import { ROOM_INFO_TRANSLATIONS } from './roomsInfo';

const ENG = {
  'messenger_v2.call.share_screen': "Share screen",
  'messenger_v2.call.ongoing': "Group call ongoing",
  'messenger_v2.call.ongoing_video': "Video call ongoing",
  'messenger_v2.call.ongoing_voice': "Voice call ongoing",
  'messenger_v2.call.more_members': "{count} more participants",
  'messenger_v2.call.mute_sound': "Turn sound off",
  'messenger_v2.call.unmute_sound': "Turn sound on",
  'messenger_v2.call.sound_off': "Sound off",
  'messenger_v2.call.live_members': "{count} currently in call",
  'messenger_v2.call.waiting_members': "Waiting for participants",
  'messenger_v2.call.joining': "Joining…",
  'messenger_v2.call.return_to_call': "Return to call",
  'messenger_v2.call.rejoin_failed': "Unable to join this call. Please try again.",
  'messenger_v2.call.stop_sharing': "Stop sharing",
  'messenger_v2.call.share_pending': "Updating screen sharing",
  'messenger_v2.call.share_unsupported': "This browser cannot share its screen. You can still view shared screens.",
  'messenger_v2.call.share_denied': "Screen sharing was cancelled or permission was denied. Your call is still connected.",
  'messenger_v2.call.share_failed': "Screen sharing could not start or stop cleanly. Please try again.",
  'messenger_v2.call.view_screen': "View {name}'s screen",
  'messenger_v2.call.expand_screen': "Expand shared screen",
  'messenger_v2.call.exit_expand_screen': "Exit expanded screen",
  'messenger_v2.pin.pin': 'Pin chat',
  'messenger_v2.pin.unpin': 'Unpin chat',
  'messenger_v2.pin.pinned': 'Pinned chat',
  'messenger_v2.pin.failed': 'Could not update chat pin. Try again.',
  'messenger_v2.self.name': '{name} (You)',
  'messenger_v2.self.subtitle': 'Message yourself',
  ...ROOM_INFO_TRANSLATIONS.ENG,
  'tabs.more': 'More',
  'header.footer.short.find_grave': 'Find grave',
  'header.footer.short.how': 'How',
  'header.footer.short.about': 'About',
  'notifications.general.title': 'Notification',
  'notifications.auth.title': 'Authentication',
  'notifications.requests.title': 'Requests',
  'notifications.gravesHub.title': 'Graves Hub',
  'notifications.graves.title': 'Graves',
  'notifications.memoryWall.title': 'Memory Wall',
  'notifications.payments.title': 'Payments',
  'notifications.settings.title': 'Settings',
  'notifications.groups.title': 'Groups',
  'notifications.sparks.title': 'Sparks',
  'notifications.messenger.title': 'Messages',
  'notifications.messages.title': 'Messages',
  'notifications.store.title': 'Store',
  'notifications.purchase.title': 'Purchase',
  'notifications.userProfile.title': 'My Light',
  'notifications.messaging.title': 'Messages',
  'messenger.header.unseen_messages': 'Messages, {count} new',
  'notifications.connectRequests.title': 'Connection Requests',
  'notifications.designSystem.title': 'Design System',
  'notifications.subscription.title': 'Subscription',
  'notifications.comments.title': 'Comments',
  'notifications.familyTree.title': 'Family Tree',
  notifications_page_title: 'Notifications',
  notifications_see_all: 'See all',
  worthy_calendar_precision_year: 'Year',
  worthy_calendar_precision_month: 'Month',
  worthy_calendar_precision_date: 'Date',
  worthy_calendar_precision_heading: 'Choose date precision',
  worthy_calendar_unset: 'No date selected',
  worthy_calendar_unset_time: 'No time selected',
  worthy_calendar_selection_value: '{iso} ({precision})',
  worthy_calendar_select_month: 'Choose month',
  worthy_calendar_select_year: 'Choose year',
  worthy_calendar_select_day: 'Choose day',
  worthy_calendar_previous: 'Previous',
  worthy_calendar_next: 'Next',
  worthy_calendar_selected_label: 'Selected:',
  worthy_calendar_valid_years: 'Valid years: {min}–{max}',
  worthy_calendar_choose_date: 'Choose date',
  worthy_calendar_choose_time: 'Choose time',
  worthy_calendar_choose_datetime: 'Choose date & time',
  worthy_calendar_close: 'Close',
  worthy_calendar_cancel: 'Cancel',
  worthy_calendar_apply: 'Apply',
  worthy_calendar_default_label: 'Event date',
  'home_page.brand_name': 'Nettgrav',
  'home_page.hero_title': 'What binds us together',
  'home_page.hero_subtitle':
    'Nettgrav brings together the people, values, and stories that shape a life. Here you can care for what matters, while life is lived and for those who come after.',
  'home_page.cta_my_light': 'Explore My Light',
  'home_page.cta_search_graves': 'Search graves',
  'home_page.cta_create_grave': 'Create a Nettgrav',
  'home_page.cta_shop_frames': 'For the anniversary',
  'home_page.chip_invite_family': 'Family',
  'home_page.chip_share_memory': 'Faith',
  'home_page.chip_light_candle': 'Hope',
  'home_page.chip_apply_frame': 'Love',
  'home_page.hero_pick_grave': 'Pick a grave',
  'home_page.hero_select_details': 'Select to view details',
  'home_page.chip_anniversary_tomorrow': 'Anniversary tomorrow',
  'home_page.hero_quote':
    'She taught us that love is something you do, not just something you feel.',
  'home_page.life_preview_label': 'My Light',
  'home_page.life_preview_title': 'What matters deserves a place',
  'home_page.life_preview_body':
    'A place for what you stand for, the people around you, and what you want to pass on.',
  'home_page.life_preview_values_title': 'What I stand for',
  'home_page.life_preview_values_body': 'Values and words that say something about you.',
  'home_page.life_preview_compass_title': 'My compass',
  'home_page.life_preview_compass_body': 'The direction you want to hold on to.',
  'home_page.life_preview_people_title': 'My people',
  'home_page.life_preview_people_body': 'The relationships that shape your life.',
  'home_page.life_preview_after_title': 'After me',
  'home_page.life_preview_after_body': 'What you want others to know one day.',
  'home_page.life_preview_cta': 'See how My Light works',
  'home_page.btn_light_candle': 'See the candles',
  'home_page.btn_add_memory': 'Write a few words',
  'home_page.btn_apply_frame': 'Life circles',
  'home_page.btn_invite_family': 'Invite family',
  'home_page.nearby_btn_light_candle': 'Visit the grave',
  'home_page.nearby_btn_add_memory': 'Write a few words',
  'home_page.nearby_btn_apply_frame': 'Life circles',
  'home_page.nearby_btn_invite_family': 'Add a photo',
  'home_page.graves_hub_title': 'A resting place that is always close',
  'home_page.graves_hub_subtitle':
    'Nettgrav is free for every family. Visit the resting place whenever you wish, and preserve photos, stories, and memories together.',
  'home_page.people_care_for': 'People I care for',
  'home_page.people_add': '+ Add',
  'home_page.placeholder_name': 'Ingeborg Larsen',
  'home_page.tag_new_memory': 'New memory',
  'home_page.pick_grave': 'Pick a grave',
  'home_page.select_to_view': 'Select to view details',
  'home_page.birthday_soon': 'Birthday soon',
  'home_page.recent_updates': 'Recent updates',
  'home_page.updates_placeholder': 'Updates or reminders will appear here.',
  'home_page.memorial_title': 'Every person has a story.',
  'home_page.memorial_subtitle':
    'On the grave wall, family and friends can gather photos, words, and experiences. More people can help tell the story of the person the grave represents.',
  'home_page.select_grave': 'Select a grave',
  'home_page.add_guardian': 'Add guardian',
  'home_page.invite_family_contribute': 'Invite family to contribute',
  'home_page.share_memory_prompt': 'Share a photo, write a few words, or show that you were here.',
  'home_page.btn_share_memory': 'Write on the grave wall',
  'home_page.from_family': 'From family',
  'home_page.family_quote':
    '“She always kept the candles lit in winter, so the house felt warm when we came inside.”',
  'home_page.added_days_ago': 'Added 3 days ago',
  'home_page.explore_memorial': 'Explore {name}',
  'home_page.this_memorial': 'this memorial',
  'home_page.social_title': 'Built for life between people',
  'home_page.social_subtitle':
    'Nettgrav brings conversations, communities, and what we want to share together in one place. For the relationships we build while we live, and the closeness we preserve throughout life.',
  'home_page.social_chat_title': 'Conversations that keep people close',
  'home_page.social_chat_body':
    'Write, call, or meet on video. Talk privately one to one, or bring family and friends together in a group.',
  'home_page.social_chat_security': 'End-to-end encrypted with hybrid post-quantum protection.',
  'home_page.social_chat_cta': 'Open Chat',
  'home_page.social_rooms_title': 'Rooms for what we share',
  'home_page.social_rooms_body':
    'Meet people with experiences, interests, or questions that touch on something you share.',
  'home_page.social_rooms_cta': 'Explore Rooms',
  'home_page.social_sparks_title': 'Create Spark',
  'home_page.social_sparks_body':
    'Share a thought, an experience, or a question. Something small to you may mean a great deal to someone else.',
  'home_page.social_sparks_cta': 'Explore Sparks',
  'home_page.store_title': 'For someone on your mind',
  'home_page.store_subtitle':
    'On Nettgrav, candles and circles can give your thoughts a personal expression.',
  'home_page.store_description':
    'Choose a candle for an important date, or a circle that says something about the person.',
  'home_page.store_quote':
    'A Nettgrav holds more than names and dates. It can also tell us about the person, their relationships, and what still matters.',
  'home_page.store_frames': 'Circles for life',
  'home_page.store_candles': 'Candles for moments and anniversaries',
  'home_page.store_view': 'View',
  'home_page.store_visit': 'Explore Presence',
  'home_page.reminders_title': 'Important dates, in your own way',
  'home_page.reminders_subtitle':
    'Nettgrav gathers the important dates of those you care for and helps you be present when it feels right.',
  'home_page.reminder_label_tomorrow': 'Tomorrow',
  'home_page.reminder_title_birthday': 'Ingeborg’s birthday',
  'home_page.reminder_body_birthday': 'A moment to remember, in your own way.',
  'home_page.reminder_label_next_week': 'Next week',
  'home_page.reminder_title_visit': 'Time for a visit',
  'home_page.reminder_body_visit': 'When it feels right to be present.',
  'home_page.reminder_action_visit': 'Adjust the time to suit you',
  'home_page.reminder_label_new': 'New',
  'home_page.reminder_title_memory': 'New photo from Line',
  'home_page.reminder_body_memory':
    'A new photo has been shared. When it is added to the grave, it becomes part of the story that lasts.',
  'home_page.reminder_action_memory': 'View memory',
  'home_page.family_title': 'We belong together across generations',
  'home_page.family_subtitle':
    'See the relationships between people, preserve your family history, and give the next generation a place to find it.',
  'home_page.family_grandparents': 'Grandparents',
  'home_page.family_linked_graves': 'In connection',
  'home_page.family_children': 'Children',
  'home_page.family_living': 'Living & remembered',
  'home_page.family_open': 'See the family connection',
  'home_page.family_beta': 'Beta',
  'home_page.why_title': 'A person is more than a name on a grave',
  'home_page.why_subtitle':
    'Nettgrav gives memories, relationships, and stories a place to live on. Free for every family.',
  'home_page.why_secure_title': 'For every family',
  'home_page.why_secure_body':
    'Everyone should be able to give those they have lost a meaningful resting place, regardless of finances or location.',
  'home_page.why_secure_item1': '',
  'home_page.why_secure_item2': '',
  'home_page.why_secure_item3': '',
  'home_page.why_connected_title': 'Built for closeness',
  'home_page.why_connected_body':
    'Preserve memories together, stay connected with people, and find community when you need it.',
  'home_page.why_connected_item1': '',
  'home_page.why_connected_item2': '',
  'home_page.why_connected_item3': '',
  'home_page.why_tools_title': 'The story remains',
  'home_page.why_tools_body':
    'What you gather today gives future generations a place to find the people and stories that came before them.',
  'home_page.why_tools_item1': '',
  'home_page.why_tools_item2': '',
  'home_page.why_tools_item3': '',
  'home_page.why_footer_quote':
    '“We work towards our own irrelevance — and that is the most meaningful thing we know to do.”',
  'home_page.why_footer_source': 'End of Time Center — research on life, death, and what endures',
  worthy_calendar_default_time_label: 'Event time',
  worthy_calendar_default_datetime_label: 'Event date & time',
  worthy_calendar_required: 'Please select a date',
  worthy_calendar_required_time: 'Please select a time',
  worthy_calendar_required_datetime: 'Please select a date and time',
  worthy_calendar_time_heading: 'Choose time',
  error_boundary_title: 'We updated Nettgrav',
  error_boundary_subtitle:
    'Reload the page to continue. If it keeps happening, try again in a moment.',
  error_boundary_reload: 'Reload now',
  error_boundary_show_details: 'Show details',
  error_boundary_hide_details: 'Hide details',
  auth_mobileNumber: 'Mobile Number',
  auth_password: 'Password',
  auth_passwordPlaceholder: 'Enter the password',
  auth_show_password: 'Show password',
  auth_hide_password: 'Hide password',
  auth_rememberMe: 'Remember me on this device',
  sign_in: 'Sign in',
  auth_login: 'Enter',
  auth_get_newsletr: `Receive news and updates from Nettgrav`,
  auth_notRegistered: `Don’t have an account? `,
  auth_alreadyRegistered: 'Already have an account? ',
  auth_login_here: 'Log in',
  register: 'Create account',
  auth_register: 'Create account',
  'family_tree_guest.eyebrow': 'Family tree',
  'family_tree_guest.title': 'See how the family is connected',
  'family_tree_guest.intro':
    'The family tree gives a shared place to gather people, graves, and relationships. This makes it easier to understand connections, preserve stories, and carry them forward.',
  'family_tree_guest.primary_cta': 'Sign in to continue',
  'family_tree_guest.secondary_cta': 'Create account',
  'family_tree_guest.note': 'Sign in to begin building your family tree.',
  'family_tree_guest.panel_label': 'What you can do',
  'family_tree_guest.feature_1':
    'Connect people, and see how relationships also emerge along the way.',
  'family_tree_guest.feature_2': 'Discover talents and senses that repeat across generations.',
  'family_tree_guest.feature_3':
    'Family members can confirm what they recognize, so the insight becomes clearer and more grounded over time.',
  'family_tree_guest.feature_1_title': 'Build and let the tree grow',
  'family_tree_guest.feature_2_title': 'Talents and senses in the family',
  'family_tree_guest.feature_3_title': 'Confirmed by the family',
  'family_tree_guest.preview_person_name': 'Elias Johansen',
  'family_tree_guest.preview_person_meta': 'Born 1984 • connected to family line',
  'family_tree_guest.preview_relation_1': 'Brother',
  'family_tree_guest.preview_relation_2': 'Parent',
  'family_tree_guest.preview_grave_name': 'Lorense Johansen',
  'family_tree_guest.preview_grave_meta': 'Grave page linked to the same family',
  'family_tree_guest.preview_grave_body':
    'See how people and graves are connected in the family over time.',
  'family_tree_guest.preview_tree_root': 'Elias Johansen',
  'family_tree_guest.preview_tree_root_meta': 'You can start from a person and build outward',
  'family_tree_guest.preview_tree_left': 'Liv Johansen',
  'family_tree_guest.preview_tree_left_meta': 'Mother',
  'family_tree_guest.preview_tree_right': 'Oskar Johansen',
  'family_tree_guest.preview_tree_right_meta': 'Father',
  'family_tree_guest.detail_title': 'What you can do in the family tree',
  'family_tree_guest.detail_intro':
    'The family tree brings people, graves, and family lines together.',
  'family_tree_guest.preview_status': 'Talent recognized',
  'family_tree_guest.preview_hint': 'Maren recognized Delegation in Elias Johansen.',
  auth_forgotPassword: 'Need help with your password?',
  login_phone_verification_message:
    'Signing in by phone requires a verified email address on the account.',
  login_phone_email_verification_message:
    'Verify the email address on your account before signing in by phone. Sign in with your email address to continue.',
  login_send_verification_code: 'Send verification email',
  login_phone_code_sent: 'Verification email sent.',
  login_phone_code_verified: 'Email address verified. Signing you in...',
  auth_too_many_attempts: 'Too many sign-in attempts. Wait a moment before trying again.',
  phone_verification_uses_email: 'Phone verification is handled by email.',
  auth_welcome: 'Welcome back',
  auth_toNettgrav: 'to nettgrav.com',
  auth_enterPhoneNumber: 'Enter your phone number',
  auth_emailOrPhone_label: 'Email or phone number',
  auth_emailOrPhone_placeholder: 'Enter email or phone number',
  auth_emailOrPhone_required: 'Add email or phone number.',
  auth_phone_hint: 'Type a local number or use an international format like +47 45007009.',
  auth_man: 'Male',
  auth_woman: 'Female',
  auth_other: 'Other',
  auth_acceptConditions: 'I accept to receive SMS from Nettgrav and I accept',
  auth_termsAndCondition: 'terms and conditions',
  auth_next: 'Next',
  auth_receivedSMS: 'You will now receive a message',
  auth_otpCode: 'Enter the OTP code',
  auth_received: 'Have you not received a one-time code?',
  auth_newOtp: 'You can send a new one-time code in 00:',
  auth_sendNew: 'Send new',
  auth_confirm: 'Confirm',
  confirm: 'Confirm',
  auth_passwordSentTo: 'The password was sent to:',
  auth_yourName: 'Your name',
  auth_enterFullName: 'Enter your name',
  auth_enterPasswordAgain: 'Enter password again',
  auth_passwordMessage: 'Use at least 7 characters and 3 of the 4 categories:',
  auth_capitalLetter: '⚙︎ Capital letter',
  auth_smallLetters: '⚙︎ Small letters',
  auth_digits: '⚙︎ Digits',
  auth_characters: '⚙︎ Non-alphanumeric characters',
  auth_signupInvitation: 'You were invited to the conscious subscription from',
  auth_resetPassword: 'Reset password',
  auth_resetPasswordSMS: 'A one-time code is sent to your mobile phone',
  auth_back: 'Back',
  auth_send: 'Send',
  auth_restOtp: 'Enter the one-time code sent to {code}{phoneNumber}',
  auth_code: 'Enter the code',
  auth_confirmPassword: 'Confirm new password',
  auth_newPassword: 'New password',
  auth_notSame: 'The passwords are not the same',
  auth_save: 'Save',
  'gravesHub.inviteFamily.title': 'Invite family to help care for the grave',
  'gravesHub.inviteFamily.submit': 'Send invitation',
  'gravesHub.inviteFamily.success':
    'Invitation sent to {email}. They can now help care for the grave.',
  'gravesHub.inviteFamily.error': 'Could not send the invitation. Please try again.',
  'gravesHub.inviteFamily.loading': 'Please wait while we load the page.',
  settings_profile: 'Profile',
  settings_personalInformation: 'Name and info',
  settings_payments: 'Payments',
  settings_paymentDate: 'Date',
  settings_paymentStatus: 'Status',
  settings_paymentMethod: 'Payment Method',
  settings_paymentAmount: 'Amount',
  settings_emptyPayments: 'There are currently no payments available',
  settings_subscription: 'Subscription',
  settings_members: 'Family and friends',
  settings_giftInvitations: 'Invite with a gift',
  settings_notifications: 'Notifications',
  settings_title: 'Settings',
  settings_back_to_menu: 'Back to settings',
  settings_load_error_title: 'Could not load settings',
  settings_load_error_body: 'Check your connection and try again.',
  settings_notifications_load_error_title: 'Could not load notifications',
  settings_notifications_load_error_body: 'Your notification choices were not changed. Try again.',
  settings_password_updated_success: 'Your new password has been saved.',
  settings_password_invalid_error: 'The password could not be changed. Check the information.',
  account_deletion_requested_success: 'Your account deletion request has been registered.',
  account_deletion_cancelled_success: 'Your account deletion has been cancelled.',
  account_deletion_update_error: 'Could not update the account deletion. Try again.',
  settings_account_information: 'Account settings',
  settings_enter_verification_code: 'Enter verification code',
  settings_verification_code_invalid: 'Code is not correct',
  settings_inventory: 'My collection',
  inventory_section_subtitle: 'End of Time Care in practice',
  inventory_empty_title: 'Add products from the store.',
  inventory_empty_description: 'Your inventory can be used on any grave.',
  inventory_purchase_item: 'Purchase Item',
  inventory_purchase_button: 'Go to store',
  settings_contact: 'Contact Nettgrav',
  settings_password: 'Password',
  settings_edit: 'Edit',
  my_light_remove_relation: 'Remove relation',
  settings_fullName: 'Name',
  settings_gender: 'Gender',
  settings_occupation: 'Occupation',
  settings_birthday: 'Day of birth',
  settings_email: 'E-mail address',
  settings_telephoneNumber: 'Phone number',
  settings_address: 'Address',
  settings_language: 'Language',
  settings_currency: 'Currency',
  settings_timeZone: 'Time zone',
  settings_invalidEmail: 'Invalid email address',
  settings_cancel: 'Cancel',
  // Life event theme names
  theme_name_familie: 'Family',
  theme_name_skole: 'School',
  theme_name_arbeid: 'Work',
  theme_name_kjaerlighet: 'Love',
  theme_name_minne: 'Memory',
  theme_name_natur: 'Nature',
  theme_name_tro: 'Faith/Hope',
  theme_name_fellesskap: 'Community',
  theme_name_annet: 'Other',
  settings_currentPassword: 'Current password',
  settings_newPassword: 'Enter new password',
  settings_retype: 'Retype the password',
  confirm_password: 'Confirm password',
  settings_billingMethod: 'Payment method',
  settings_cancelSubscription: 'Cancel subscription',
  settings_cancel_mySubscription: 'Yes, cancel my subscription',
  settings_month: 'month',
  cancelSubscription_message:
    'You are about to end the Nettgrav {name} plan. You can still stay here on the free plan, and restart anytime.',
  reactivateSubscription_message:
    'You are about to reactivate your subscription to the Nettgrav {name} plan. This will restore full access to all the features associated with this plan.',
  not_now: 'not now',
  reactivate: 'Yes, reactivate my subscription',
  settings_nextDue: 'Next payment due',
  settings_paymentMethods: 'Payment Methods',
  settings_nextBilling: 'Next automatic invoicing is',
  settings_mangeMethods: 'View and manage your payment method',
  settings_emptyMethods: 'There are no payment methods added yet',
  settings_vippsHeading: `Vipp's payment and agreements will be here soon`,
  settings_manageVipps: 'To view and manage your agreements',
  settings_cardEnd: 'ending in',
  settings_remove: 'Remove',
  settings_stop: 'stope',
  relation_title_for_connection: 'What is the relation from {firstGrave} to {secondGrave}?',
  relation_direction_title_for_connection:
    'What is the relation from {secondGrave} to {firstGrave}?',
  settings_vippsAgreement: 'Vipps agreement',
  view_manage_agreements: 'View and manage your agreement',
  empty_agreements: 'No Vipps agreements were found',
  settings_amount: '{amount}',
  settings_subscriptionHeading: 'Subscription management',
  settings_subscriptionStatus: 'Status',
  settings_length: 'Length',
  settings_nextBillingDate: 'Next billing date',
  settings_endDate: 'End date',
  settings_reactivateSubscription: 'Reactivate subscription',
  settings_freeSubscriptionHeading: 'Get started for free.',
  months: 'months',
  year: 'year',
  month: 'month',
  years: 'years',
  saved: 'Saved',
  saved_message: '{name} has been saved successfully',
  settings_upgrade: 'Upgrade plan',
  settings_subDescription: 'For a meaningful life',
  settings_for: 'for',
  settings_paymentInfo: 'Payment information',
  settings_cardNumber: 'Card number',
  settings_billingInfo: 'Billing information',
  settings_name: 'Name',
  settings_billingEmail: 'Email',
  settings_billingCountry: 'Country',
  settings_postCode: 'Postal code',
  settings_changePlan: 'Change plan',
  change_plan: 'change plan',
  change: 'change',
  change_members: 'change members',
  settings_noSubscription: 'You do not have an active subscription yet.',
  settings_clickHere: 'click here',
  settings_getSubscription: 'Get subscription',
  settings_subscriptionPrice: 'Price per year',
  settings_subscriptionLengths: 'Permitted lengths',
  settings_subscriptionYears: 'Years purchased',
  settings_subscriptionFrameId: 'Frame ID',
  open_menu: 'Open menu',
  settings_memberHeading: 'Invitations',
  settings_receivedMembership: '(Invitations you have received)',
  settings_emptyMembership: 'No invitations right now.',
  settings_subscribedPlan:
    'Your subscription has been successfully activated. You can view or manage your ',
  settings_updatePlan:
    'Your subscription has been successfully updated. You can view or manage your ',
  settings_downgradePlan:
    'Your subscription has been successfully downgraded. You can view or manage your ',
  settings_addedMember:
    'New members have been successfully added to your current plan. You can view or manage your ',
  payment_progress: 'Payment in progress. please wait',
  something_wrong: 'Something went wrong. please try again later',
  add_validNumber: 'Please enter a valid phone number',
  select_planMessage:
    'To continue, select a plan that best suits your needs. Our plans are designed to offer flexibility and great features. Make sure you choose the one that matches your requirements.',
  settings_memberPage: 'member page',
  settings_your: 'your.',
  settings_enable: 'plan enabled',
  free: 'Free',
  conscious: 'Conscious',
  consciousPlus: 'Conscious plus',
  settings_membershipOn: '- membership on',
  settings_modalSubheading: 'Greatest of all is love',
  settings_modalLink: 'Thank you for being here',
  settings_memberSubheading: 'Your Family plan.',
  settings_emptyMembers: 'You have no subscription members',
  settings_memberName: `{name}'s Family`,
  settings_memberLength: '{length} members',
  settings_administrator: 'Administrator',
  settings_showMembers: 'See members',
  settings_familyMembers: 'Family members',
  settings_you: 'You',
  settings_connect: 'connect',
  settings_setRelation: 'Set relationship',
  settings_selectedRelation: 'Select relationship',
  settings_giftHeading: `Give a membership to someone you care about.`,
  settings_giftFreeSubscription: `You have a free account. Upgrade to access everything and invite more people.`,
  settings_seeSubscriptions: 'Upgrade',
  settings_youHave: 'You have {count} ',
  settings_inviteAgain: 'invitations left.',
  settings_addMore: 'to add more memberships to your plan',
  error_trigger_title: 'Error Boundary Test',
  error_trigger_subtitle:
    'Click the button to trigger a render error and verify the global error boundary.',
  error_trigger_button: 'Trigger error',
  settings_addMember: 'Add member',
  settings_invitedMember: 'Invited members',
  settings_emptyGiftMembers: 'No unanswered invitations',
  settings_inviteTo: 'Click here to invite to your family subscription',
  settings_pendingSubscription: 'Your subscription is currently {status}.',
  settings_notificationsSubheading: 'Choose what you want to receive from us.',
  settings_notificationsTitle: 'Notification settings',
  settings_preferenceText: 'Notifications about conversations and direct messages.',
  settings_reminders: 'Reminders',
  settings_remindersText: 'Anniversaries and quiet reminders.',
  settings_anniversary_marking: 'I want commemorations on anniversaries',
  settings_anniversary_in_app: 'Show commemorations in Nettgrav',
  settings_anniversary_email: 'Also send me email',
  settings_genealText: 'News and information from Nettgrav.',
  settings_textMessage: 'Text messages',
  settings_general: 'General updates',
  delete: 'Delete',
  settings_goToAgreements: 'Click here',
  settings_shareLink: 'Copy and share your Nettgrav.no membership invitation',
  grave_invitation_shareLink: 'Copy and share your grave invitation link',
  settings_copyToClipboard: 'link copied to clipboard',
  discard_subheading: 'You can keep editing, or close for now.',
  no: 'No',
  yes: 'Yes',
  invitation: 'Invitation',
  information: 'Information',
  interests: 'Interests',
  note: 'Note',
  relative: 'Family',
  uploadingImages: 'uploading images',
  uploading: 'Uploading',
  lifeEvent: 'Life event',
  Workplace: 'Workplace',
  delete_modalHeading: 'Confirm that you want to remove',
  picture: 'picture',
  paymentMethod: 'Payment method',
  vippsAgreement: 'Vipps agreement',
  settings_complete_subscription: 'Complete Subscription',
  pending_message:
    'Your subscription is incomplete. Complete your subscription to continue accessing conscious features.',
  pending_title: 'Your payment agreement is pending',
  stopped_title: 'Your payment agreement was stopped',
  stopped_message:
    'Your subscription is incomplete because the payment agreement was cancelled. Complete your subscription to continue accessing conscious features.',
  expired_title: 'Your payment agreement has expired',
  expired_message:
    'Your subscription is incomplete because the payment agreement has expired. Complete your subscription to continue accessing conscious features.',
  complete_setup: 'complete setup',
  cancelled_title: 'Your subscription is cancelled',
  cancelled_message:
    'Your subscription has been cancelled. You may reactivate your subscription before {period_end_date} to continue access conscious features. After this date, you subscription will be downgraded to free plan.',
  activeStopped_title: 'Your payment agreement has ended',
  activeStopped_message: `Your subscription’s payment method has expired. Please renew payment method to continue access conscious features. If the problem persists, the subscription will be downgraded to the free plan after the current billing cycle.`,
  renew_Agreement: 'Renew payment agreement',
  add_card: 'Add payment method',
  Reactivate: 'Reactivate subscription',
  active_title: 'Your subscription will be activated soon',
  active_message: `Your subscription is being processed and will be activated in a few minutes. Thank you for your patience and access to conscious services will be unlocked shortly`,
  activeExpired_title: 'Your payment agreement has expired',
  activeExpired_message: `Your subscription’s payment method has expired. Please renew or establish a new payment agreement to continue access conscious features.`,
  notValid_title: 'Payment method required',
  notValid_message: `It looks like your payment method is missing or no longer valid. Please update your payment details to continue uninterrupted service.`,
  consciousness: 'About us',
  about_us: 'About Nettgrav',
  team: 'Our story',
  careers: 'Join our team',
  features: 'About the grave',
  available_sustainable: 'Always available',
  maintenance_free_grave: 'Easy to use',
  memory_album: 'People',
  value_archive: 'Qualities and stories',
  memorial_wall: 'Gravevisits that lasts',
  life_archive: 'Life stories',
  anniversary_calendar: 'Important dates calendar',
  Family_values: 'Family tree (coming soon)',
  resources: 'Help and resources',
  find_grave: 'Search',
  blog: 'Blog',
  help_center: 'Questions and answers',
  contact: 'Contact',
  contact_us: 'Contact us',
  business_inquiries: 'Partner with us',
  feedback: 'Share your thoughts',
  basic_information: 'Basic information',
  interest: 'Interest',
  notes: 'Notes',
  passion: 'Passion',
  relation: 'Relationship',
  life_event: 'Life event',
  subscription_invitation: 'Subscription invitation',
  cookies_banner_text:
    'We use necessary storage and our own traffic measurement to operate and improve Nettgrav.',
  cookies_more: 'Learn more',
  cookies_accept: 'Accept',
  rooms_landing_eyebrow: 'Rooms',
  rooms_landing_title: 'A place to gather around what matters.',
  rooms_landing_lead:
    'A room brings people together around what matters. Not a group. Not a thread. A room where you set the tone, invite who you want and create a community around something that truly matters to you.',
  rooms_landing_coming_soon: 'Coming soon to Nettgrav.',
  rooms_landing_preview_label: 'Preview',
  rooms_landing_panel_quote: 'No algorithm decides who sees what. You do.',
  rooms_landing_open_rooms: 'Open rooms',
  rooms_landing_closed_rooms: 'Closed rooms',
  rooms_landing_private_rooms: 'Private rooms',
  rooms_landing_what_title: 'What is a room?',
  rooms_landing_what_body_1:
    'A room is a community you create around a thought, an experience, a grief or a joy. You decide who is welcome, what the room is about and how it stays safe.',
  rooms_landing_what_body_2:
    'Some rooms are open. Everyone can read, but you need to join to participate. Others are closed, where you approve who gets in. And some are private, only for the people you invite yourself.',
  rooms_landing_who_title: 'Who can create a room?',
  rooms_landing_who_body: 'Anyone with a Nettgrav account can create a room.',
  rooms_landing_use_case_1:
    'Someone who has lost a loved one and wants to gather the people who knew them.',
  rooms_landing_use_case_2: 'A nurse who wants to offer relatives a safe place.',
  rooms_landing_use_case_3: 'A psychologist or facilitator running a grief group.',
  rooms_landing_use_case_4: 'A friend who wants to keep a memorial room alive over time.',
  rooms_landing_who_question: 'The only thing we ask is: how will you keep the room safe?',
  rooms_landing_support_title: 'Support the room you care about',
  rooms_landing_support_body_1:
    'Some rooms deserve to live for a long time. If you host a room that matters to others, you can open it for support. Those who find value there can contribute, for example, NOK 99 per month.',
  rooms_landing_support_body_2:
    'Support is a monthly subscription. Nettgrav keeps 15%, and payment provider fees are deducted before the remainder is paid to you.',
  rooms_landing_directions_title: 'Directions',
  rooms_landing_directions_body:
    'Every room belongs to a direction, a category that helps people find what is relevant to them. You choose the direction when you create the room, and your room can become visible to those searching for exactly what you offer.',
  rooms_landing_direction_grief: 'Grief and loss',
  rooms_landing_direction_relationships: 'Relationships',
  rooms_landing_direction_life_choices: 'Life choices',
  rooms_landing_direction_health: 'Health',
  rooms_landing_direction_eot: 'End of Time Consciousness',
  rooms_landing_cta_eyebrow: 'Early access',
  rooms_landing_cta_title: 'Rooms are on their way into Nettgrav.',
  rooms_landing_cta_body:
    'The feature is not fully launched yet. Existing rooms are still available for those who already use them.',
  rooms_landing_cta_primary: 'Create a room',
  rooms_landing_cta_secondary: 'Read terms',
  find_grave_norway: 'Find a grave',
  find_grave_value_statement: 'Find where someone is buried, and visit the grave online.',
  search_grave: 'Search for a name',
  search_recent_title: 'Recent',
  search_recent_clear: 'Clear',
  search_recent_remove: 'Remove',
  search_suggestions_title: 'Suggestions',
  search_searching: 'Searching…',
  search_no_results: 'No results',
  or: 'or',
  find_grave_create_cta: 'add a grave',
  create_netgrave: 'create a Nettgrav',
  netgrave: 'Nettgrav',
  visit: 'Visit',
  relation_summary_self: 'I am {relationLower}',
  relation_summary_target: '{name} is my {relationLower}',
  relation_summary_fallback_person: 'this person',
  visit_grave: 'Find a person',
  wish: '',
  find_grave_practical_reason:
    'Here you can find graves in {municipalityName} and stay close to those who matter to you.',
  find_grave_cemetery_practical_reason:
    '{cemeteryName} is located in {municipalityName}. Here you can find graves and see who is buried in the cemetery. Search by name to find the right grave site and visit the grave online.',
  find_grave_support_statement: 'Small actions create room for closeness over time.',
  find_grave_guest_cta_title: 'When you find the right grave',
  find_grave_guest_cta_body: 'you can connect to it, leave a sign, and follow along over time.',
  find_grave_guest_cta_button: 'Care for a grave',
  find_grave_search_heading: 'Search by name',
  find_grave_search_description: 'Start with a name to find the right grave.',
  find_grave_name_placeholder: 'Enter a name, e.g. John Smith',
  second_section_description: 'Start with a name, or explore municipality and cemetery.',
  find_grave_start_hint: 'Enter a name',
  find_grave_faq_title: 'Common questions',
  find_grave_faq_question_1: 'How do I find a grave?',
  find_grave_faq_answer_1:
    'Search by name. You can also use municipality or cemetery to narrow the results.',
  find_grave_faq_question_2: 'Can I search by municipality or cemetery?',
  find_grave_faq_answer_2:
    'Yes. Enter a municipality or cemetery in search, or continue from the overview lists.',
  find_grave_faq_question_3: 'What if I cannot find the person?',
  find_grave_faq_answer_3:
    'Try another spelling or fewer words. You can also create a Nettgrav if one does not exist yet.',
  memorial_plaque: 'Municipalities',
  memorial_plaque_description: 'Explore municipalities and their local burial grounds.',
  archive: 'Cemeteries',
  archive_description: 'See which cemeteries are connected to each municipality.',
  memory_album_description:
    'Discover people represented in the cemetery through photos and shared stories.',
  find_municipality: 'Graves by municipality',
  search_municipality: 'Search for municipality',
  find_grave_municipality_cta: 'See cemeteries',
  it_is: 'There are',
  find_grave_count: '{count}',
  municipality_description:
    "Search across {count} municipalities to find the grave you're looking for.",
  no_results: 'No results found for',
  find_cemetery: 'Choose a cemetery in {municipalityName}',
  find_cemetery_generic: 'Find a grave across these cemeteries',
  search_cemetery: 'Search for cemetery',
  cemetery_description:
    'cemeteries in {municipalityName}. Explore the cemeteries to find the people they represent.',
  grave_description:
    'people represented here. Search by name to find the right grave site and visit the grave online.',
  goto_grave: 'view grave',
  payment_due_message:
    'Your subscription is active. Your payment is being processed. Vipps will handle the charge.',
  payment_due_title: 'Your subscription is active',
  find_grave_image_title: 'The grave gives a different perspective on our life. On your',
  find_grave_text: 'do you have a separate wall where your contacts can send you questions.',
  life_page: 'Life page',
  the_life_page: 'My Light',
  first_description: 'Follow your Spark. Here, you can share your own spark and respond to others.',
  your_graves: 'Those you carry with you',
  second_description: 'The people you have connected to are linked to your Light.',
  update: 'Your relations',
  third_description: 'Your closest ones become part of your Light.',
  find_grave_last_text:
    "Welcome to Nettgrav A social network for life's real challenges – where we start with meaningful, accessible and maintenance-free graves, for those of us who will continue living. We also hope to experience your inner spark – your experiences from life that you find the courage to share with others. The world needs to hear your words and thoughts.",
  plans_page_heading: 'A conscious choice for a meaningful life',
  plans_page_subheading: `Let go of the past, embrace the journey forward with the most valuable grave for your loved ones.`,
  per_user: 'per member',
  current_members: 'Current members',
  added_members: 'Number of members to be added',
  removed_members: 'Number of members to be removed',
  view_current_members: 'View current members',
  total_members: 'Members after the change',
  plan_price: 'Plan price',
  increment_text: 'Choose the number of memberships you want for you and your family',
  free_description: 'For those who want to search for and visit graves at no cost.',
  conscious_description: `With Conscious membership, you become a verified supporter of End Of Time perspectives.`,
  consciousPlus_description: `Access as Conscious, with extra emphasis on the ethics of the grave. Price: NOK 500 per year`,
  total_user_count: ' For {subscriptionTotalCount} family members, the total payment is:',
  per_month: 'per month',
  current_plan: 'Current plan',
  got_started: 'Got started',
  free_feature_heading: 'All features included in the free plan',
  conscious_feature_heading: 'All features included in the free plan, plus additional ones',
  conscious_plus_feature_heading:
    'All features included in the conscious plan, plus additional ones',
  // Adjust the feature texts according to the requirements.//
  feature_memory_album: 'Memory album',
  feature_purposes: 'Purposes',
  feature_end_of_time: 'End Of Time Coin',
  feature_family_tree: 'Family tree',
  feature_testament: 'Testament',
  feature_groups: 'Groups (Communities)',
  feature_Shop: 'Presence',
  feature_Sparks: 'Sparks',
  feature_life_page: 'My light',
  feature_search_grave: 'Search for graves',
  feature_create_grave: 'Create Spark',
  question_answer: 'Questions and answers',
  feature_life_archive: 'Life archive',
  feature_anniversary_calendar: 'Memorial Day calendar',
  feature_memory_wall: 'Memory wall',
  feature_value_archive: 'Qualities',
  benefits_1_title: 'Love continues',
  benefits_1_description:
    'Every conscious grave is a place where love lives on – with dignity, warmth, and meaning.',
  benefits_2_title: 'Supports what saves lives',
  benefits_2_description:
    'Your contribution goes directly to research and development to understand and overcome what is killing us.',
  benefits_3_title: 'A meaningful grave',
  benefits_3_description:
    'From flowers and candles – to real action. Conscious graves help shape a better future.',
  benefits_4_title: 'Toward a world without unwanted death',
  benefits_4_description:
    'Together we create hope. Every grave brings us one step closer to a safer and more whole world.',
  benefits_title: 'Good reasons to choose Conscious on Nettgrav',
  faqs_1_question: 'What payment methods do you accept?',
  faqs_1_answer: 'We accept credit/debit cards (Visa, Mastercard) and Vipps',
  faqs_2_question: 'Are there any additional fees I should be aware of?',
  faqs_2_answer:
    'There are no hidden fees. Here you can gather all graves and burials without extra fees',
  faqs_3_question: 'How do I update my payment details?',
  faqs_3_answer:
    'To update your payment details, please go to your account settings and navigate to the subscription tab',
  faqs_4_question: 'What happens after the payment is completed?',
  faqs_4_answer:
    'Once the payment is completed, you will receive a notification from Nettgrav, indicating that your membership is activated.',
  faqs_5_question: 'What is the difference between Free and Conscious?',
  faqs_5_answer:
    'Free subscription provides five searches and five memories. There is also a limitation on the size of media added to graves. With Conscious, you have unlimited access to all features and access to new features that are added.',
  faqs_6_question: 'Who is Conscious plan for?',
  faqs_6_answer:
    'Conscious is for those who want the most out of life. It empowers you to let go of old assumptions and rituals. With Conscious, you always have access to features that support your journey in life – starting with the most meaningful grave for your loved ones and our promise to always guide you to where love is.',
  update_modal_change_plan: 'Change {name} plan',
  waite_for_validation: 'Please wait while checking for subscription validation',
  add_members: 'Add members',
  remove_members: 'Remove members',
  allowed_members: 'Allowed number of members',
  how_many_add: 'How many members do you want to add?',
  how_many_remove: 'How many members do you want to remove?',
  not_remove_all: 'Keep at least one member.',
  updated_price: 'Updated price after the changes',
  remaining_members: 'Total remaining members',
  total_price: 'Total price',
  extra_user: 'For additional {subscriptionTotalCount} family members is an additional payment',
  process_payment: 'Proceed to payment',
  continue: 'Continue',
  subscription_members: 'Subscription members',
  remove_subscription_members: 'Remove subscription members by clicking remove',
  subscription_invitation_members: 'Invitations to subscriptions',
  remove_invitation_members: 'Remove the subscription invitation by clicking remove',
  downgrade_plan: 'Downgrade plan',
  upgrade_plan: 'Upgrade plan',
  downgrade_message:
    'Disable all subscription members and invitations to continue downgrading your subscription',
  upgrade_message: 'Remove all subscription members and invitations to upgrade plan',
  close_message: 'You can now close and continue further',
  close: 'Close',
  active_members: 'Active Members in Your Subscription',
  active_members_message:
    'To proceed, please deactivate one or more members from your subscription.',
  active_members_empty_message: 'No active members found in your subscription',
  active_invitations: 'Pending Invitations for Your Subscription',
  active_invitations_message: 'Please revoke the member invitations to proceed.',
  active_invitations_empty_message: 'No outstanding invitations linked to your subscription',
  check_out: 'Check out',
  select_payment_method: 'Select payment method',
  order_details: 'Order details',
  subscription_number: 'Subscription count',
  taxes: 'Taxes',
  total: 'Total amount to pay:',
  sub_total: 'Regular membership price:',
  discount_title: 'Billing frequency:',
  subscription_length: 'Plan duration',
  discount: 'Discount for multiple members:',
  renewal: 'The subscription renews automatically.',
  renewal_details:
    'Renewal occurs based on the selected payment frequency. You can cancel at any time.',
  payment_page_terms: 'By selecting "Next" or "Subscribe" you agree to our',
  terms_conditions: 'Terms of Service.',
  terms_conditions_page_title: 'Terms & Conditions',
  terms_conditions_page_subtitle: 'General terms of use and privacy for nettgrav.com',
  terms_conditions_section1_title: '1. General',
  terms_conditions_section1_body:
    'nettgrav.com is a digital gathering place where families and friends can stay close to the person they miss. The service offers a cloud-based memorial space that lets loved ones light candles, share photos, stories and other contributions whenever the need arises. In addition to creating and visiting a Nettgrav, members can use the Grave Album, Memory Board, Value Archive and Life Archive. Certain parts of the service have specific terms—such as pricing, payment methods or subscription periods—described on the website. If those specific terms differ from these general terms, the specific terms take precedence.',
  terms_conditions_section2_title: '2. Registration, username and password',
  terms_conditions_section2_body:
    'How you access the service depends on whether you manage the physical grave or visit it digitally. You may create an account on nettgrav.com or through other services or social media where Nettgrav offers that option. By registering via a third party you allow Nettgrav to collect the information required to set up your account. You are responsible for ensuring the information you provide is accurate. Your password is personal and must not be shared. If you suspect unauthorised use, contact Nettgrav AS immediately and change your password. To protect the service, Nettgrav AS may ask you to update your password at any time.',
  terms_conditions_section3_title: '3. Use of the service',
  terms_conditions_section3_body:
    'You are responsible for how you use the product, and the service may only be used for its intended purpose. You agree to hold Nettgrav AS harmless from any legal claims or losses that arise from your use of the product and the services provided.',
  terms_conditions_section4_title: '4. Prices and payment',
  terms_conditions_section4_body:
    'Current pricing is listed on nettgrav.com and may be updated from time to time. Prices include applicable taxes where required.',
  terms_conditions_section5_title: '5. Disclaimer',
  terms_conditions_section5_body:
    'Unless explicitly stated otherwise, Nettgrav AS is not responsible for information or content placed on or sent through our services. Nettgrav does not control external websites we link to and is not responsible for their content. To the extent permitted by law, Nettgrav AS disclaims liability for any loss or damage resulting from your actions or omissions in connection with the service.',
  terms_conditions_section6_title: '6. Changes',
  terms_conditions_section6_body:
    'Nettgrav AS may modify the content or scope of the service, and may revise prices or other terms. If changes are material and to your disadvantage, Nettgrav AS will notify you by letter, SMS or email at the address you have registered, no later than 30 days before the changes take effect. If you do not accept the new terms you can cancel your membership at any time.',
  terms_conditions_section7_title: '7. Term and termination',
  terms_conditions_section7_body:
    'You may delete your account and any subscriptions at any time. Email kontakt@nettgrav.no if you have questions or need assistance.',
  terms_conditions_section8_title: '8. Complaints',
  terms_conditions_section8_body:
    'If you wish to make a complaint, notify Nettgrav AS by email, phone, letter or via the website within five days of delivery. Flowers and plants are regarded as perishable goods and are exempt from the right of withdrawal.',
  terms_conditions_section9_title: '9. Privacy',
  terms_conditions_section9_1_title: '9.1 General',
  terms_conditions_section9_1_paragraph1:
    'Your privacy matters, and in line with applicable law we inform you of the following:',
  terms_conditions_section9_1_paragraph2:
    'Nettgrav AS, Damstredet 3, 0177 Oslo (org. no. 912 857 336) is the data controller for personal information processed in connection with the product and services. Nettgrav AS processes personal data in accordance with Norwegian legislation.',
  terms_conditions_section9_1_paragraph3:
    'By creating an account you consent to Nettgrav AS processing personal data in line with these terms and our privacy policy.',
  terms_conditions_section9_2_title: '9.2 Purpose',
  terms_conditions_section9_2_body:
    'Nettgrav AS processes personal data in order to deliver the services, analyse how they are used, manage customer relationships, communicate with account holders and meet legal obligations.',
  terms_conditions_section9_3_title: '9.3 What data is processed?',
  terms_conditions_section9_3_body:
    'We process the details you provide when registering as well as information generated through your use of the service. This may include name, address, phone number, email address, payment information and relevant details about the deceased and the contributions linked to the grave.',
  terms_conditions_section9_4_title: '9.4 Disclosure of data',
  terms_conditions_section9_4_body:
    'Nettgrav AS may share personal data with suppliers who perform services on our behalf, such as infrastructure, IT operations or customer support. We do not share personal data with other third parties and we do not use your data to train artificial intelligence.',
  terms_conditions_section9_5_title: '9.5 Access, correction and deletion',
  terms_conditions_section9_5_body:
    'You have the right to request access to the personal data Nettgrav AS holds about you. You may also request that information be corrected, supplemented or deleted when there is a legal basis for doing so.',
  terms_conditions_section9_6_title: '9.6 Use of cookies',
  terms_conditions_section9_6_body:
    'We use cookies on the website. Cookies are small text files stored on your device that allow us to remember your choices and how the service is used. The information helps us tailor the website, improve usability and measure traffic.',
  terms_conditions_section9_6_paragraph2:
    'Most modern browsers accept cookies automatically, but you can choose to disable them. We do not use cookies to personalise the experience for individual users—everyone sees the same content.',
  terms_conditions_section9_6_paragraph3:
    'Traffic is measured in Nettgrav’s own system using pseudonymous visitor and session keys. We do not use Google Analytics or other external analytics tools for this measurement, and measurement data is not shared with commercial partners as user profiles.',
  terms_conditions_section9_6_paragraph4: '',
  terms_conditions_section10_title: '10. Disputes',
  terms_conditions_section10_body:
    'These terms are governed by Norwegian law, and any disputes shall be resolved by the Norwegian courts. Oslo District Court is the agreed legal venue.',
  terms_conditions_section11_title: '11. Contact information',
  terms_conditions_section11_body:
    'If you have questions about the service, contact Nettgrav AS at kontakt@nettgrav.no, +47 450 07 009 or by post at Damstredet 3, 0151 Oslo.',
  legal_navigation: 'Legal information',
  legal_last_updated: 'Last updated 2 August 2026',
  legal_terms_1_title: '1. About these terms',
  legal_terms_1_body:
    'Nettgrav is a digital service for graves, memories, relationships, conversations and communities. It includes Nettgrav, My Light, Create Spark, Rooms and End of Time Chat. Some purchases or features may have additional terms shown before you order or use them.',
  legal_terms_2_title: '2. Account and security',
  legal_terms_2_body:
    'You must provide accurate information and keep your login details private. Contact us and change your password if you believe someone else has gained access. Nettgrav may require renewed verification or a password change when necessary for security.',
  legal_terms_3_title: '3. Respectful and lawful use',
  legal_terms_3_body:
    'Treat other people and the memory of the deceased with respect. You may not impersonate others, knowingly create a false grave, harass or threaten people, infringe rights, publish unlawful material or attempt unauthorised access. Report misuse or incorrect information to kontakt@nettgrav.no.',
  legal_terms_4_title: '4. Content and visibility',
  legal_terms_4_body:
    'You retain the rights to content you create. You confirm that you may share it and choose among the available visibility levels. Publishing gives Nettgrav the limited rights needed to store, display, secure and deliver the content according to your choices. Share information about living people with care and the necessary permission.',
  legal_terms_5_title: '5. Moderation and errors',
  legal_terms_5_body:
    'Nettgrav may hide, restrict or remove content and accounts that violate these terms, the law or the rights of others. We may request documentation when graves or relationships are created or changed. Measures are assessed according to severity, risk and the information available.',
  legal_terms_6_title: '6. Prices and payment',
  legal_terms_6_body:
    'Basic use of Nettgrav is free. Prices, payment, delivery and any additional terms are shown before purchase. Mandatory consumer rights apply regardless of these terms.',
  legal_terms_7_title: '7. Changes and availability',
  legal_terms_7_body:
    'Nettgrav develops continuously. Features may change, be replaced or removed. We give appropriate notice of material changes that adversely affect your rights. We cannot guarantee uninterrupted availability and work to restore the service after failures.',
  legal_terms_8_title: '8. Ending use and complaints',
  legal_terms_8_body:
    'You may request account deletion and end ongoing agreements at any time. Purchases are covered by mandatory Norwegian consumer and withdrawal rights. Contact kontakt@nettgrav.no as soon as possible when something is wrong so we can help.',
  legal_terms_9_title: '9. Liability and disputes',
  legal_terms_9_body:
    'Nettgrav is liable to the extent required by mandatory law. We are not responsible for user-published content or external services we do not control. Norwegian law applies. We first seek to resolve disagreements through dialogue. Consumers may also contact the Norwegian Consumer Authority or another relevant complaints body.',
  legal_terms_10_title: '10. Contact information',
  legal_terms_10_body:
    'Nettgrav AS, organisation number 912 857 336. Registered business address: Damstredet 2, 0177 Oslo. Contact us at kontakt@nettgrav.no.',
  privacy_page_title: 'Privacy at Nettgrav',
  privacy_page_subtitle: 'What we process, why we need it and the choices you have.',
  privacy_promise_eyebrow: 'In short',
  privacy_promise_title: 'Your information is not for sale',
  privacy_promise_no_sale: 'We do not sell personal information.',
  privacy_promise_no_targeting:
    'We do not share names, contact details, relationships, memories, messages or activity with commercial partners for individual targeting.',
  privacy_promise_context:
    'Partners receive visibility in selected Nettgrav contexts. They do not gain access to the people using the service and receive only aggregate statistics not intended to identify individuals.',
  privacy_promise_no_profiles:
    'We do not use what you write, whom you remember or what you experience to build commercial profiles about you.',
  privacy_controller_title: '1. Who is responsible?',
  privacy_controller_body:
    'Nettgrav AS, organisation number 912 857 336, is the data controller. Our registered business address is Damstredet 2, 0177 Oslo. Contact us at kontakt@nettgrav.no.',
  privacy_data_title: '2. What information do we process?',
  privacy_data_body:
    'We process account and contact details, profile data, relationships, content you choose to share, support enquiries and necessary payment details. We also process technical data such as sessions, browser type, approximate country, security events and areas of the service visited. Graves contain data about deceased people. Memories and relationships may also contain data about living people.',
  privacy_purposes_title: '3. How do we use it?',
  privacy_purposes_body:
    'We use information to create and secure accounts, deliver requested features, display content according to visibility choices, handle payments and support, prevent misuse, correct errors, measure aggregate use and meet legal duties. We do not use your content to train general-purpose AI models.',
  privacy_legal_basis_title: '4. Legal basis',
  privacy_legal_basis_body:
    'Processing needed to provide Nettgrav normally relies on our contract with you. Security, misuse prevention and limited first-party measurement rely on our legitimate interest in a safe and functioning service. Accounting data is processed to comply with law. Optional analytics and other consent-based processing start only after your choice, and consent may be withdrawn.',
  privacy_visibility_title: '5. Visibility and information about others',
  privacy_visibility_body:
    'You control visibility through the choices in each feature. Public content can be seen and shared by others. Private content is restricted according to your choice. Where someone adds information about you, you may request access, correction, restriction or deletion when the legal conditions are met.',
  privacy_processors_title: '6. Suppliers, partners and transfers',
  privacy_processors_body:
    'Hosting, storage, email, payment, support, security and analytics suppliers may process necessary information for us under contract and instruction. Commercial partners do not receive user profiles or personal information for precise advertising. Where a technical supplier processes data outside the EEA, we use a valid transfer mechanism and appropriate safeguards.',
  privacy_retention_title: '7. How long do we retain information?',
  privacy_retention_body:
    'We retain information while the account or content is active and afterwards only when needed for its purpose, security, documentation or legal requirements. Payment and accounting data is retained as required by accounting law. Technical logs and measurement data are deleted or anonymised according to defined periods. Backups expire through normal rotation.',
  privacy_rights_title: '8. Your rights',
  privacy_rights_body:
    'You may request access, correction, deletion, restriction and portability, and object to processing based on legitimate interests. You may withdraw consent without affecting earlier lawful processing. You may complain to the Norwegian Data Protection Authority. Some data may need to be retained due to law or the rights of others.',
  privacy_security_title: '9. Security',
  privacy_security_body:
    'We use access controls, encrypted transport, logging, backups and other technical and organisational measures suited to the risk. No digital system is without risk. We provide notice in accordance with applicable rules when a breach may affect you.',
  privacy_contact_title: '10. Contact us',
  privacy_contact_body:
    'Send privacy questions or requests to kontakt@nettgrav.no. We may request information needed to verify your identity before providing access or making changes.',
  cookies_page_title: 'Cookies and measurement',
  cookies_page_subtitle: 'Necessary storage and Nettgrav’s own traffic measurement.',
  cookies_necessary_title: '1. Necessary storage',
  cookies_necessary_body:
    'Nettgrav uses necessary local storage and session technology for login, security, language, core features and remembering your privacy choice. It cannot be disabled within the service when required for a feature you use.',
  cookies_first_party_title: '2. Nettgrav first-party measurement',
  cookies_first_party_body:
    'We count page views and sessions in our own system to understand aggregate use, detect technical problems and filter bots. Measurement uses pseudonymous session and visitor keys, page category, browser type, approximate country and a time-limited hash of the IP address. Reports are aggregate and are not shared with partners as user profiles.',
  cookies_list_title: '3. Overview',
  cookies_list_body:
    'Necessary items include the Nettgrav session and settings such as language and display preferences. Nettgrav does not use Google Analytics, Google Tag Manager or third-party analytics cookies.',
  cookies_reject: 'Reject',
  cookies_manage: 'Change cookie choice',
  terms_conditions_accept_button: 'Accept',
  terms_conditions_reject_button: 'Decline',
  change_free_plan: 'Free plan is free of charge',
  free_plan_message:
    'With free you can explore, visit and create Nettgrav. Free is one fundamental value.',
  ending_with: 'ending with',
  add_payment_method: 'Add payment method',
  name_on_card: 'Name on card',
  expiry_date: 'Expiry date',
  secure_payment_message: 'Secure payment with SSL encryption',
  billing_address: 'Billing address',
  enter_address: 'Enter address',
  billing_info_message:
    'This information is used to issue the first invoice. You can update the details of future invoices from your account profile.',
  subscribe: 'Subscribe',
  select_language: 'Select language',
  payment_error: 'Payment error',
  subscription_waiting_message:
    'Payment is being processed. Please wait, your subscription is in progress',
  success_message: 'Subscription cancelled successfully',
  reactivate_success_message: 'The subscription has been reactivated',
  choose_plan: 'Choose a plan before subscribing',
  canceling_waite_message: 'Cancelling subscription in process, please wait...',
  subscription_overview: 'Subscription overview',
  users: 'Members',
  for_members: 'For {user} members',
  for_member: 'For {user} member',
  for_6_members: 'For {user} or more',
  billing_cycle: 'Billing cycle',
  amount: 'Amount',
  cancelSubscriptionInfo:
    'Your subscription ends on the end date and moves to the free plan. You can restart anytime.',
  confirm_billing_cycle: 'Save changes',
  different_cycle: 'Please select a different subscription cycle',
  update_billing: 'The billing cycle has been updated',
  waiting_update_billing_cycle: `Just a moment, we're updating your billing cycle...`,
  add_members_message: 'Members have been added',
  remove_members_message: 'Members have been removed',
  your_current_plan: 'Your current plan',
  upgrade_to: 'Upgrade to {planName}',
  downgrade_to: 'Downgrade to {planName}',
  members_removed: 'Subscription member has been removed',
  invitation_removed: 'Member of the subscription invitation has been removed',
  mann: 'Man',
  kvinne: 'Woman',
  annen: 'Other',
  life_page_description: 'Here you will find your graves and My Light.',
  settings: 'Settings',
  settings_description: 'Your account information such as password, membership and person.',
  logout: 'Sign out',
  logout_description: 'Do something kind. A glance. A smile. A word. Your light matters.',
  logout_success: 'You are now signed out.',
  create_new_grave: 'Create new grave',
  create_grave_description: 'Create a new grave entry for a deceased individual in records.',
  new: 'New',
  read: 'Read',
  empty_notification_message: 'New notifications are displayed here',
  public_anniversaries: 'Public Memorial Days',
  grave_anniversaries: 'Anniversaries',
  public_anniversary: 'Public Memorial Day',
  grave_anniversary: 'Personal Memorial Day',
  anniversary: 'Memorial Day',
  birthday_event: 'Birthday',
  death_anniversary_event: 'Death anniversary',
  memorial_days: 'Memorial Days',
  anniversary_delete: 'The memorial day has been deleted successfully.',
  anniversary_created: 'The memorial day has been created successfully.',
  anniversary_updated: 'The memorial day has been updated successfully.',
  empty_anniversaries: 'No memorial day has been created yet.',
  anniversaries_today: 'Today',
  anniversaries_upcoming: 'Upcoming',
  anniversaries_past: 'Earlier',
  anniversaries_past_empty: 'No earlier memorial days yet.',
  anniversaries_personal: 'Your memorial days',
  anniversaries_personal_empty: 'You have not added any memorial days yet.',
  anniversaries_personal_login: 'Log in to add your own days.',
  anniversaries_care_title: 'Care over time',
  anniversaries_care_body: 'Light and care can be handled on key days, even when no one is nearby.',
  anniversaries_care_soon: 'Coming soon',
  anniversaries_focus_title: 'This day',
  anniversaries_focus_today: 'Light a candle today to be present.',
  anniversaries_focus_future: 'Candles can be scheduled for this day.',
  anniversaries_focus_future_scheduled:
    '{count, plural, one {# candle is scheduled for this day.} other {# candles are scheduled for this day.}}',
  anniversaries_focus_future_scheduled_self: 'You have scheduled a candle for this day.',
  anniversaries_focus_future_cta: 'Order candle',
  anniversaries_focus_future_tooltip: 'Coming soon',
  anniversaries_focus_past: 'This day has passed. The memory remains.',
  anniversaries_focus_empty: 'Select a memorial day to see details.',
  anniversaries_recurring_note: 'Annual · {year}',
  anniversaries_show_all: 'Show all',
  anniversaries_show_less: 'Show fewer',
  candles_now: 'Candles now',
  candles_on_selected_day: 'Candles this day',
  candles_on_selected_day_empty: 'No candles on this day.',
  schedule_candle: 'Schedule candle',
  schedule_candle_cta: 'Schedule',
  scheduled_gift_context_label: 'Scheduling for',
  scheduled_gift_created: 'Candle scheduled.',
  scheduled_gift_error: 'Unable to schedule candle.',
  scheduled_gift_load_error: 'Unable to load scheduled candles right now.',
  quiet_presence_count: 'Quiet presences · {count}',
  quiet_presence_zero: 'No quiet presences yet',
  quiet_presence_return: 'You have been here before',
  calendar_today_with_date: 'Today, {date}',
  calendar_today: 'Today',
  calendar_tomorrow: 'Tomorrow',
  calendar_upcoming: 'Upcoming',
  calendar_month: 'Month',
  calendar_week: 'Week',
  calendar_day: 'Day',
  weekday_short_0: 'Sun',
  weekday_short_1: 'Mon',
  weekday_short_2: 'Tue',
  weekday_short_3: 'Wed',
  weekday_short_4: 'Thu',
  weekday_short_5: 'Fri',
  weekday_short_6: 'Sat',
  create: 'Create',
  add_dates: 'Add Dates',
  date: 'Date',
  time: 'Time',
  title: 'Title',
  reset_time: 'Reset Time',
  home: 'Home',
  about: 'About',
  howTo: 'How to',
  plans: 'Plans',
  find_a_grave: 'Find a Grave',
  create_a_grave: 'Create a Grave',
  take_control: 'Take Control of the Grave',
  pricing: 'Pricing',
  get_started: 'Get started',
  create_new_account: 'Create your own account.',
  did_you_know: 'Did you know',
  registration_description_one:
    "There are no grave leases or maintenance fees here. You don't have to worry about upkeep. Nettgrav takes care of the outer — you take care of the inner.",
  registration_description_two:
    'A grave to carry with you in life. Remembering someone is also a way of loving.',
  registration_description_three: "You don't have to perform here. It's enough just to be present.",
  enter_your_password: 'Enter your password',
  confirm_your_password: 'Confirm your password',
  type_your_email: 'Enter your email address',
  type_email: 'Enter email',
  hi: 'Hi {name}',
  dream_world_question: 'What does your dream world look like?',
  decline: 'Decline',
  read_only: '(read only)',
  accept: 'Accept',
  accepted_message: 'The invitation is accepted',
  invited_title: 'You are invited to a subscription',
  open: 'Open',
  subscription_invitation_message: 'You are invited to {subscription} subscription from {name}',
  email_error: 'Please enter a valid email',
  password_length: 'Use at least 8 characters, with uppercase, lowercase, and numbers.',
  filled_out: 'Fill in all fields to continue.',
  must_agree: 'Agree to the terms to continue.',
  inactive: 'Inactive',
  delete_payment_method: 'Deleting payment method in process, wait...',
  payment_method_deleted: 'The payment method has been deleted',
  payment_method_inactive: 'Your current payment method is either deleted or no longer active.',
  subscription_changes_title: 'You requested these subscription changes.',
  period: 'You Requested to downgrade billing cycle from {month} {previous} to {newMonth} {new}',
  user_count: 'You Requested to downsize members from {previous} to {new}',
  product_id: 'You Requested to downgrade plan from {previous} to {new}',
  remove_subscription_change: 'The requested subscription change is reverted',
  remove_subscription_loading: 'please waite request is in progress to delete changes......',
  revert: 'Revert',
  subscription_changes_subTitle:
    'These changes will be applied after your current billing cycle will end by {date}',
  add_new_paymentMethod: 'Add payment method',
  filled_out_info:
    'Make sure you have filled in all the fields in the account_form_before continuing',
  continue_new_card: 'Select a payment method or add a new card to continue',
  create_payment_method_waiting: 'Creating payment method. Please wait...',
  login_description: 'Closeness to the dead and to life on nettgrav.com. Follow your Spark.',
  login_with_email: 'Log in with email',
  login_with_phone: 'Log in with phone number',
  account_created: `Welcome. Your account has been created`,
  verify_account: 'Email not verified',
  verification_message:
    'To log in, please verify your email address. Check your inbox or spam, or request a new message:',
  resend_email: 'Resend verification email',
  sending_verification_email: 'Please check your mailbox for a verification email',
  sending_verification_code: 'Verification code has been sent to your phone number.',
  sending_verification_waiting:
    'A verification code has been sending to your phone number please wait...',
  email_verification:
    'We’ve sent a verification email. Please check your inbox and click the link to verify your email.',
  signup_step_title: 'Confirm your email',
  signup_relation_ready:
    'The relation is ready — we’ll connect you to {name} as soon as your email is confirmed.',
  signup_message_heading: 'Confirm your email',
  signup_message_subheading: 'To finish, please confirm your email.',
  signup_primary_cta: 'We sent a confirmation link to {email}',
  signup_secondary_cta: 'Once you open the link, you’ll be logged in automatically.',
  signup_secondary_cta_relation:
    'Once you open the link, you’ll be logged in and the relation will be connected.',
  signup_help_text: 'Can’t find the email? Check spam or resend the link.',
  signup_verification_reason: 'This helps us ensure the right access.',
  signup_primary_action: '🕊 Waiting for email confirmation…',
  signup_resend_action: 'Resend the link',
  signup_save_email: 'Save email',
  signup_cancel_email: 'Cancel',
  signup_email_updated: 'Email updated. A new link has been sent.',
  signup_verification_refresh_hint: 'Verified — updating…',
  signup_change_email: 'Change email',
  signup_login_action: 'Go to login',
  signup_resend_toast: 'Confirmation email has been resent.',
  signup_waiting_cta: 'Awaiting confirmation',
  signup_delivery_status_label: 'Email status:',
  grave_guest_visit_title: 'Visit the grave',
  grave_guest_visit_body: 'Here you can read, see who belongs, and be present around {name}.',
  grave_guest_visit_support: 'Sign in to connect yourself to the grave and stay involved.',
  grave_guest_visit_primary: 'Connect yourself to the grave',
  signup_delivery_status_sending: 'Sending email…',
  signup_delivery_status_sent: 'Email sent from us. Waiting for delivery confirmation.',
  signup_delivery_status_delivered: 'Email delivered.',
  signup_delivery_status_temporary_failure:
    'We could not deliver the email right now. Please try again shortly.',
  signup_delivery_status_temp_over_quota:
    'The email could not be delivered because the mailbox is full. Please try again shortly.',
  signup_delivery_status_permanent_failure:
    'The email could not be delivered. Check the address or use a different email.',
  signup_login_inline: 'Already have an account? Sign in',
  waiting_for_account: `We're creating your account. Please wait a moment...`,
  account_verification_waiting: 'Please wait, your account verification is in process...',
  account_verification_heading: 'Account Verified Successfully',
  account_verification_heading_error: 'Account Verification Failed',
  account_verification_description: 'Your account has been successfully verified.',
  account_verification_description_error:
    'There was an issue verifying your account. Please try again or contact support for assistance',
  update_payment_method_waiting: 'Updating payment method. Please wait...',
  update_payment_method_success: 'Payment method successfully updated.',
  warning_payment_method: 'Select a new payment method',
  complete_pending_payment: `Please complete the payment process.`,
  plans_card_payment_method: 'Access payment options here:',
  forgot_password_heading: 'Need help with your password?',
  forgot_password_description: 'Enter your email address and we will send a link.',
  forgot_password_button: 'Send link',
  forgot_password_message: 'We have sent a link to your email address. Check your inbox or spam.',
  forgot_password_title: 'Link sent',
  forgot_password_waiting: 'Sending link…',
  set_new_password: 'Set a New Password',
  set_new_password_description:
    'Please enter a new password for your account. Make sure it’s strong and secure. After confirming, you’ll be able to log in with your new password.',
  set_new_password_error: 'Please Enter the password',
  set_new_password_success: 'Your password has been successfully updated',
  set_new_password_waiting:
    'Please hold on while we update your password. This will only take a moment.',
  action_required: 'Action Required: ',
  email_verification_alert: `Add and verify your email to
            continue logging in with email or phone. Accounts with no or unverified
            e-mail address will not be able to login`,
  goTo_settings_page: 'Go to setting page',
  go_to_home_page: 'Go to home page',
  verify_now: 'Verify Now',
  authCode_verified: 'Phone number verified successfully',
  personal_information_updated: 'Personal information updated',
  change_phone_number: 'Change phone number',
  verify_phone_button: 'Verify phone number',
  change_email: 'Change Email',
  current_email: 'Current email',
  new_email: 'New email',
  verify_email_button: 'Verify email',
  change_email_btn: 'Change Email',
  change_password: 'Change Password',
  change_password_btn: 'Change Password',
  reset_date: 'Reset date',
  date_picker_day_label: 'Day',
  date_picker_month_label: 'Month',
  date_picker_year_label: 'Year',
  date_picker_day_placeholder: 'Select day',
  date_picker_month_placeholder: 'Select month',
  date_picker_year_placeholder: 'Select year',
  date_picker_search_placeholder: 'Search…',
  date_picker_no_results: 'No matches found',
  date_picker_clear: 'Clear selection',
  sending_verification_email_waiting:
    'A verification link has been sent to your email, please wait...',
  local_name: 'Local Name',
  create_anniversary_waiting: 'create anniversary in progress please wait...',
  anniversary_time_end: 'Event has finished',
  hello: 'Hello',
  coins: 'Coins',
  store: 'Presence',
  purchase: 'Purchase',
  checkout_title: 'Complete your choice',
  checkout_billing_address: 'Billing Address',
  checkout_billing_name_label: 'Full name',
  checkout_billing_name_placeholder: 'Full name',
  checkout_billing_email_label: 'Email',
  checkout_billing_email_placeholder: 'Email',
  checkout_billing_phone_label: 'Phone number',
  checkout_billing_phone_placeholder: 'Phone number',
  checkout_billing_street_label: 'Street address',
  checkout_billing_street_placeholder: 'Street address',
  checkout_billing_city_label: 'City',
  checkout_billing_city_placeholder: 'City',
  checkout_billing_state_label: 'State/Province',
  checkout_billing_state_placeholder: 'State/Province',
  checkout_billing_postal_label: 'Postal code',
  checkout_billing_postal_placeholder: 'Postal code',
  checkout_billing_country_label: 'Country',
  checkout_billing_country_placeholder: 'Select country',
  checkout_card_details: 'Card Details',
  checkout_card_number_label: 'Card number',
  checkout_card_number_placeholder: '1234 1234 1234 1234',
  checkout_card_expiration_label: 'Expiration date',
  checkout_card_expiration_placeholder: 'MM / YY',
  partner_card_expiration: 'Expiration date',
  checkout_card_cvc_label: 'Security code',
  checkout_card_cvc_placeholder: 'CVC',
  checkout_payment_unavailable: 'Payment service is not ready. Please try again.',
  checkout_missing_card_details: 'Enter your card number to continue.',
  checkout_missing_card_expiry: 'Enter the expiration date.',
  checkout_missing_card_cvc: 'Enter the CVC.',
  checkout_saved_payment_methods: 'Payment method',
  checkout_add_new_payment: 'Add payment method',
  checkout_notice_banner_title: 'Gift to the family',
  checkout_notice_banner_body:
    'This order will be linked to the notice{hasName, select, true { for {name}} false {}}.',
  checkout_cart_title: 'Your Cart',
  checkout_subtotal: 'Subtotal',
  checkout_total: 'Total',
  checkout_checkout: 'Confirm your choice',
  checkout_complete_purchase: 'Confirm your choice',
  checkout_pay_amount: 'Pay {amount}',
  bonus_tc: 'Bonus TC',
  set_color: 'Whats your color today?',
  set_color_button: 'Set your color',
  sparks: 'Sparks',
  community: 'Community',
  purpose: 'Purpose',
  talents: 'Talents',
  profile_image_changed: 'Image updated successfully',
  cover_photo_updated: 'Cover photo updated.',
  cover_photo_removed: 'Cover photo removed.',
  edit_cover_photo: 'Edit cover photo',
  waiting_profile_upload: 'profile image updating please wait...',
  graves: 'Those I carry with me',
  'cemeteryLanding.title': 'Find a grave at {cemetery}',
  wisdom: 'Wisdom',
  sparks_description: 'Share your Spark that may catch fire and spread light.',
  text_area_placeholder: 'How can you light up someone else´s path?',
  crop_image: 'Crop image',
  recurring_anniversary: 'Repeat every year',
  nick_name: 'Nick Name',
  birth_name: 'Birth name',
  date_of_birth: 'Date of birth',
  date_of_death: 'Date of death',
  time_of_birth: 'Time of birth',
  time_of_death: 'Time of death',
  place_of_birth: 'Place of birth',
  place_of_death: 'Place of death',
  cause_of_death: 'Cause of death',
  municipality: 'Municipality',
  country: 'Country',
  cemetery: 'Cemetery',
  grave_number: 'Grave number',
  grave_info_updating: 'updating grave information please wait...',
  deceased_name: 'Name',
  deceased_placeholder: 'Enter name of the deceased',
  deceased_gender: 'Gender',
  i_am: 'I am',
  buried_is_mine: 'The deceased is my',
  select_relationship: 'Select relationship',
  upload_document: 'Upload document for the grave',
  upload_document_description: 'select which document you want to upload:',
  death_certificate: 'Death certificate',
  birth_certificate: 'Birth certificate',
  invoice: 'Receipt for grave care or rent',
  power_of_attorney: 'Confirmation from lawyer',
  driving_license: `ID card of the deceased`,
  proof_of_person: 'Upload a document about the deceased',
  proof_of_person_description: 'Use PDF, PNG, or JPG under 5 MB.',
  replace_files: 'Replace files',
  browse_files: 'Find your file',
  drag_image: 'or drag your file here',
  dear: 'Dear',
  new_grave_first_description: 'Welcome to create a new Nettgrav.',
  new_grave_second_description: 'Here, you can create a safe and respectful grave.',
  new_grave_third_description: `By creating a Nettgrav, you confirm that you have permission to do this for the deceased.`,
  new_grave_fourth_description: `Click 'Accept' to continue.`,
  new_grave_agree_terms: 'I agree to the terms above',
  enter_name_error: 'Please enter name of the person',
  select_gender_error: "Choose the person's gender.",
  select_relation_error: 'Choose your relation to the person.',
  select_date_error: 'Please select a date',
  select_reason_error: 'Please select a reason of death',
  reason_of_death: 'Cause of death',
  other_reason: 'Enter another reason',
  other_reason_error: 'Please enter other reason of death',
  select_country: 'Select Country',
  select_municipality: 'Select Municipality',
  select_cemetery: 'Select Cemetery',
  select_country_error: 'Please select a country',
  select_municipality_error: 'Please select a municipality',
  select_cemetery_error: 'Please select a cemetery',
  create_the_grave: 'Create the grave',
  create_the_message: 'Creating a grave is in progress please wait....',
  death_date_error: 'Please select a valid date of death',
  birth_date_error: 'Please select a valid date of birth',
  month_0: 'January',
  month_1: 'February',
  month_2: 'March',
  month_3: 'April',
  month_4: 'May',
  month_5: 'June',
  month_6: 'July',
  month_7: 'August',
  month_8: 'September',
  month_9: 'October',
  month_10: 'November',
  month_11: 'December',
  unknown_year: 'Unknown year',
  unknown_month: 'Unknown month',
  'life.unknown_month': 'Unknown month',
  weekday_0: 'Sunday',
  weekday_1: 'Monday',
  weekday_2: 'Tuesday',
  weekday_3: 'Wednesday',
  weekday_4: 'Thursday',
  weekday_5: 'Friday',
  weekday_6: 'Saturday',
  father: 'Father',
  mother: 'Mother',
  son: 'Son',
  husband: 'Husband',
  wife: 'Wife',
  brother: 'Brother',
  sister: 'Sister',
  maternal_grandfather: 'Maternal grandfather',
  maternal_grandmother: 'Maternal grandmother',
  paternal_grandfather: 'Paternal grandfather',
  paternal_grandmother: 'Paternal grandmother',
  maternal_uncle: 'Maternal uncle',
  maternal_aunt: 'Maternal aunt',
  paternal_uncle: 'Paternal uncle',
  paternal_aunt: 'Paternal aunt',
  farfar: 'Paternal grandfather',
  morfar: 'Maternal grandfather',
  farmor: 'Paternal grandmother',
  mormor: 'Maternal grandmother',
  grandfather: 'Grandfather',
  grandmother: 'Grandmother',
  grandchild: 'Grandchild',
  grandson: 'Grandson',
  granddaughter: 'Granddaughter',
  uncle: 'Uncle',
  uncle_child: 'Cousin',
  aunt: 'Aunt',
  aunt_child: 'Cousin',
  nephew: 'Nephew',
  niece: 'Niece',
  cousin: 'Cousin',
  aunt_husband: "Aunt's husband",
  uncle_wife: "Uncle's wife",
  cousin_wife: "Cousin's wife",
  cousin_husband: "Cousin's husband",
  stepbrother: 'Stepbrother',
  stepsister: 'Stepsister',
  stepfather: 'Stepfather',
  stepmother: 'Stepmother',
  stepson: 'Stepson',
  stepdaughter: 'Stepdaughter',
  father_in_law: 'Father in law',
  mother_in_law: 'Mother in law',
  brother_in_law: 'Brother in law',
  sister_in_law: 'Sister in law',
  son_in_law: 'Son in law',
  daughter_in_law: 'Daughter in law',
  self: 'Self',
  parent: 'Parent',
  child: 'Child',
  sibling: 'Sibling',
  spouse: 'Spouse',
  grandparent: 'Grandparent',
  great_grandparent: 'Great grandparent',
  great_grandchild: 'Great grandchild',
  great_great_grandparent: 'Great great grandparent',
  great_great_grandchild: 'Great great grandchild',
  great_great_great_grandparent: 'Great great great grandparent',
  great_great_great_grandchild: 'Great great great grandchild',
  aunt_or_uncle: 'Aunt/Uncle',
  great_uncle: 'Great uncle',
  great_aunt: 'Great aunt',
  great_aunt_or_uncle: 'Great aunt/uncle',
  nibling: 'Nibling',
  grand_niece: 'Grandniece',
  grand_nephew: 'Grandnephew',
  grand_nibling: 'Grandnibling',
  great_niece: 'Great niece',
  great_nephew: 'Great nephew',
  great_nibling: 'Great nibling',
  cousin_in_law: 'Cousin in law',
  aunt_in_law: 'Aunt in law',
  uncle_in_law: 'Uncle in law',
  first_cousin_in_law: 'First cousin in law',
  uncle_in_law_son: "Uncle in law's son",
  first_cousin: 'First cousin',
  first_cousin_once_removed: 'First cousin once removed',
  first_cousin_twice_removed: 'First cousin twice removed',
  second_cousin: 'Second cousin',
  second_cousin_once_removed: 'Second cousin once removed',
  second_cousin_twice_removed: 'Second cousin twice removed',
  third_cousin: 'Third cousin',
  third_cousin_once_removed: 'Third cousin once removed',
  third_cousin_twice_removed: 'Third cousin twice removed',
  aunt_uncle_in_law: 'Aunt/Uncle in law',
  nibling_in_law: 'Nibling in law',
  niece_in_law: 'Niece in law',
  nephew_in_law: 'Nephew in law',
  parent_in_law: 'Parent in law',
  child_in_law: 'Child in law',
  sibling_in_law: 'Sibling in law',
  grandparent_in_law: 'Grandparent in law',
  grandchild_in_law: 'Grandchild in law',
  step_parent: 'Step-parent',
  step_mother: 'Stepmother',
  step_father: 'Stepfather',
  step_child: 'Stepchild',
  step_daughter: 'Stepdaughter',
  step_son: 'Stepson',
  step_sibling: 'Stepsibling',
  step_sister: 'Stepsister',
  step_brother: 'Stepbrother',
  boyfriend: 'Boyfriend',
  girlfriend: 'Girlfriend',
  adopt_son: 'Adopt son',
  adopt_daughter: 'Adopt daughter',
  adopted_son: 'Adopted son',
  adopted_daughter: 'Adopted daughter',
  moons: 'Moons',
  my_moons: 'My moons',
  has_you_as_moon: 'Has you as moon',
  moons_empty_title: 'No moons yet.',
  moons_empty_description: 'A moon is someone who has guided you. Someone whose light you follow.',
  friends: 'Friends',
  friends_and_family: 'Family and friends',
  colleagues: 'Colleagues',
  friend: 'Friends',
  other: 'Other',
  daughter: 'Daughter',
  partner: 'Partner',
  relation_category_parent: 'Parent',
  relation_category_child: 'Child',
  relation_category_partner: 'Partner',
  relation_category_sibling: 'Sibling',
  relation_category_grandparent: 'Grandparent',
  relation_category_aunt_uncle: 'Aunt/Uncle',
  relation_quick_pick_hint: 'We prefilled your choice. Confirm or switch.',
  relation_quick_pick_parent_choose: 'Choose Mother or Father.',
  relation_quick_pick_sibling_choose: 'Choose Brother or Sister.',
  relation_quick_pick_child_choose: 'Choose Son or Daughter.',
  open_details: 'Open details',
  colleague: 'Colleague',
  great_granddaughter: 'Great granddaughter',
  great_grandson: 'Great grandson',
  great_grandmother: 'Great grandmother',
  great_grandfather: 'Great grandfather',
  great_great_granddaughter: 'Great great granddaughter',
  great_great_grandson: 'Great great grandson',
  great_great_grandmother: 'Great great grandmother',
  great_great_grandfather: 'Great great grandfather',
  great_great_great_granddaughter: 'Great great great granddaughter',
  great_great_great_grandson: 'Great great great grandson',
  great_great_great_grandmother: 'Great great great grandmother',
  great_great_great_grandfather: 'Great great great grandfather',
  cohabitant: 'Cohabitant',
  contact_person: 'Your contact person',
  invited_person_name: `Invited person's name`,
  monthly: 'Monthly',
  semi_annual: 'Semi-Annual',
  annually: 'Annually',
  biennial: 'Biennial',
  auth_modal_description: `Login or create a free account to visit graves and use all features.`,
  auth_modal_heading: 'Log in | Create account',
  active: 'Active',
  requested_to_remove: 'Request to remove',
  manage_members: 'Manage Members',
  remove_members_warring:
    'Remove {remainingNumber} more members or cancel their invitations (or both).',
  remove_members_warning: 'Remove members or lower the number to continue.',
  subscription_base_price: 'Subscription base price',
  membership: 'membership',
  relation_to_grave: `Invited relation to {graveName}`,
  relation_to_person: `{graveName} relation to invited`,
  administrator_access: 'Administrator access',
  select_role: 'Select role',
  administrator: 'Administrator',
  normal: 'Normal',
  select_role_error: 'Please select the user role',
  user_name: 'User name',
  remove_all_grave_user: 'Important Notice: Grave Management Update',
  remove_all_grave_user_message:
    'Keep at least one person or admin connected. To remove everyone, transfer ownership or delete the grave.',
  send_it: 'Send it',
  public_view: 'Public view',
  spark_posting_to_privacy: 'Visible to {privacy}',
  constellation: 'Constellation',
  moons_only: 'Moons only',
  form: 'Form',
  state_of_mind: 'State of being',
  spark_state_of_mind_info: 'Choose your state of being. It shapes how your spark is received.',
  spark_state_of_mind_info_label: 'State of being info',
  spark_form_info_label: 'Information about expression',
  spark_remove_link_preview_to_add_media: 'Remove link preview to add media.',
  taggable_composer_type_to_tag: 'Type a name to tag',
  taggable_composer_no_matches: 'No matches found',
  taggable_composer_clear: 'Clear',
  question: 'question',
  insight: 'insight',
  experience: 'experience',
  discovery: 'discovery',
  feeling: 'feeling',
  value: 'value',
  energy: 'energy',
  select_category: 'Select category',
  spark_delete: 'Spark deleted successfully',
  spark_create: 'Spark created successfully',
  spark_update: 'Spark update successfully',
  ENG: 'English',
  NOR: 'Norwegian',
  loading: 'Loading…',
  in_your_mind: 'Share a thought, question, or experience…',
  spark_reflection_placeholder:
    'Respond with what this spark awakens in you — reflection, hope, or connection.',
  create_spark: 'Create a Spark',
  reflect_on_spark: 'Reflect on Spark',
  empty_graves:
    'Use the search field at the top left to find a grave you have a connection to. Once you´ve set the relation, the grave will appear here.',
  all: 'All',
  owner: 'Owner',
  affiliated: 'Affiliated',
  view_all: 'View All',
  close_relation: 'Once you add someone, they´ll show up here.',
  no_relation_set: 'No relations have been set',
  love_ones: 'Those walking with {name}',
  set_relation: 'Choose your relation',
  relation_request_send: 'Your relation request has been successfully sent.',
  relation_updated_success: 'Relation updated successfully.',
  relation_update_failed: 'Unable to update the relation.',
  relation_removed_success: 'Relation removed successfully.',
  relation_remove_failed: 'Unable to remove the relation.',
  relation_connection: '{name} is my {reciprocalRelation}, and I am the {relation} of {name}.',
  request_send: 'Request has been sent',
  empty_sparks: 'No sparks available please create new one',
  'sparks.empty_stars':
    'No sparks have become stars yet. When a spark grows into a star, it will appear here.',
  create_post: 'Grave wall · {graveName}',
  grave_wall_cta_primary: 'Leave the words',
  grave_wall_cta_secondary: 'Close',
  post: 'Post',
  update_post: 'Update Post',
  account_heading: 'Delete your Nettgrav account',
  delete_account: 'Delete account',
  delete_account_pending: 'Account deletion in progress',
  deleted_message_pending:
    'Your deletion request has been sent. Your account and all data will be deleted. You can cancel the deletion before 23:50 today. If you have any questions, contact us at kontakt@nettgrav.no.',
  deleted_message:
    'If you delete your account, all information and data will be permanently removed. Deletion is final after 23:50. Contact kontakt@nettgrav.no if you have any questions.',
  confirm_delete_account: 'This will delete your account and all associated data.',
  confirm_cancel_account: 'This will stop the deletion request and keep your account active.',
  account_delete_confirm_button: 'Remove account',
  account_delete_cancel_button: 'Keep account',
  account_cancel_delete_confirm_button: 'Stop deletion',
  account_cancel_delete_cancel_button: 'Keep account',
  phone_number_error: 'Phone number/Password do not match',
  email_error_login: 'Email and password do not match.',
  set_relation_heading: 'Connect with the grave',
  set_relation_free_description: `Tell us who {graveName} is to you and get access to the grave.`,
  set_relation_access: 'As a member, you can:',
  do_you_know: 'Who is {graveName} to you?',
  set_relation_description: 'Submit request to join page as a relative, friend or a well-wisher',
  set_relation_info_message: `If you have a free account, you’ll be asked to pay 2 $ per month when you click “Confirm and Join.`,
  click_button_below: 'Choose your relation to continue.',
  feature_title_1: 'Memory Album',
  feature_description_1: 'Add photos of your loved one and family.',
  feature_title_2: 'Memory Wall',
  feature_description_2: 'Read and share memories with others who knew them.',
  feature_title_3: 'Memorial Day Calendar',
  feature_description_3: 'Get reminders for important days.',
  feature_title_4: 'Value Archive',
  feature_description_4: 'Save important lessons the loved one taught you.',
  feature_title_5: 'Life Archive',
  feature_description_5: 'Write down stories about their life.',
  choose_relation: 'Choose relation',
  relation_label: 'I am {grave}´s',
  reciprocal_label: '{grave} is my',
  set_relation_note: 'Choose who the deceased is to you and give the grave a home here at Nettgrav',
  set_relation_other:
    'For everyone who knew the deceased. Whether you were a colleague, a fan, or something else.',
  set_relation_placeholder: 'Example, I was friends with {grave} at the university in Oslo...',
  confirm_relation_member: 'Confirm relation and become member',
  pay_and_reactivate: 'Pay to Reactivate Membership',
  confirm_membership: 'Confirm Membership',
  enlightened: 'Enlightened',
  inspired: 'Inspired',
  spark_reaction_add_wood: 'Add wood',
  spark_reaction_add_breath: 'Add breath',
  spark_reaction_add_light: 'Add light',
  spark_reaction_legacy: 'Legacy',
  spark_stage_spark: 'Spark',
  spark_stage_campfire: 'Campfire',
  spark_stage_star: 'Star',
  'spark.openDetail': 'Open spark',
  reflected: 'Reflected',
  comments: 'Replies',
  comment: 'Reply',
  empty_comments: 'No replies found',
  comment_placeholder: 'Write here…',
  reply: 'Reply',
  view_replies: 'View all {total} replies',
  create_grave_body: 'To create a new Nettgrav, you need a Conscious Membership.',
  upgrade_modal_heading: 'Create new grave',
  go_to: 'Go to',
  our_plans: 'activate membership',
  choose_the_subscription: 'to access all features.',
  link_grave_body:
    'So nice that you want to link the buried together. To do that, you need Conscious membership.',
  add_more_images_body: 'To add more photos to albums, you need to upgrade your subscription.',
  inviting_body: 'Inviting is available with Conscious Membership.',
  life_archive_body: 'The life archive is available with conscious membership.',
  upload_images_body: 'To add Photos, an upgrade to your current subscription is necessary',
  add_value_body: 'So nice that you want to add a quality. To add, you need Conscious membership.',
  search_limit_body:
    'Dive deeper into Nettgrav with our conscious Plan. Upgrade today for unlimited searches.',
  grave_invitation_first_text: 'You have been invited to contribute to the grave',
  of: 'of',
  grave_invitation_second_text: 'Here you can gather memories, photos, and anniversaries together.',
  grave_email_info:
    'This email is fixed for this invitation. If there’s an issue, reach out to the person who invited you.',
  subscription_email_info:
    'This email is fixed for this subscription. If there’s an issue, contact the person who set it up.',
  grave_invitation_message: '{name} has invited you to help care for the grave of {grave}.',
  accept_or_pay: 'Accept and process payment',
  paid_grave_user_message: `You’ve been invited by {userName} to join this grave with a paid subscription. Accept the invitation to join this exclusive community, or decline if it’s not the right time for you. Choose your next step below!`,
  unpaid_grave_user_message: `You’ve been invited by {userName} to join this grave. To be part of this exclusive community, please upgrade to a paid subscription. Accept the invitation to join, or decline if it’s not the right time for you. Choose your next step below!`,
  active_unpaid_grave_user_message: `You don't have an active subscription right now. Reactivate your subscription to continue contributing and stay an active member of the community. Click below to renew your membership and make an impact!`,
  invite: 'Invite',
  complete_relation_setup: 'Complete Your Payment To Confirm Your Relation',
  already_set_relation: `You've already set your relationship with the grave {graveName} as {relation}.`,
  already_accept_relation: `You've already accepted your relationship with the grave {graveName} as {relation}.`,
  finalize_membership: `To finalize this connection and unlock all membership benefits, please complete your payment. Once done, the grave will be linked to your life page, and you'll gain access to:`,
  click_below_to_complete:
    'Click the button below to complete your payment and confirm your relation.',
  complete_payment: 'Complete Payment',
  awaiting_owner_approval: `Awaiting Owner's Approval`,
  awaiting_approval_message:
    'The owner has been notified of your request for relation. Please wait for their approval or rejection. You’ll be updated as soon as they respond.',
  subscribed_grave_invitation: `You've been invited to connect with the grave {graveName} as {relation} by {name}.`,
  click_below_to_accept:
    'Click the button below to accept the invitation and confirm your relation.',
  accept_invitation: 'Accept Invitation',
  accept_invitation_payment: 'Accept and Complete Payment',
  complete_invitation: 'Complete Your Invitation',
  unsubscribed_grave_invitation: `To accept this invitation and finalize your connection, please complete the payment process. Once confirmed, you'll gain access to the following exclusive features:`,
  you_are_invited: `You've Been Invited!`,
  reclaim_user_access: 'Reclaim Your Access',
  previous_relation: 'You were previously connected with the {graveName} as {relation}.',
  downgrade_subscription:
    'Since your membership has been downgraded to the free plan, access to this grave and its features has been restricted. However, you are still a recognized member of this grave.',
  regain_access:
    'To regain full access and reconnect with the grave, please upgrade your membership.',
  click_below_to_upgrade: 'Click the button below to upgrade and restore your access.',
  upgrade_membership: 'Upgrade membership',
  set_self_relation: 'Say who {graveName} is to you to connect with the grave.',
  set_relation_linked: 'When you do this, you can:',
  set_self_relation_1: 'Visit the grave whenever you need to.',
  set_self_relation_2: 'Preserve memories and family.',
  set_self_relation_3: 'Let the grave bring more meaning to life going forward.',
  set_self_relation_message: `Important message:`,
  claim_grave_labe: 'I want to be responsible for this grave. Check this box to let us know.',
  claim_grave_terms_1: 'Welcome to Nettgrav.',
  claim_grave_terms_2: `Here, you can claim a safe and respectful grave.`,
  claim_grave_terms_3: `By claiming a Nettgrav, you confirm that you have permission to do this for the deceased.`,
  claim_grave_terms_4: `Usually, this is the owner of the physical grave or their representative. Click “Accept” to continue.`,
  i_agreed_claim: 'I agree to the terms above',
  upload_death_document: 'Upload the death certificate of the person the grave page is for.',
  upload_death_document_limit: 'The document can be in PDF, png, jpg format and less than 5 MB',
  drag_files: 'or Drag and drop the file here',
  'grave.new.docs.header': 'I am the grave owner/leaseholder.',
  'grave.new.docs.upload_title': 'Upload documentation',
  'grave.new.docs.upload_note': 'Format: PDF, PNG or JPG (max 5 MB).',
  'grave.new.docs.button': 'Upload documentation',
  'grave.new.docs.drop_hint': 'Click or drag the file here',
  'grave.new.info.title': 'Care responsibility for the grave.',
  'grave.new.info.line1':
    'When you continue, you confirm that you have the right to care for this grave.',
  'grave.new.info.line2':
    'This usually applies to the person responsible for the physical grave, or someone with authorization.',
  'grave.new.info.line3': 'The documentation is used only for this purpose.',
  'grave.new.accept_label': 'I confirm that I am responsible for this grave',
  'grave.new.create_cta': 'Create grave',
  claim_grave_message: 'Do you have responsibility to care for this grave?',
  claim_grave_document_helper: 'This is only used to confirm responsibility for the grave.',
  claim_guardian_info_title: 'What does care responsibility involve?',
  claim_guardian_info_lead:
    'Being a guardian means taking care of the grave and the community around it.',
  claim_guardian_info_bullet_relations: 'Approve or decline relation requests',
  claim_guardian_info_bullet_content: 'Manage content on the grave',
  claim_guardian_info_bullet_admins: 'Add or remove administrators',
  claim_guardian_info_note: 'Care responsibility is confirmed with documentation.',
  take_ownership: 'Become {firstName}’s guardian',
  manage_grave: 'Manage grave',
  claim_request_queue:
    'Your request to claim the grave to {graveName}, has been successfully submitted. It is now awaiting approval. You will be notified once your request has been reviewed.',
  register_ownership: 'Register ownership',
  public: 'Public',
  moon: 'Moon',
  moon_set: 'Set as my moon',
  moon_remove: 'Remove moon connection',
  moon_remove_as_moon: 'Remove as moon',
  moon_remove_confirm_moon:
    'This removes {username} as your moon. You can add {username} again later.',
  moon_remove_confirm_as_moon:
    'This removes you as moon for {username}. You can choose again later.',
  moon_cancel_request: 'Cancel request',
  moon_ping_cta: 'Send a sign',
  moon_request_sent: 'Moon request sent.',
  moon_request_accepted: 'Moon invitation accepted.',
  moon_request_declined: 'Moon invitation declined.',
  moon_request_page_title: 'Moon invitation',
  moon_request_page_subtitle: '{name} wants you to be their moon.',
  moon_request_sign_in: 'Sign in to respond',
  moon_request_accept: 'Accept',
  moon_request_decline: 'Decline',
  moon_request_already_handled: 'This invitation has already been handled.',
  moon_removed: 'Moon connection removed.',
  moon_ping_sent: 'Signal sent.',
  moon_ping_cta_sent: 'Sign sent',
  moon_ping_sent_hint: 'They are told that you are here for them.',
  moon_ping_cooldown: 'You already gave a sign today. You can send another one in a few hours.',
  moon_helper_text_line_1: 'A moon is someone who has guided you.',
  moon_helper_text_line_2: 'Someone whose light you follow.',
  moon_helper_text: 'A moon is someone who has guided you. Someone whose light you follow.',
  own_words_tab: 'My own words',
  own_words_public_tab: 'Their own words',
  own_words_title: 'My own words',
  own_words_subtitle:
    'A place for what you want others to understand about you while you can talk together.',
  own_words_prompts_title: 'Start with a question',
  own_words_prompt_1: 'What do I hope you understand about me?',
  own_words_prompt_2: 'What gives my life direction?',
  own_words_prompt_3: 'What is difficult to say out loud?',
  own_words_prompt_4: 'What do I need to put into words right now?',
  own_words_placeholder: 'Write in your own words...',
  own_words_visibility_title: 'Who can read this?',
  own_words_visibility_everyone: 'Everyone on Nettgrav',
  own_words_self_only: 'Only you can read this until you choose another visibility.',
  own_words_reader_invitation_title: 'How can the reader meet your words?',
  own_words_reader_invitation_help:
    'Options with private chat show a message button alongside your words.',
  own_words_reader_invitation_listen: 'Just read',
  own_words_reader_invitation_ask: 'Ask me in private chat',
  own_words_reader_invitation_understand_together: 'Understand together in private chat',
  own_words_reader_invitation_keep: 'Keep this safe',
  own_words_publish: 'Share my words',
  own_words_update: 'Update',
  own_words_publish_success: 'Your words have been shared.',
  own_words_publish_needs_words: 'Write something before sharing.',
  own_words_save_error: 'Could not save right now.',
  own_words_public_title: 'In my own words',
  own_words_public_subtitle: 'Words {name} wrote and chose to share.',
  own_words_updated: 'Updated {date}',
  own_words_chat_cta: 'Ask to understand',
  own_words_chat_ask_cta: 'Send private message',
  own_words_chat_understand_cta: 'Understand together',
  own_words_chat_error: 'The conversation could not be opened right now.',
  after_me_tab: 'After me',
  after_me_title: 'After me',
  after_me_subtitle: 'A place to make choices and wishes clearer.',
  after_me_intro_title: 'If I cannot say this myself one day',
  after_me_intro_text: 'You can write little or much. You can change everything later.',
  after_me_step_counter: 'Step {current} of {total}',
  after_me_step_intentions_title: 'What should this give?',
  after_me_step_words_title: 'Something I want others to know',
  after_me_step_legacy_title: 'What should live on?',
  after_me_words_help: 'It does not have to be perfect. Write it in your own words.',
  after_me_writing_prompts_title: 'Start with a question',
  after_me_writing_prompt_1: 'What do I hope you understand about me?',
  after_me_writing_prompt_2: 'What has given my life direction?',
  after_me_writing_prompt_3: 'What do I hope to pass on?',
  after_me_writing_prompt_4: 'What should those closest to me know?',
  after_me_public_tab: 'In their own words',
  after_me_public_title: 'What I want you to know about me',
  after_me_public_subtitle: 'Words written by {name}, and shared on their own terms.',
  after_me_public_intentions_title: 'What I hope this gives',
  after_me_public_legacy_title: 'What I hope to pass on',
  after_me_public_choices_title: 'My choices',
  after_me_public_updated: 'Updated {date}',
  after_me_public_chat_cta: 'Ask to understand',
  after_me_public_chat_error: 'The conversation could not be opened right now.',
  after_me_emotional_context_title: 'Where do these words come from?',
  after_me_emotional_context_help: 'Choose only if it makes your words easier to understand.',
  after_me_emotional_context_vulnerable: 'Vulnerability',
  after_me_emotional_context_grateful: 'Gratitude',
  after_me_emotional_context_hopeful: 'Hope',
  after_me_emotional_context_uncertain: 'Uncertainty',
  after_me_emotional_context_peaceful: 'Peace',
  after_me_reader_invitation_title: 'How would you like to be met?',
  after_me_reader_invitation_help: 'Make it clear how you would like to be met.',
  after_me_reader_invitation_listen: 'Just listen',
  after_me_reader_invitation_ask: 'Ask me',
  after_me_reader_invitation_understand_together: 'Understand together',
  after_me_reader_invitation_keep: 'Keep this safe',
  after_me_public_emotional_context_label: 'These words come from',
  after_me_public_reader_invitation_label: 'I would like to be met with',
  after_me_legacy_help: 'This is optional. It can give direction to those close to you.',
  after_me_step_boundaries_title: 'What do you not want?',
  after_me_step_sharing_title: 'Who should know?',
  after_me_label_visibility: 'Who can see this?',
  after_me_label_activation_mode: 'When should this be visible?',
  after_me_label_intentions: 'What should this give?',
  after_me_label_message_text: 'Something I want others to know',
  after_me_label_grave_choice: 'Grave form',
  after_me_label_ceremony_choice: 'Ceremony style',
  after_me_label_place_choice: 'Preferred place',
  after_me_label_religious_preference: 'Do you want a religious setting?',
  after_me_label_body_title: 'The body',
  after_me_label_body_choice: 'Do you have a preference for cremation or coffin burial?',
  after_me_label_legacy_focus: 'Direction',
  after_me_label_legacy_reason: 'If you want, write one sentence about why.',
  after_me_label_boundaries: 'What do you not want?',
  after_me_visibility_moons: 'Moons',
  after_me_visibility_family_friends: 'Family and friends',
  after_me_visibility_self_only: 'Only me',
  after_me_activation_show_when_deceased: 'Show if others need to make choices on my behalf',
  after_me_activation_visible_now: 'Visible now',
  after_me_intention_calm: 'Calm',
  after_me_intention_clarity: 'Clarity',
  after_me_intention_closeness: 'Closeness',
  after_me_intention_calm_help: 'So your loved ones do not have to guess.',
  after_me_intention_clarity_help: 'So your choices are easy to understand.',
  after_me_intention_closeness_help: 'So what happens can feel real.',
  after_me_choice_unsure: 'Unsure',
  after_me_choice_both: 'Both',
  after_me_grave_choice_physical: 'Physical grave',
  after_me_grave_choice_nettgrav: 'Nettgrav',
  after_me_ceremony_choice_small: 'Small',
  after_me_ceremony_choice_open: 'Open',
  after_me_ceremony_choice_none: 'None',
  after_me_body_choice_cremation: 'Cremation',
  after_me_body_choice_coffin_burial: 'Coffin burial',
  after_me_place_choice_church: 'Church',
  after_me_place_choice_nature: 'Nature',
  after_me_place_choice_home: 'Home',
  after_me_religious_preference_religious: 'Yes',
  after_me_religious_preference_non_religious: 'No',
  after_me_legacy_focus_knowledge: 'Knowledge',
  after_me_legacy_focus_knowledge_help: 'Understanding that can make life clearer and longer.',
  after_me_legacy_focus_health: 'Health',
  after_me_legacy_focus_health_help: 'Work that can help fewer lives end too early.',
  after_me_legacy_focus_care: 'Care',
  after_me_legacy_focus_care_help: 'Dignity and closeness where people are most vulnerable.',
  after_me_legacy_focus_nature: 'Nature',
  after_me_legacy_focus_nature_help: 'The continuity of life and what carries us forward.',
  after_me_legacy_focus_creation: 'Creation',
  after_me_legacy_focus_creation_help: 'What people build, express, and pass on.',
  after_me_legacy_focus_freedom: 'Freedom',
  after_me_placeholder_message_text:
    'Is there anything you want to make clear to those close to you?',
  after_me_placeholder_legacy_reason: 'Write a short sentence…',
  after_me_placeholder_boundaries: 'Sometimes the most important thing is to set a boundary.',
  after_me_status_ready: 'Clear',
  after_me_status_draft: 'Draft',
  after_me_status_ready_hint: 'You can make changes at any time.',
  after_me_save_state_idle: 'Draft',
  after_me_save_state_saving: 'Saving…',
  after_me_save_state_saved: 'Saved',
  after_me_save_state_error: 'Could not save',
  after_me_back: 'Back',
  after_me_next: 'Continue',
  after_me_mark_ready: 'Make clear',
  after_me_update: 'Update',
  after_me_mark_ready_success: 'Saved as clear.',
  after_me_mark_ready_needs_more: 'To make this clear, we need a bit more.',
  after_me_saved_inline: 'Clear version saved',
  after_me_warning_self_only:
    'Only you can see this. Others will not be able to help if something happens.',
  after_me_last_updated: 'Updated {date}',
  after_me_save_error: 'Could not save right now. Try again.',
  after_me_error_visibility_missing: 'Choose who can see this.',
  after_me_error_activation_mode_missing: 'Choose when this should be visible.',
  after_me_error_intentions_missing: 'Choose at least one intention.',
  after_me_error_content_missing: 'Add a few words before making this clear.',
  after_me_error_message_text_too_long: 'The text is too long. Please shorten it a bit.',
  after_me_error_boundaries_text_too_long:
    'The boundaries text is too long. Please shorten it a bit.',
  after_me_error_legacy_reason_too_long: 'The reason text is too long. Please shorten it a bit.',
  after_me_practical_title: 'Simple choices',
  after_me_practical_intro: 'This is not about details. Only what matters most.',
  after_me_boundaries_help: 'Sometimes the most important thing is to set a boundary.',
  private: 'Private',
  relatives: 'Relatives',
  need_subscription: 'You need a subscription to add memories.',
  upgrade_subscription: 'Upgrade Subscription',
  no_memories_added: 'A place for what remains.',
  no_memories_added_with_relation: 'A place for what remains.',
  no_memories_added_ceremony: 'A place for words also now.',
  no_memories_added_with_relation_ceremony: 'A place for words also now.',
  no_memories_added_no_relation_hint:
    'For those who belonged. Choose your relationship to see the grave wall and what lives on.',
  grave_wall_pending_review_hint:
    'Your relationship is registered. The grave wall opens when Nettgrav has approved the grave.',
  input_memory_placeholder: 'Leave a few words here.',
  input_memory_placeholder_ceremony: 'Write when you need to.',
  memory_discard_message: 'Are you sure you want to discard your changes?',
  discard_changes: 'Discard Changes?',
  discard: 'Discard',
  discard_cancel: 'Continue editing',
  post_update_success: 'Post updated successfully',
  post_share_success: 'Post shared successfully',
  post_share_failed: 'Could not share the post. Please try again.',
  post_failed: 'Failed to post. Please try again.',
  company_request_approved: 'Company request approved',
  company_request_declined: 'Company request declined',
  ad_request_approved: 'Ad request approved',
  ad_request_declined: 'Ad request declined',
  spark_comment_create_failed: 'Failed to create comment',
  spark_comment_update_failed: 'Failed to update comment',
  settings_notification_preferences_saved: 'Notification preferences saved',
  file_upload_failed: 'Failed to upload file',
  posting: 'Posting',
  updating: 'Updating',
  edit_post: 'Edit Post',
  update_memory: 'Update',
  create_memory_post: 'Post to grave',
  memory_description_placeholder: 'Leave a few words here.',
  add_photos_videos: 'Add photos/videos',
  click_or_drag_media: 'Click or drag media files here',
  edit_image: 'Edit Image',
  edit_video: 'Edit Video',
  add_caption: 'Add a caption...',
  memory_deleted_success: 'Memory deleted successfully!',
  memory_delete_failed: 'Failed to delete memory.',
  memory_load_failed: 'Could not load the post. Please try again.',
  comments_load_failed: 'Could not load the comments. Please try again.',
  comment_delete_failed: 'Could not delete the comment. Please try again.',
  grave_wall_load_failed: 'Could not load the grave wall',
  grave_wall_load_failed_description: 'Please try again. Your content has not been changed.',
  delete_memory_title: 'Remove from this place?',
  delete_media_confirmation: 'This removes the media from this place. You can add it again later.',
  delete_img_title: 'Remove from this place?',
  delete_memory_content: 'This removes the item from this place. You can add it again later.',
  delete_memory_confirm: 'Remove',
  write_something_or_add_media:
    'A Spark needs something to burn. Share a photo, a memory, or a few words – and let it shine for others.',
  empty_grave_post_warning:
    'A grave post needs something to share. Add a photo, a memory, or a few words – and let it live for others.',
  empty_memory_post_warning:
    "You haven't written anything yet. Share some words, thoughts, or memories before you post.",
  add_to_your_post: 'Add image or video',
  memory_review: 'Memory Preview',
  grave_wall: 'Grave wall',
  grave_ceremony_title: 'Death notice and ceremony',
  grave_ceremony_death_notice_section: 'Death notice',
  grave_ceremony_ceremony_section: 'Ceremony',
  grave_ceremony_edit: 'Edit',
  grave_ceremony_subtitle_ready: 'Time and place, when ready.',
  grave_ceremony_subtitle_empty: 'Add time and place when ready.',
  grave_ceremony_published_by: 'This information was shared by {name}',
  grave_ceremony_published_by_relation: '{relation} of {graveName}',
  grave_ceremony_updated_at: 'Updated {dateTime}',
  grave_ceremony_when: 'When',
  grave_ceremony_where: 'Where',
  grave_ceremony_place_of_death: 'Place of death',
  grave_ceremony_message: 'Announcement',
  grave_ceremony_save: 'Save',
  grave_ceremony_not_set: 'Not set',
  grave_ceremony_saved: 'Ceremony information saved.',
  grave_ceremony_save_failed: 'Could not save right now.',
  grave_ceremony_attendance_coming: 'Coming',
  grave_ceremony_attendance_unsure: 'Unsure',
  grave_ceremony_attendance_not_coming: 'Cannot come',
  grave_ceremony_attendance_summary: 'Responses',
  grave_ceremony_attendance_prompt: 'Can you attend the ceremony?',
  grave_ceremony_response_saved: 'Your response has been saved.',
  grave_ceremony_response_failed: 'Could not save your response right now.',
  grave_ceremony_copy_link_failed: 'Could not copy the link right now.',
  grave_ceremony_redirecting: 'Opening the death notice on the grave page…',
  grave_ceremony_timing_pending: 'Time and place are not set yet',
  grave_ceremony_responses_title: 'Who is coming',
  grave_ceremony_share_link: 'Share the death notice',
  grave_ceremony_link_copied: 'Death notice link copied',
  grave_ceremony_responses_empty: 'No responses yet.',
  grave_ceremony_responses_load_failed: 'Could not load the response list right now.',
  grave_ceremony_move_to_anniversaries: 'Move to memorial days now',
  grave_ceremony_move_to_anniversaries_saved: 'Moved to memorial days.',
  grave_ceremony_move_to_anniversaries_failed: 'Could not move right now.',
  create_grave_ceremony_visibility_notice:
    'The death notice is published on the grave wall and can be shared with others. You can edit the information later.',
  life_archive_menu: 'Life archive',
  media: 'Media',
  connect_grave: 'Connect Grave',
  upgrade_plan_modal: 'Upgrade Your Plan',
  more: 'More',
  about_name: 'Name',
  about_gender: 'Gender',
  relations: 'Relations',
  about_birthplace: 'Birthplace',
  about_nickname: 'Nickname',
  about_birth_name: 'Birth name',
  about_death_location: 'Death location',
  about_cemetery: 'Cemetery',
  about_birthday: 'Day of birth',
  about_death_date: 'Day of death',
  about_relations: 'Relations',
  about_cause_of_death: 'Cause of death',
  about_country: 'Country',
  about_title: 'About',
  about_privacy: 'Visibility',
  buried: 'Buried',
  edit_grave_details: 'Edit Grave Details',
  relationships: 'Relationships',
  grave_people_tab_label: 'Those who belong',
  grave_people_title: 'Those who belong',
  grave_people_title_with_name: 'Those who were close to {name}',
  grave_people_subtitle_with_name: 'These are the people who were part of the life of {name}.',
  work: 'Work',
  announcements: 'Death notices',
  grave_link: 'Together with',
  grave_link_header: '{graveName}, your {relation}, is connected with',
  Søndag: 'Sunday',
  Mandag: 'Monday',
  Tirsdag: 'Tuesday',
  Onsdag: 'Wednesday',
  Torsdag: 'Thursday',
  Fredag: 'Friday',
  Lørdag: 'Saturday',
  placeholder_name: 'Enter name',
  placeholder_nickname: 'Enter nickname',
  placeholder_birth_name: 'Enter birth name',
  placeholder_birthplace: 'Enter birthplace',
  placeholder_death_location: 'Enter death location',
  placeholder_gender: 'Select gender',
  placeholder_country: 'Select country',
  placeholder_municipality: 'Select municipality',
  placeholder_cemetery: 'Select cemetery',
  placeholder_cause_of_death: 'Select cause of death',
  placeholder_privacy: 'Select visibility',
  placeholder_date_of_birth: 'Select date of birth',
  placeholder_time_of_birth: 'Select time of birth',
  placeholder_date_of_death: 'Select date of death',
  placeholder_time_of_death: 'Select time of death',
  grave_owner: 'grave owner',
  admin: 'admin',
  edit_relation: 'Edit relation',
  remove_member: 'Remove member',
  confirm_delete_user_title: 'Are you sure?',
  confirm_button: 'Remove',
  cancel_button: 'Keep',
  confirm_delete_message:
    'This will remove {username} as a family member. You can add {username} again later.',
  confirm_remove_member_self_title: 'Leave this grave?',
  confirm_remove_member_self_message: 'You will lose access now, but you can reconnect later.',
  confirm_remove_member_other_title: 'Remove {username} from this grave?',
  confirm_remove_member_other_message:
    '{username} will lose access now, but can be invited again later.',
  relation_to_buried: 'Buried relation to you',
  relation_to_user: 'Your relation to the buried',
  role_required: 'Please select a role',
  relation_required: 'Please select a relation',
  direction_required: 'Choose the relation direction.',
  relation_you_are_prefix: 'You are',
  relation_you_are_suffix: 'to {name}',
  relation_they_are_prefix: '{name} is your',
  invitation_relation_you_are_prefix: 'The invited person is',
  invitation_relation_you_are_suffix: 'to {name}',
  invitation_relation_they_are_prefix: '{name} is their',
  invite_family_member: 'Invite someone',
  grave_people_invite_button: 'Give family access',
  email_required: 'Please enter a email',
  email_required_validation: 'Please enter a valid email address',
  name_required: 'Please enter a name',
  pending_invitations: 'Pending Invitations',
  find_grave_member: 'Search relations',
  grave_people_pending_invitations: 'Pending invitations',
  grave_people_search_placeholder: 'Find a person',
  grave_people_search_failed: 'Could not search for people. Please try again.',
  grave_people_search_empty_title: 'No matches',
  grave_people_search_empty_message: 'Try another name.',
  grave_invitations_load_failed: 'The invitations could not be loaded.',
  relation_requests_load_failed: 'The relation requests could not be loaded.',
  relation_request_update_failed: 'The relation request could not be updated.',
  grave_invitation_sent: 'The invitation has been sent.',
  grave_invitation_updated: 'The invitation has been updated.',
  find_invited_user: 'Find someone you have invited',
  find_workplace: 'Find workplace',
  add_workplace: 'Add workplace',
  company_name_label: 'Company Name',
  company_name_placeholder: 'Enter company name',
  company_name_required: 'Add company name.',
  city_label: 'City',
  city_placeholder: 'Enter city',
  city_required: 'Add city.',
  position_label: 'Position',
  position_placeholder: 'Enter position',
  position_required: 'Add position.',
  start_year_label: 'Start Year',
  start_year_placeholder: 'Select start year',
  start_year_required: 'Choose start year.',
  end_year_label: 'End Year',
  end_year_placeholder: 'Select end year',
  end_year_required: 'Choose end year.',
  description_label: 'Description',
  description_placeholder: 'Enter job description',
  publicPrivacy_label: 'Privacy',
  publicPrivacy_placeholder: 'Select privacy setting',
  publicPrivacy_required: 'Choose privacy selection.',
  invalid_end_date: 'Invalid End Date',
  invalid_end_date_message: `End date comes after the start date.`,
  no_workplaces_added: 'Places that belonged to life.',
  add_workplaces_message: 'Choose your relationship to add workplaces that mattered.',
  add_workplaces_message_member: 'Here you can add where the person worked throughout life.',
  no_invitations_sent: 'Share the grave with your closest ones',
  no_invitations_message: 'Invite family and friends to be present — when it suits them.',
  grave_people_empty_title: 'No pending invitations',
  grave_people_empty_message: 'Invitations you send appear here until they are answered.',
  grave_relation_responsible: 'Has responsibility',
  grave_people_owner_tag: 'Holds the grave',
  photos: 'Album',
  find_interests: 'Find interests',
  add_interest: 'Add interest',
  interest_name: 'Interest Name',
  interest_name_placeholder: 'Enter interest name',
  interest_name_required: 'Add interest name.',
  interest_category: 'Category',
  interest_category_placeholder: 'Select a category',
  interest_category_required: 'Choose category.',
  interest_description: 'Description',
  interest_description_placeholder: 'Enter description',
  interest_description_required: 'Add description.',
  confirm_delete_workplace_message:
    'This will remove the workplace. You can add the workplace again later.',
  confirm_delete_interests_message:
    'This will remove the interest. You can add the interest again later.',
  confirm_delete_payment_method_message:
    'This will remove this payment method. You can add another one later.',
  no_interests_added: 'What brought joy, calm, or curiosity.',
  add_interests_message: 'Choose your relationship to share interests that belonged to life.',
  add_interests_message_member:
    'Here you can share what caught their curiosity, inspired them, or simply made them smile.',
  add_passion: 'Add passion',
  confirm_delete_passion_message:
    'This will remove the passion from this place. You can add the passion again later.',
  confirm_delete_gift_message:
    'This will remove this gift from this place. You can add the gift again later.',
  passion_description: 'Passion Description',
  passion_description_placeholder: 'Enter passion description',
  passion_description_required: 'Add passion description.',
  no_passion_added: 'What gave energy and meaning.',
  add_passion_message: 'Choose your relationship to add passions that meant a lot.',
  add_passion_message_member:
    'Add what they truly cared about – what gave them energy, meaning, or joy.',
  no_grave_linked: 'Connections give context.',
  add_grave_linked_message:
    'Show how {firstName} connects with their family. Link {firstName} to those who matter – wherever the graves are.',
  grave_link: 'Together with',
  grave_link_empty_primary: 'Some graves belonged together in life.',
  grave_link_empty_secondary: 'Here they can stand together — no matter where they are buried.',
  grave_link_empty_tertiary: 'Choose your relationship to connect them on Nettgrav.',
  grave_link_empty_image_alt: 'Two graves connected together',
  grave_link_open_grave: 'Open the grave for {name}',
  grave_link_more_actions: 'More actions for the grave connection',
  grave_link_removed: 'The grave connection has been removed.',
  grave_link_remove_failed: 'We could not remove the connection. Please try again shortly.',
  grave_link_updated: 'The grave connection has been updated.',
  photo_albums_manage: 'Edit collection',
  upload_photo: 'Upload photo',
  photo_uploading_title: 'Uploading photos',
  photo_album_system_name: 'Collected photos',
  photo_album_images_count: '{count, plural, one {# photo} other {# photos}}',
  photo_album_empty_count: 'No photos here yet',
  photo_tagging_label: 'Also show on other graves',
  photo_tagging_placeholder: 'Choose graves',
  photo_tagged_section_title: 'Photos shared with other graves',
  photo_tagged_source: 'Also on the grave of {graveName}',
  photo_tagged_open_original: 'See original',
  photo_upload_progress: 'Uploading {completed} of {total}',
  photo_upload_partial_failure:
    '{successCount} photos uploaded, {failedCount} failed. You can try again.',
  photo_album_delete_confirm_title: 'Delete album?',
  photo_album_delete_confirm_body: 'Photos are not deleted. They are moved to Collected photos.',
  photo_album_delete_confirm_body_with_images:
    'The photos will still be available in Collected photos.',
  photo_album_delete_confirm_body_empty: 'This album is empty and will be deleted.',
  photo_album_delete_confirm_action: 'Delete album',
  photo_delete_image_title: 'Remove image?',
  photo_delete_image_content:
    'The image will be removed from this grave. You can add it again later.',
  photo_delete_failed: 'The image could not be removed. Please try again.',
  grave_photos_loading: 'Loading photos',
  grave_photos_load_failed: 'Could not load the photos',
  grave_photos_load_failed_description: 'Please try again. Your content has not been changed.',
  grave_photos_retry: 'Try again',
  grave_photos_load_more: 'Show more photos',
  grave_photos_load_more_failed: 'Could not load more photos.',
  photo_albums_load_failed: 'Could not load the album collection.',
  grave_photo_alt: 'Photo at the grave of {name}',
  photo_comment_action_failed: 'Could not save the comment. Please try again.',
  photo_comment_delete_title: 'Delete the comment?',
  photo_comment_delete_content: 'The comment will be permanently removed.',
  photo_move_to_album: 'Move to album',
  photo_move_to_album_title: 'Move image to album',
  photo_move_to_album_placeholder: 'Choose album',
  no_photos_added: 'Photos can gather here over time.',
  add_photos_message: 'When a photo is added, it becomes part of the story.',
  album_empty_primary: 'Photos that gather over time.',
  album_empty_album_title: 'No photos here yet',
  album_empty_album_message: 'When a photo is added, it becomes part of the story.',
  album_empty_secondary: 'Choose your relationship to add photos and see more of the story.',
  album_empty_cta: 'Connect to {firstName}',
  select_cover_photo: 'Select cover photo',
  add_photos: 'Add photos',
  choose_cover_photo: 'Choose cover image',
  adjust_cover_position: 'Adjust position',
  upload_image: 'Add image',
  remove_image: 'Remove from cover',
  remove_grave_avatar: 'Remove profile image',
  grave_avatar_removed: 'Profile image removed.',
  grave_avatar_remove_failed: 'Could not remove profile image.',
  edit_profile_photo: 'Edit profile photo',
  edit_cover_image: 'Edit grave cover image',
  add_cover_photo: 'Add cover photo',
  edit: 'Edit',
  upload_photos: 'Upload Photos',
  label_description: 'Description',
  placeholder_description: 'Enter description',
  label_address: 'Address',
  placeholder_address: 'Enter address',
  date_time: 'Date and Time',
  create_anniversary: 'Create Memorial Day',
  edit_anniversary: 'Edit Memorial Day',
  add_life_event: 'Add Story',
  no_events_added: '{firstName}’s book holds the stories that belong to {firstName}’s life.',
  life_events_empty_primary: "Here, life's stories can have a place.",
  life_events_empty_secondary:
    'Connect to the grave if you would like to contribute memories and stories.',
  life_events_empty_cta: 'Connect to {firstName}',
  add_events_message:
    'Here you can share memories, moments, and words that show who {firstName} was.',
  life_events_load_failed: 'The life story could not be loaded.',
  life_events_load_failed_description: 'Please try again. Your content has not been changed.',
  try_again: 'Try again',
  life_event_media_update_failed: 'The image could not be updated. Please try again.',
  life_event_media_delete_failed: 'The media could not be removed. Please try again.',
  event_label_name: 'Title of the story',
  event_placeholder_name: 'Enter story title',
  event_required_name: 'Add story title.',
  event_label_date: 'Date of the story',
  event_placeholder_date: 'Select story date',
  event_required_date: 'Choose story date.',
  event_label_theme: 'Choose a theme',
  event_placeholder_theme: 'Select theme',
  event_required_theme: 'Choose theme.',
  event_label_country: 'Country',
  event_placeholder_country: 'Select country',
  event_required_country: 'Choose country.',
  event_theme_selected: 'Selected color:',
  event_label_description: 'Story text',
  event_placeholder_description: 'Write the story here',
  event_required_description: 'Choose story text.',
  event_theme_light: 'Light Theme',
  event_theme_dark: 'Dark Theme',
  create_event: 'Create Story',
  create_event_grave_info: "Add a life event to {graveName}'s grave.",
  edit_event: 'Edit Story',
  show_all: 'Show All',
  set_as_cover: 'Set as cover',
  creator: 'Creator',
  previous: 'Previous',
  view_more_events: 'View More Life Stories',
  view_more: 'View More',
  connect_grave_title: 'Graves you can connect to {graveName}',
  connect_grave_select_title: 'Choose the grave to connect',
  connect_grave_relations_title: 'Set relations',
  connect_grave_relation_subject: '{name} is',
  connect_grave_relation_object: 'to {name}',
  connect_grave_confirm: 'Link the graves',
  connect_grave_section_direct: 'Your graves',
  connect_grave_section_other: 'Other relevant',
  link_to_grave: 'Link to this grave',
  your: 'Your',
  graves_not_found: 'No graves available at the moment.',
  connect_grave_empty_title: 'There are no other graves here yet',
  connect_grave_empty_message: 'When you get access to more, you can connect them together.',
  connect_grave_load_failed: 'We could not load the graves right now.',
  share: 'Share',
  linked_copied: 'Link copied to clipboard',
  share_memory: 'Share Memory ',
  copy_link: 'Copy link',
  media_not_added: 'No media added yet.',
  delete_event_title: 'Confirm deletion of the Story?',
  grave_is_private_title: '{graveName}’s Grave is Private',
  grave_is_private_message:
    'Only close relatives can view memories, life stories, and other shared content on this grave.',
  grave_relations_private_title: 'Relations are private',
  grave_relations_private_message:
    'Since this grave is private, relations are only visible to close relatives.',
  grave_user_not_found_message:
    'Relations gather around {firstName}. Start with yourself, and add those who matter.',
  grave_user_not_found_message_primary: 'Relations gather around {firstName}.',
  grave_user_not_found_message_secondary: 'Start with yourself, and add those who matter.',
  grave_relations_empty_primary: 'Here you see who belongs.',
  grave_relations_empty_secondary:
    'Connect yourself to the grave to see who belongs around {firstName}.',
  grave_relations_empty_cta: 'Connect to {firstName}',
  connect_with_grave: 'Choose your relation to {graveName}',
  join_set_relation_free: 'Choose your relation to {firstName}',
  join_sheet_title: 'Choose your relation to {name}',
  join_sheet_intro: 'A personal space for closeness to {name} – available whenever you want.',
  join_sheet_auth_title: 'Sign in to continue',
  join_sheet_auth_intro: 'Sign in to react, add a reflection, or write a comment.',
  join_sheet_intent_react_title: 'Sign in to react to sparks',
  join_sheet_intent_react_intro: 'When you are signed in, you can react and take part.',
  join_sheet_intent_weekly_question_title: "Sign in to answer this week's question",
  join_sheet_intent_weekly_question_intro:
    'When you are signed in, you can publish your own spark.',
  join_sheet_intent_reflect_title: 'Sign in to add a reflection',
  join_sheet_intent_reflect_intro: 'When you are signed in, you can share your reflection.',
  join_sheet_intent_composer_title: 'Sign in to write a comment',
  join_sheet_intent_composer_intro: 'When you are signed in, you can join the conversation.',
  join_sheet_intent_submit_title: 'Sign in to publish your comment',
  join_sheet_intent_submit_intro: 'When you are signed in, your comment can be shared.',
  guest_quota_notice_title: 'More searches today',
  guest_quota_notice_body: 'To keep searching today, log in or create an account.',
  please_sign_in_to_continue: 'Sign in to continue.',
  join_sheet_subtitle: 'A place for closeness to {name}.',
  join_sheet_name_fallback: 'the people you care about',
  connect_grave_message: `Set your relation with a loved one. This feature is part of our Premium Subscription. To access this and other exclusive features, please upgrade your plan.`,
  cancel_relation_request: 'Cancel relation request',
  cancel_claim_request: 'Cancel claim request',

  grave_welcome_title: 'Welcome to the grave of {name}.',
  grave_intro_text: 'Here you can read, reflect, share stories, or simply be still.',
  grave_natural_feelings_text:
    'It’s natural to think about your own life and losses when you visit a grave. That’s perfectly okay. You are not alone.',
  grave_what_you_can_do_title: 'What you can do here:',
  grave_read_stories: 'Read stories and memories',
  grave_react_comment_care: 'React and comment',
  grave_share_reflections: 'Share your own reflections',
  grave_light_candle: 'Be close on anniversaries, and invite others who knew the departed',
  grave_why_nettgrav_matters_title: 'Nettgrav mission',
  grave_support_end_of_time_center:
    'Each Nettgrav supports the work of the End Of Time Center, striving for a healthier world where fewer people die from disease.',
  grave_team_end_of_time_message:
    'At Nettgrav you can also read messages from our partners — companies that want to do more for you and contribute to a better world.',
  grave_enter_grave_button: 'Close',

  my_light_welcome_title: 'My Light',
  my_light_you_are_the_light: 'You are the light.',
  my_light_intro_text: 'This is your space.',
  my_light_sparks_relationships_graves: 'Here will come solutions for what matters.',
  my_light_what_you_find_here_title: 'Everything built here aims to support good social lives.',
  my_light_sparks: 'With strength, care, and human closeness at the center.',
  my_light_graves: 'This is a place for you.',
  my_light_loved_ones: 'For what you carry, and what you want to pass on.',
  my_light_everything_begins_with_you: 'More will come.',
  my_light_enter_button: 'Got it',
  my_light_profile_occupation_label: 'Occupation or role',
  my_light_profile_occupation_placeholder: 'What do you do?',
  my_light_profile_bio_label: 'About me',
  my_light_profile_bio_placeholder: 'Write a few lines about yourself',
  compass_tab: 'My compass',
  compass_title: 'My compass',
  compass_title_other: 'How {name} stays on course',
  compass_subtitle: 'What I try to live by.',
  compass_empty_lead: 'Some choose to write down the direction they want to hold on to.',
  compass_empty_copy: 'It can make both life and relationships clearer.',
  compass_empty_cta: 'Write My compass',
  compass_help_primary: 'Write it as it is for you.',
  compass_label_pressure_pattern: 'What pulls me off course',
  compass_nav_pressure_pattern: 'Off course',
  compass_help_pressure_pattern: 'What tends to make you lose direction?',
  compass_placeholder_pressure_pattern: 'When I want to be liked more than honest.',
  compass_label_anchor_statement: 'What is non-negotiable for me',
  compass_nav_anchor_statement: 'Non-negotiable',
  compass_help_anchor_statement: 'What I do not compromise on.',
  compass_placeholder_anchor_statement: "I don't lie to myself.",
  compass_label_choice_question: 'The question that keeps me on course',
  compass_nav_choice_question: 'My question',
  compass_help_choice_question: 'One question before important choices.',
  compass_placeholder_choice_question: 'Is this true, or just safe?',
  compass_label_known_for: 'How you notice I am off course',
  compass_nav_known_for: 'How you notice',
  compass_help_known_for: 'What others can recognize.',
  compass_placeholder_known_for: 'I become quiet and pull away.',
  compass_label_growth_edge: 'How I find my way back',
  compass_nav_growth_edge: 'How I return',
  compass_help_growth_edge: 'What helps you return to direction?',
  compass_placeholder_growth_edge: 'I need stillness and one honest conversation.',
  compass_label_visibility: 'Visibility',
  compass_visibility_self_only: 'Only me',
  compass_visibility_moons: 'Moons',
  compass_visibility_family_friends: 'Family and friends',
  compass_visibility_public: 'Public',
  compass_visibility_shown_for: 'Visible for: {visibility}',
  compass_visibility_owner_hint:
    'This is how your compass is shown to others based on your visibility choice.',
  compass_visibility_reason_family_friends:
    'You see this because you are registered as family or friend.',
  compass_visibility_reason_moons: 'You see this because you are registered as a moon.',
  compass_visibility_reason_public: 'You see this because the compass is shared publicly.',
  compass_visibility_reason_default: 'Visibility is controlled by the owner.',
  compass_safety_hint: 'Your compass can change as life changes.',
  compass_share_nudge: 'Do you want to share your compass with close people?',
  compass_share_nudge_moons: 'Share with moons',
  compass_share_nudge_family: 'Share with family and friends',
  compass_share_nudge_public: 'Share publicly',
  compass_step_indicator: 'Field {current} of {total}',
  compass_step_counter: '{current}/{total}',
  compass_summary_title: 'How I stay on course',
  compass_prev: 'Previous',
  compass_prev_alt: '← Previous',
  compass_prev_to: '← To {label}',
  compass_next: 'Continue',
  compass_next_alt: 'Next →',
  compass_next_to: 'To {label} →',
  compass_save: 'Save',
  compass_saving: 'Saving...',
  compass_saved: 'Saved',
  compass_save_error: 'Could not save right now.',
  compass_signal_cta: 'Thanks for sharing',
  compass_signal_sent: 'Sign sent',
  compass_signal_sent_to: 'Thanks sent to {name}',
  compass_signal_toast_sent: 'Thanks sent.',
  compass_signal_error: 'Could not send thanks right now.',
  compass_signal_hint: 'A quiet thanks for sharing their compass. It is not shown publicly.',
  compass_signal_sent_hint: 'It is only shown to {name}.',
  compass_signal_guest_hint: 'Sign in to let them know you were here.',
  compass_signal_guest_cta: 'Sign in',
  compass_can_change: 'You can change this at any time.',
  compass_shared_none: 'No compass shared yet.',
  my_light_profile_cancel: 'Close',
  my_light_profile_save: 'Save',
  my_light_about_title: 'About me',
  conversation_starters_tab_self: 'Ask me about',
  conversation_starters_tab_other: 'Ask {name}',
  conversation_starters_title_self: 'Ask me about',
  conversation_starters_title_other: 'Ask {name}',
  conversation_starters_subtitle: 'Some conversations only need a place to begin.',
  conversation_starters_placeholder: 'Write something others can ask you about',
  conversation_starters_suggestion_1: 'why I',
  conversation_starters_suggestion_2: 'how I',
  conversation_starters_suggestion_3: 'what I learned when',
  conversation_starters_suggestion_4: 'what made me',
  conversation_starters_visibility_label: 'Who can see this?',
  conversation_starters_visibility_everyone: 'Everyone',
  conversation_starters_visibility_moons: 'Moons',
  conversation_starters_visibility_family_friends: 'Family and friends',
  conversation_starters_visibility_self_only: 'Only me',
  conversation_starters_add: 'Add',
  conversation_starters_ask: 'Ask {name}',
  conversation_starters_chat_draft: 'Hi {name}. You wrote that I can ask you about “{starter}”.',
  conversation_starters_empty: 'Add something that can open a good conversation.',
  conversation_starters_save_error: 'The conversation starter could not be saved right now.',
  conversation_starters_delete_error: 'The conversation starter could not be deleted right now.',
  conversation_starters_chat_error: 'The conversation could not be opened right now.',
  day_title: 'Today',
  day_subtitle: 'Something to consider, someone to understand, and something to preserve.',
  day_reflection_label: 'A thought for today',
  day_reflection_1: 'What have you come to understand differently over time?',
  day_reflection_2: 'Which question is staying with you right now?',
  day_reflection_3: 'What do you wish more people were curious about?',
  day_reflection_4: 'What has another person taught you without knowing it?',
  day_reflection_5: 'What does closeness mean to you today?',
  day_reflection_action: 'Go to Create Spark',
  day_connection_label: 'Understand together',
  day_connection_title: '{name} has shared something they want to understand with others.',
  day_connection_empty_title: 'Is there something you want to understand with others?',
  day_connection_empty_text:
    'Share it in your own words and choose whether Nettgrav may help new people find it.',
  day_connection_action: 'Read and understand together',
  day_connection_empty_action: 'Share in your own words',
  day_preserve_label: 'Preserve',
  day_preserve_title: 'Is there a photo with a story only you know?',
  day_preserve_action: 'Go to your graves',
  own_words_discovery_title: 'Let Nettgrav connect me with new people',
  own_words_discovery_help:
    'These words may appear in Today for people you do not know. You can turn this off at any time.',
  my_light_about_subtitle: 'A few words about me, as life feels now.',
  my_light_questions_title: 'Three questions',
  my_light_question_1: 'What matters most to me in life right now?',
  my_light_question_2: 'What gives me calm, meaning, or energy in everyday life?',
  my_light_question_3: 'What am I learning about myself?',
  spark_energy_tooltip: 'Your Spark makes the world a better place.',

  grave_support_title: 'What does this grave support?',
  grave_support_intro: 'Each Nettgrav is a part of something bigger.',
  grave_support_body:
    'This grave supports the End Of Time Center – a science center with one radical vision: A world without death.',
  grave_support_help:
    'Together we seek answers to why we die, and how insight from death can help us live more deeply and compassionately – for ourselves and for each other.',
  grave_support_read_more: 'Read more about End Of Time Center.',
  end_of_time_center_title: 'End Of Time Center',
  end_of_time_center_intro:
    'Nettgrav is the first product from The End Of Time Corporation. We plan to establish the End Of Time Center – a science center for research on life and death, with a radical goal: To understand death and create a future where no one needs a grave.',
  end_of_time_center_body:
    "Here, researchers, visionaries and problem solvers will gather to develop knowledge, solutions and new perspectives on life's biggest questions. Together we seek insight and inspiration that can make the world safer, warmer – and maybe a bit more eternal.",
  end_of_time_center_close: 'Close',
  about_this_grave: 'About this grave',
  my_light: 'My Light',
  relation_confirmation_label: 'Auto confirm relation',
  auto_confirm_on: 'Automatic',
  auto_confirm_off: 'Require Approval',
  relation_requests: 'Relation Requests',
  connection_request_sent_info:
    'Your connection request has been sent to the owner of {graveName}. Once approved, the grave will appear in your linked graves.',
  connection_request_sent: 'Connection request sent.',
  connection_created_unverified:
    'The grave connection was created without verification from a grave manager.',
  connection_request_failed: 'Could not send connection request. Please try again later.',
  linked_grave_unverified_status: 'Not verified by a grave manager',
  grave_already_connected: '{graveName} is already connected',
  is_grave_already_connected: 'Is this grave already connected?',
  take_grave_ownership: 'Do you want to become the owner of this grave?',
  grave_privacy_public:
    'This grave is public. Anyone can see and interact with the public content.',
  grave_privacy_private:
    'This grave is private. Only invited grave users can see the content. Other users cannot see anything.',
  grave_privacy_relatives:
    'This grave is set to relatives. Relatives can see both relatives and public content. Other users can only see the public content.',
  please_fill_all_fields: 'Please fill all required fields',
  grave_invitations: 'Grave invitations',
  'relationships.manageInvites': 'Invite family and friends',
  invite_you_as: 'invite you as',
  grave_invitation: 'Grave Invitation',
  grave_invitations_not_found_title: 'No Invitations Found',
  grave_invitations_not_found_subtile:
    'You haven’t received any grave invitations yet. When someone invites you to a grave, you’ll see it here.',
  invited_you_to_grave: '{name} invited you to the grave',
  search_by_name: 'Search by name',
  confirm_delete_linked_grave_message:
    'This will remove the link to this grave. You can link the grave again later.',
  search_grave_placeholder: 'Search by name',
  search_open: 'Open search',
  search_open_full: 'Search',
  search_submit: 'Search',
  clear_search: 'Clear search',
  close_search: 'Close search',
  search_grave_heading: "Find the grave you're looking for",
  search_grave_intro: 'Search by name, or filter further.',
  search_all_heading: 'Find people and graves',
  search_all_intro: 'Search for a person or grave by name.',
  search_all_placeholder: 'Search for people and graves',
  search_people_heading: 'Find the person you are looking for',
  search_people_intro: 'Search by name to find people.',
  search_people_placeholder: 'Search for people',
  search_grave_guest_cta_title: 'When you find the right grave',
  search_grave_guest_cta_body: 'you can connect to it, leave a sign, and follow along over time.',
  search_grave_guest_cta_button: 'Create account',
  search_grave_loading_title: 'We are fetching the grave...',
  search_grave_loading_subtitle: 'This usually takes under a second.',
  search_all_loading_title: 'We are fetching the results...',
  search_all_loading_subtitle: 'This usually takes under a second.',
  search_people_loading_title: 'We are fetching the members...',
  search_people_loading_subtitle: 'This usually takes under a second.',
  search_grave_none_subtext: `No one should be left without a place to be remembered and stay close. Create a Nettgrav you can walk forward with – completely free.`,
  search_grave_none_text: 'No results found for',
  search: 'Search',
  search_grave_perfect_matches: 'Could this be the one you’re looking for?',
  search_grave_filter_heading: 'Filter by country, municipality, and cemetery',
  search_grave_show_filters: 'Show more search options',
  search_grave_hide_filters: 'Hide search options',
  search_grave_image_heading: 'Search for graves to get started.',
  search_grave_image_subtitle: 'Who are you looking for today?',
  search_grave_search_for: 'Results for',
  search_grave_no_relation_hint:
    'You can visit the grave now. When you choose a relation, it becomes part of your space here.',
  search_grave_visit_cta: 'Visit grave',
  grave_invitation_email: 'Email address',
  grave_invitation_email_placeholder: 'Enter email address',
  grave_invitation_email_required: 'Add email.',
  grave_invitation_email_required_validation: 'Please enter a valid email',
  grave_invitation_invited_person_name: 'Name',
  grave_invitation_invited_person_name_placeholder: 'Enter name',
  grave_invitation_name_required: 'Add name.',
  grave_invitation_relation_to_grave: 'Their relationship',
  grave_invitation_relation_to_grave_modal: "The invited person's relation to {graveName}",
  grave_invitation_relation_to_grave_help:
    'Set the relationship as the invited person will see it.',
  grave_invitation_relation_required: 'Choose relation.',
  grave_invitation_select_relationship: 'Choose how you are connected',
  grave_invitation_select_relationship_short: 'Choose relation',
  grave_invitation_relation_to_person: 'How they see {graveName}',
  grave_invitation_relation_to_person_modal: "{graveName}'s relation to the invited person",
  grave_invitation_relation_to_person_help: "This appears from the invited person's point of view.",
  grave_invitation_select_reciprocal: 'Choose a relation (for example parent or sibling)',
  grave_invitation_direction_required: 'Choose relation direction.',
  grave_invitation_administrator_access: 'Administrator Access',
  grave_invitation_role_required: 'Choose role.',
  grave_invitation_administrator: 'Administrator',
  grave_invitation_normal: 'Normal',
  anniversary_create_name: 'Name',
  anniversary_create_placeholder_name: 'Enter name',
  anniversary_create_date_time: 'Date',
  anniversary_create_name_required: 'Please enter name',
  anniversary_create_date_time_required: 'Please pick a date',
  anniversary_create_date_hint: 'Can be changed later.',
  anniversaries_create_title: 'Add a memorial day',
  anniversaries_create_hint: 'For gatherings, visits, or a day that matters to you.',
  spark_create_modal_category: 'Spark category:',
  spark_suggestions_label: 'Some good inspiration:',
  spark_category_question: 'question',
  spark_category_insight: 'insight',
  spark_category_experience: 'experience',
  spark_category_discovery: 'discovery',
  spark_category_emotion: 'emotion',
  spark_category_value: 'value',
  spark_category_energy: 'energy',
  spark_category_intention: 'intention',
  spark_category_Story: 'Story',
  spark_category_Feeling: 'Feeling',
  edit_spark: 'Edit Spark',
  share_spark: 'Share the Spark',
  extinguish_park: 'Extinguish Spark',
  spark_info_title: 'What is my Spark?',
  spark_info_intro:
    'A Spark begins within you. It can be a thought, a question, an experience, or something that makes you pause and notice what you feel. When you share it, it can awaken reflection, connection, or action in others.',
  spark_examples_title: 'Examples of a Spark',
  spark_example_question: "A question you're wondering about.",
  spark_example_insight: 'An insight you have gained.',
  spark_example_experience: 'An experience that moved you.',
  spark_example_value: 'A value you want to highlight.',
  spark_form_info:
    'Choose the form of your spark. It shows others how you wish to share your truth – as a question, story, insight, feeling or intention.',
  spark_why_title: 'Why create a Spark?',
  spark_why_inspire: 'To inspire others.',
  spark_why_express: 'To put words to what you think and feel.',
  spark_why_share: 'To share something meaningful to you.',
  spark_why_build: 'To build a warmer and more open community.',
  spark_how_title: 'How to create a Spark?',
  spark_how_step1: 'Write a thought, a question, or share a feeling.',
  spark_how_step2: 'Choose category: Question, Insight, Experience, Value, Feeling, Energy.',
  spark_how_step3: 'Publish – and let your spark shine for others!',
  spark_helper_text:
    'Share your spark—ask a question, voice a thought or feeling. Even small words can bring light to others.',
  spark_show_inspirations: 'Get inspired – fetch a question',
  spark_get_question: 'Fetch a question',
  spark_selected_question: 'What is your Spark?',
  spark_change_question: 'Change question',
  spark_optional_helper: 'Your contribution can ignite others.',
  spark_textarea_label: 'What sparks something in you?',
  'sparks.media.limits': 'Up to 5 photos or videos. Maximum 50 MB per file.',
  'sparks.media.tooMany': 'You can add up to 5 photos or videos.',
  'sparks.media.tooLarge': '{name} is larger than 50 MB.',
  'sparks.media.invalidType': '{name} is not a supported photo or video format.',
  spark_reflection_label: 'Add your spark in response.',
  spark_menu_button: 'Spark menu',
  spark_share_button: 'Share',
  discard_draft: 'Set draft aside',
  share_life_event: 'Share Life Event',
  delete_spark_title: 'Are you sure you want to delete this spark?',
  share_link_spark: 'Spark is ready to be shared',
  public_view_description: 'This spark is shared with everyone',
  moons_only_description: 'This spark is shared with your moons',
  constellation_description: 'This spark is shared with your constellation',
  memory_public_description: 'Anyone visiting {name} on Nettgrav can read this post.',
  memory_private_description: 'Your post is only visible to you',
  memory_relatives_description:
    'What you share here is only visible to people connected to {name} on Nettgrav.',
  memory_privacy_label: 'Privacy',
  memory_description_label: 'Words you leave behind',
  file_remove_failed: 'Failed to remove file.',
  add_value: 'Add quality',
  spark_feeling_Reflecting: 'Reflecting',
  spark_feeling_Reflecting_description:
    'Create a Spark about something you have reflected on a lot.',

  spark_feeling_Wonder: 'Wonder',
  spark_feeling_Wonder_description: 'Create a Spark with a question you are wondering about.',

  spark_feeling_Connection: 'Connection',
  spark_feeling_Connection_description: 'Create a Spark that brings people together.',

  spark_feeling_Freedom: 'Freedom',
  spark_feeling_Freedom_description:
    'Create a Spark from your free, inner place – a place we must care for. Share without fear of triggering change.',

  spark_feeling_tooltip: 'Choose perspective',
  memory_reaction_name_Healed: 'Show it comforted you',
  memory_reaction_name_Love: 'Send love',
  memory_reaction_name_Remembered: 'I remember it too',
  memory_reaction_name_Cherished: 'Appreciate this memory',
  views: 'views',
  grave_memories: 'Grave memories',
  grave_memories_placeholder: 'Leave a few words here.',
  grave_memories_message: 'A place to leave words when you visit.',
  grave_post_on: 'Post on:',
  select_grave: 'Select grave',
  select_a_grave: 'please select a grave',
  user_values_title: 'This is what we see in {name}',
  user_values_menu: 'This is what I see in {name}',
  profile_values_tab_self: 'What others have understood about me',
  profile_values_tab_self_mobile: 'Seen in me',
  profile_values_tab_other: 'What others have understood about {name}',
  profile_values_tab_other_mobile: 'About them',
  profile_people_tab_self: 'My people',
  profile_people_tab_self_mobile: 'People',
  compass_tab_mobile: 'Compass',
  profile_people_tab_other: 'People around {name}',
  profile_people_tab_other_mobile: 'People',
  my_light_profile_label: 'My Light',
  my_light_profile_purpose_self:
    'A place for what you stand for, the people around you, and what you want to pass on.',
  my_light_profile_purpose_other:
    'A place for what defines {name}, the people around them, and what should live on.',
  intention_moment_section_title_self: 'What others have understood about me',
  intention_moment_section_title_other: 'What others have understood about {name}',
  intention_moment_section_intro:
    'Moments others noticed, and conversations about how they were experienced.',
  intention_moment_add: 'Share a moment',
  intention_moment_empty_self_title: 'No one has shared such a moment yet',
  intention_moment_empty_self_message:
    'Others can share a moment they noticed, and you can reply with your perspective.',
  intention_moment_empty_other_title: 'Is there something you noticed about {name}?',
  intention_moment_empty_other_message: 'Share a concrete moment and what it did to you.',
  intention_moment_empty_readonly_title: 'No one has shared a moment like this about {name} yet',
  intention_moment_empty_readonly_message:
    'This is where moments shared by people close to {name} will appear.',
  intention_moment_create_title: 'Something you noticed about {name}',
  intention_moment_edit_title: 'Edit moment',
  intention_moment_observed_label: 'What happened?',
  intention_moment_observed_help: 'Describe a concrete action, choice, or moment with {name}.',
  intention_moment_observed_placeholder: 'Describe the situation as you experienced it.',
  intention_moment_impact_label: 'What did it do to you?',
  intention_moment_impact_help: 'What did you think, feel, or do differently afterwards?',
  intention_moment_impact_placeholder: 'It made me ...',
  intention_moment_share: 'Share moment',
  intention_moment_update: 'Save',
  intention_moment_save_error: 'The moment could not be saved. Please try again.',
  intention_moment_card_impact: 'What it did to me',
  intention_moment_legacy_value: 'A word that was chosen: {value}',
  intention_moment_delete_title: 'Delete this moment?',
  intention_moment_delete_message: 'The contribution will be removed permanently.',
  intention_moment_hide_title: 'Remove this from your profile?',
  intention_moment_hide_message:
    'The contribution will be removed. Its words will not be changed or attributed to you.',
  intention_moment_hide_action: 'Remove',
  intention_moment_creator_consent:
    'I am comfortable with public visibility if {name} wants that too.',
  intention_moment_private_until_both:
    'The card stays private between you until both explicitly choose public visibility.',
  intention_moment_response_title: 'How it was for you',
  intention_moment_response_observer_label: 'This was noticed',
  intention_moment_response_prompt: 'What mattered to you in this situation?',
  intention_moment_response_help:
    'Use your own words. It may have been complicated, or something you had not considered before.',
  intention_moment_response_placeholder:
    'This is how I experienced what was happening within me ...',
  intention_moment_subject_consent: 'I want the complete card to be shown publicly in My Light.',
  intention_moment_public_only_together:
    'The card becomes public only because both of you chose it.',
  intention_moment_response_save: 'Share my perspective',
  intention_moment_card_subject_response: 'How it was for {name}',
  intention_moment_respond: 'Reply with your perspective',
  intention_moment_edit_response: 'Edit my perspective',
  intention_moment_continue_chat: 'Continue in chat',
  intention_moment_chat_error: 'Could not open the conversation.',
  intention_moment_content_locked:
    'After the recipient has replied, the words above cannot be changed. You can still change your consent.',
  user_values_add_cta: 'Say what you see',
  user_values_empty_title: 'Add the qualities that show who {firstName} is.',
  user_values_empty_message:
    'Share what matters most to {name} so everyone knows how to support them.',
  user_values_empty_self_title: 'What others see in you',
  user_values_empty_self_message: 'When someone shares what they see in you, it appears here.',
  user_values_modal_title: 'What do you see in {name}?',
  user_values_modal_edit_title: 'Edit quality',
  user_values_modal_heading: 'Choose a quality you recognize, and say why.',
  user_values_selected_label: 'I see this in {name}',
  user_values_selected_message: 'What makes you choose “{personality}”?',
  user_values_placeholder: 'Write a few words about what you have seen or experienced.',
  user_values_create_cta: 'Share',
  user_values_update_cta: 'Share',
  user_values_privacy_public_description: "Visible to everyone who visits {name}'s space.",
  user_values_privacy_private_description: 'Only you and {name} can see this quality.',
  user_values_privacy_relatives_description:
    'People you invite to care alongside {name} can see this quality.',
  gift_from: 'Lit a candle',
  grave_values: 'Words about {graveName}',
  grave_values_fallback: 'Words about',
  grave_values_load_failed: 'Could not load these words right now',
  grave_values_load_failed_description: 'Try again. Anything already shared is still saved.',
  grave_values_options_load_failed: 'Could not load the qualities',
  grave_values_options_load_failed_description: 'Try again before sharing your words.',
  grave_values_privacy_label: 'Who can see this?',
  grave_values_created: 'The quality was added.',
  grave_values_updated: 'The quality was updated.',
  grave_values_deleted: 'The quality was removed.',
  grave_values_save_failed: 'Could not save the quality. Try again.',
  the_value_archive: 'Qualities',
  edit_value_archive: 'Edit quality',
  create_value_archive: 'Create quality',
  update_value_archive: 'Update quality',
  value_archive_title: 'Choose a quality and add history',
  value_archive_selected: 'A quality that describes {graveName}',
  value_archive_selected_message:
    'You remember {graveName} as {personality}. Share a few words that show this.',
  no_suggestions: 'No suggestions available',
  value_archive_placeholder: 'Write a few words that point to the quality',
  select_personality_warning: 'Please select a quality.',
  enter_description_warning: 'Remember to add a few words that point to the quality.',
  grave_values_empty_primary: 'Words and small stories about who {firstName} was to others.',
  grave_values_empty_secondary:
    'Connect yourself to the grave to share your words about {firstName}.',
  grave_values_empty_cta: 'Connect to {firstName}',
  no_values_added: '{firstName}’s story holds more.',
  add_values_message:
    'Qualities are words that describe what it was like to meet them – what they left with others.',
  confirm_delete_value_message:
    'This will remove the quality from this place. You can add it again later.',
  confirm_delete_product_message:
    'This will remove this product. You can add the product again later.',
  added_personality_value: 'added',
  create_grave: 'Create grave',
  create_grave_mode_label: 'What would you like to create?',
  create_grave_mode_grave: 'New grave',
  create_grave_mode_with_ceremony: 'New grave with death notice',
  create_grave_mode_with_ceremony_mobile: 'With death notice',
  create_grave_mode_with_ceremony_help:
    'You can add the essentials now. Time and place can be added later.',
  create_grave_ceremony_accuracy_confirm_label:
    'I confirm that the information is correct as far as I know.',
  create_grave_ceremony_confirm_required:
    'Confirm that the information is correct as far as you know.',
  create_grave_death_notice_section: 'Death notice',
  create_grave_ceremony_section: 'Ceremony',
  create_grave_ceremony_message_label: 'Message to family and friends',
  create_grave_ceremony_message_placeholder: 'Write a short message.',
  create_grave_ceremony_place_of_death_label: 'Where did the person pass away',
  create_grave_ceremony_place_of_death_placeholder: 'e.g. at home, nursing home, or hospital',
  create_grave_ceremony_timing_pending: 'Time and place are not set yet',
  create_grave_ceremony_timing_pending_help: 'You can update this later on the grave.',
  create_grave_ceremony_funeral_date_label: 'Ceremony (date)',
  create_grave_ceremony_funeral_time_label: 'Ceremony (time)',
  create_grave_ceremony_funeral_time_placeholder: 'e.g. 12:00',
  create_grave_ceremony_funeral_at_label: 'Ceremony (date and time)',
  create_grave_ceremony_funeral_venue_label: 'Place',
  create_grave_optional_field_help: 'Optional',
  create_grave_ceremony_funeral_venue_placeholder: 'e.g. Lade church',
  create_grave_any_proof: 'Do you have any documents to confirm the death?',
  create_grave_validation_name_required: 'Add name.',
  create_grave_validation_gender_required: 'Choose gender.',
  create_grave_validation_birthday_required: 'Choose date of birth.',
  create_grave_validation_death_date_required: 'Choose date of death.',
  create_grave_validation_country_required: 'Choose country.',
  create_grave_validation_municipality_required: 'Choose municipality.',
  create_grave_validation_cemetery_required: 'Choose cemetery.',
  create_grave_validation_relation_required: 'Choose relation.',
  create_grave_validation_reciprocal_relation_required: 'Choose reciprocal relation.',
  create_grave_validation_reason_required: 'Choose reciprocal death reason.',
  create_grave_validation_other_reason_required: 'Choose other reason.',
  create_grave_select_document_heading: 'Please Select document',
  create_grave_select_document_message:
    'Select the document you want to upload and accept the terms',
  spark_feeling: 'Choose perspective',
  spark_feeling_tooltip_freedom: 'Stand with freedom, open and fearless.',
  spark_feeling_tooltip_wonder: 'See with wonder, eyes open and new.',
  spark_feeling_tooltip_connection: 'Be with others in shared bond.',
  spark_feeling_tooltip_gratitude: 'Live with gratitude, naming what is good.',
  spark_feeling_tooltip_peace: 'Rest with peace, soft presence for the heart.',
  spark_feeling_tooltip_hopeful: 'Move with hope toward what’s to come.',
  spark_feeling_tooltip_reflecting: 'Walk with reflection in quiet presence.',
  spark_feeling_Reflecting: 'Reflection',
  added_spark_feeling_Reflecting: 'creates a spark with reflection',
  added_spark_feeling_Wonder: 'creates a spark with wonder',
  added_spark_feeling_Connection: 'creates a spark with connection',
  added_spark_feeling_Freedom: 'creates a spark with freedom',
  added_spark_feeling_Hopeful: 'creates a spark with hope',
  added_spark_feeling_Peace: 'creates a spark with peace',
  added_spark_feeling_Gratitude: 'creates a spark with gratitude',
  added_spark_feeling_Peace: 'creates a spark with peace',
  added_reflection_feeling_Reflecting: 'reflects with reflection',
  added_reflection_feeling_Wonder: 'reflects with wonder',
  added_reflection_feeling_Connection: 'reflects with connection',
  added_reflection_feeling_Freedom: 'reflects with freedom',
  added_reflection_feeling_Hopeful: 'reflects with hope',
  added_reflection_feeling_Gratitude: 'reflects with gratitude',
  added_reflection_feeling_Peace: 'reflects with peace',
  spark_reflections_header: 'Reflections',
  spark_add_reflection: 'Add reflection',
  spark_reflections_empty: 'Be the first to add a reflection.',
  spark_reflections_count: '{count, plural, one {# reflection} other {# reflections}}',
  spark_reflectors_count: '{count, plural, one {# person} other {# people}}',
  spark_reflecting_on: 'Reflecting on',
  spark_reflection_feeling: 'State: {state}',
  spark_original_label: 'Original spark',
  spark_reflection_context_label: 'Reflection',
  spark_unknown_user: 'Someone',
  spark_reactions_empty: 'No reactions yet for this selection.',
  memory_feeling_Remembering: 'Remembering',
  memory_feeling_Remembering_description:
    'Relive cherished moments and stories that keep the memory alive.',

  memory_feeling_Honoring: 'Appreciating',
  memory_feeling_Honoring_description:
    'Express gratitude and acknowledge the values and traces left behind.',

  memory_feeling_Reflecting: 'Reflects',
  memory_feeling_Reflecting_description:
    'Take a moment to feel what their life and presence mean to you.',

  memory_feeling_Thankful: 'Thankful',
  memory_feeling_Thankful_description:
    'Share what you are thankful for—their love, wisdom or memories you carry.',

  memory_feeling_Missing: 'Missing',
  memory_feeling_Missing_description:
    'Put into words the longing and void their absence leaves behind.',
  memory_feeling_Forgiving: 'Forgiving',
  memory_feeling_Forgiving_description: 'Choose forgiveness and release.',

  added_memory_feeling_Remembering: 'remembers {graveName}',
  added_memory_feeling_Honoring: 'appreciates {graveName}',
  added_memory_feeling_Reflecting: 'reflects on {graveName}',
  added_memory_feeling_Thankful: 'is thankful for {graveName}',
  added_memory_feeling_Missing: 'misses {graveName}',
  added_memory_feeling_Forgiving: 'forgives {graveName}',
  view_header_desktop: 'Desktop preview',
  view_header_mobile: 'Mobile preview',
  memory_posts: 'Memory Posts',
  view_deceased_name: 'Grave name',
  grave_duplicate_title: 'This grave already exists',
  grave_duplicate_message:
    'A grave with the same name and details already exists on Nettgrav. We do not create a new grave when there is a certain match. Visit the existing one to connect.',
  grave_duplicate_button: 'Go to existing grave',
  create_grave_pending_review_notice:
    'The grave has been sent to Nettgrav for review and is not publicly visible yet.',
  create_grave_create_error: 'The grave could not be created. Check the details and try again.',
  create_grave_potential_duplicates_title: 'We found a similar grave',
  create_grave_potential_duplicates_message:
    'Check whether one of these is the same person before you create a new grave.',
  create_grave_potential_duplicates_button: 'Go to grave',
  grave_create_invalid_date_title: 'Invalid date order',
  grave_create_invalid_date_message:
    'Date of death cannot be before date of birth. Review the dates and try again.',
  memory_feeling_tooltip: 'Feeling',
  memory_feeling: 'Feeling',
  conscious_verified_badge:
    'You receive a verified badge—a mark of trust, presence, and care in the community',
  conscious_supports_free_graves:
    'You help keep all graves open and cared for, ensuring everyone can remember loved ones, regardless of ability to pay.',
  conscious_ad_free_safe_space:
    'You support a safe, ad-free space built on belonging, warmth, and honesty.',
  conscious_supports_community_and_mission:
    'Your contribution sustains the Nettgrav community and the broader End Of Time mission, now and for the future.',
  partner_page_title: 'Partners The End of Time',
  partner_page_mission: 'Support remembrance, gratitude, and truth.',
  partner_welcome_title: 'Welcome!',
  partner_welcome_message:
    'Become a partner. Support remembrance, gratitude, and truth for families and communities.',
  partner_company_name: 'Company name',
  partner_company_website: 'Company website',
  partner_company_mission: 'Short mission statement',
  partner_company_logo: 'Logo',
  partner_continue: 'Continue',

  partner_choose_context_title: 'Choose where to support',
  partner_appears_memory_album: 'Appears gently alongside families’ memory albums.',
  partner_appears_value_archive: 'Gratitude is possible thanks to our partners.',
  partner_appears_funeral_room: 'In partnership with you for remembrance.',
  partner_appears_anniversary_calendar: 'Celebrating memories with help from partners.',
  partner_appears_groups: 'Community support made possible by partners.',
  partner_appears_store: 'Brought to you with care by partners.',

  partner_upload_or_generate_title: 'Upload or generate your ad',
  partner_upload_image_video: 'Upload image/video',
  partner_select_theme: 'Select a theme',
  partner_select_theme_remembrance: 'Remembrance',
  partner_select_theme_gratitude: 'Gratitude',
  partner_select_theme_support: 'Support',
  partner_or: 'Or',
  partner_describe_generate:
    "Describe what you want to generate (e.g., 'a soft candle with gentle background')",
  partner_generate_ai: 'Generate with AI',
  partner_upload_success: 'Creative uploaded!',
  partner_generate_success: 'Generated with AI!',

  partner_write_message_title: 'Write your message',
  partner_write_message_placeholder: 'Write a warm, supportive message...',
  partner_make_warmer: 'Make it warmer / poetic',
  partner_live_preview: 'Live preview',
  partner_message_preview_placeholder: 'Your message will appear here.',

  partner_set_commitment_title: 'Set your commitment',
  partner_commitment_cpm: 'CPM (per 1,000 views)',
  partner_commitment_cpm_desc: '~6,200 views/month, NOK 140 CPM',
  partner_commitment_cpc: 'CPC (per click)',
  partner_commitment_cpc_desc: 'Pay for each click only',
  partner_commitment_flat: 'Flat monthly sponsorship',
  partner_commitment_flat_desc: 'Fixed fee, all-in',
  partner_campaign_summary: 'Your campaign summary',
  partner_estimated_monthly_reach: 'Estimated monthly reach',
  partner_commitment: 'Commitment',
  partner_submit_review: 'Submit for review',

  partner_status_thank_you: 'Thank you! Your partnership will be reviewed within 24 hours.',
  partner_status_subtitle:
    "You'll get an update via email when it's approved. You can track status on your dashboard.",
  partner_go_to_dashboard: 'Go to dashboard',

  partner_your_campaigns: 'Your campaigns',
  partner_placement: 'Placement',
  partner_status: 'Status',
  partner_impressions: 'Impressions',
  partner_clicks: 'Clicks',
  partner_actions: 'Actions',
  partner_view_company: 'View company',
  partner_sponsored: 'End Of Time Call',
  partner_call_cta: 'End Of Time Call',

  partner_supported_by: 'Supported by ❤️ {count} conscious members',
  partner_highlight_this_partner: 'Highlight this partner',
  partner_about: 'About',
  partner_partner_since: 'Partner since: {date}',
  partner_causes_supported: 'Causes supported:',
  partner_active_campaigns: 'Active campaigns:',
  partner_families_supported: 'Families supported',
  partner_testimonials: 'Testimonials:',
  partner_total_highlights: 'Total highlights',
  partner_see_support_helps: 'See how your support helps',
  partner_share_impact: 'Share this partner’s impact',
  partner_invite_more_causes: 'Invite this partner to support more causes',

  partner_review_preview_title: 'Review & Preview',
  partner_review_ad_preview: 'Ad Preview',
  partner_review_placement: 'Placement',
  partner_review_company: 'Company',
  partner_review_website: 'Website',
  partner_review_mission: 'Mission',
  partner_review_billing: 'Billing',
  partner_confirm_submit: 'Confirm & Submit',
  partner_appears_key_memory_album: 'Memory Album',
  partner_appears_key_value_archive: 'Qualities',
  partner_appears_key_funeral_room: 'Funeral Room',
  partner_appears_key_anniversary_calendar: 'Memorial Day Calendar',
  partner_appears_key_groups: 'Groups/Community',
  partner_appears_key_store: 'Store / Webshop',
  account_form_email_label: 'Email',
  account_form_email_placeholder: 'Enter your email',
  account_form_email_required: 'Please enter your email',
  account_form_email_invalid: 'Please enter a valid email address',

  account_form_userName_label: 'Name',
  account_form_userName_placeholder: 'Enter your name',
  account_form_userName_required: 'Please enter your name',
  account_form_userName_invalid: 'The name must contain at least one letter',

  account_form_gender_label: 'Gender',
  account_form_gender_placeholder: 'Select gender',
  account_form_gender_required: 'Please select your gender',
  account_form_gender_option_male: 'Male',
  account_form_gender_option_female: 'Female',
  account_form_gender_option_other: 'Other',

  account_form_password_label: 'Password',
  account_form_password_placeholder: 'Enter your password',
  account_form_password_required: 'Please enter your password',
  account_form_password_min: 'Use at least 8 characters.',
  account_form_password_max: 'Use no more than 128 characters.',

  account_form_confirmPassword_label: 'Confirm Password',
  account_form_confirmPassword_placeholder: 'Confirm your password',
  account_form_confirmPassword_required: 'Please confirm your password',
  account_form_confirmPassword_match: 'The two passwords do not match',

  not_authorized: 'You are not authorized',

  account_form_country_label: 'Country',
  account_form_country_placeholder: 'Select country',
  account_form_country_required: 'Please select your country',

  account_form_dateOfBirth_label: 'Date of Birth',
  account_form_dateOfBirth_placeholder: 'Select date',
  account_form_dateOfBirth_required: 'Please select your date of birth',
  account_form_dateOfBirth_underage: 'Available for ages 13+.',

  account_form_language_label: 'Language',
  account_form_language_placeholder: 'Select language',
  account_form_language_required: 'Please select your preferred language',
  language_english: 'English',
  language_norwegian: 'Norwegian',
  language_danish: 'Danish',
  language_swedish: 'Swedish',
  language_finnish: 'Finnish',

  account_form_checked_label: 'I agree to the {termsLink}',
  account_form_checked_required: 'Agree to continue.',
  account_form_creating_account: 'Creating account...',

  see_more: 'see more',
  filter_button: 'Filter graves',
  account_form_submit: 'Create account',
  registration_too_many_attempts:
    'Too many registration attempts. Wait a while before trying again.',
  registration_failed: 'We could not create the account. Please try again.',
  grave_tab: 'Search',
  home_welcome: 'Bring the grave into the cloud with nettgrav.com.',
  home_subheading: 'Accessible and close in your daily life. Search by name to get started.',
  home_create_account: 'Create account',
  home_login: 'Login',
  home_terms: 'By continuing, you agree to our',
  'home.actions.title': 'Nettgrav: A lasting home for our lives.',
  'home.actions.subtitle': 'A network built for truth and togetherness, driven by lasting meaning.',
  'home.actions.create.title': 'Create a Nettgrav',
  'home.actions.create.body':
    'Gather the family and create your permanent Nettgrav—completely free. Share words, photos, and candles, and preserve the story together wherever you are in the world.',
  'home.actions.create.cta': 'Start Nettgrav',
  'home.actions.find.title': 'Find a grave',
  'home.actions.find.body':
    'Find the one you miss. See verified memories and get alerted on important days.',
  'home.actions.find.cta': 'Search graves',
  'home.actions.invite.title': 'Invite contributors',
  'home.actions.invite.body':
    'Invite contributors. Share access with your closest to build the life story together and keep the memory alive.',
  'home.actions.invite.cta': 'Send invites',
  'home.actions.spark.title': 'Light your Spark',
  'home.actions.spark.body':
    'Share what matters to you right now. Your Spark is the space for your reflections and inner truths. Share your light with the world and spark reflection in others.',
  'home.actions.spark.cta': 'Create a Spark',
  footer_copyright: '© 2013–2026 Nettgrav.com.',
  footer_built_by: 'The End Of Time Corporation',
  footer_teotc_name: 'Nettgrav is developed in Norway by The End Of Time Corporation (TEOTC).',
  footer_intro_eyebrow: 'Nettgrav — where love never ends.',
  footer_intro_body: 'Products and services from one perspective — what endures across all time.',
  footer_col_nettgrav: 'Nettgrav',
  footer_col_explore: 'Explore',
  footer_col_teotc: 'End of Time',
  footer_col_contact: 'Contact',
  footer_find_grave: 'Find a grave',
  footer_graves: 'Browse all graves',
  footer_about: 'About Nettgrav',
  footer_create_spark: 'Create a Spark',
  footer_my_light: 'My Light',
  footer_rooms: 'Rooms',
  footer_partner: 'Partner',
  footer_how_it_works: 'How Nettgrav works',
  footer_create_nettgrav: 'Create a Nettgrav',
  footer_about_teotc: 'About TEOTC',
  footer_nettarv: 'Nettarv',
  footer_matvarebutikken: 'Matvarebutikken',
  footer_become_partner: 'Become a partner',
  footer_privacy: 'Privacy',
  footer_terms: 'Terms',
  footer_cookies: 'Cookies',
  footer_end_of_time_center: 'The End of Time Center',
  footer_end_of_time_chat: 'End Of Time Chat',
  my_light_info_title: 'My Light',
  my_light_info_intro: 'A place for what matters most to you, at your own pace.',
  my_light_info_body_1: 'My Light is your life page in Nettgrav.',
  my_light_info_body_2:
    'Here you connect with people you care about, build relationships over time — and make what matters most clear.',
  my_light_info_body_3: 'This is not about sharing the most.',
  my_light_info_body_4: 'It is about being present.',
  my_light_info_section_what_you_can_do_title: 'What you can do in My Light',
  my_light_info_body_5: 'You can:',
  my_light_info_body_6: 'strengthen relationships with the people you care about',
  my_light_info_body_7: 'share words and presence that do good',
  my_light_info_body_8: '• share good words with each other — while we live',
  my_light_info_body_9: 'choose Moons — the closest people you trust',
  my_light_info_body_10:
    'set direction with My Compass and make what matters most clear in After Me',
  my_light_info_body_11: 'My Light holds both life now — and direction for what comes next.',
  my_light_info_section_not_title: 'What this is not',
  my_light_info_body_12:
    'My Light is not a social network. It is not about speed, attention, or growth.',
  my_light_info_body_13: 'Here, what matters most can be shared with calm, closeness, and care.',
  my_light_info_section_why_title: 'Why does it exist?',
  my_light_info_body_14: 'Because people need each other.',
  my_light_info_body_15: 'And because it is good to say what matters — while we live.',
  my_light_info_cta: 'Go to My Light',
  'my_light_guest_preview.eyebrow': 'For guests',
  'my_light_guest_preview.supporting': 'Here you can see what My Light contains.',
  'my_light_guest_preview.primary_cta': 'Sign in to your My Light',
  'my_light_guest_preview.secondary_cta': 'Create account',
  'my_light_guest_preview.panel_label': 'What My Light contains',
  'my_light_guest_preview.modules_title': 'This is what My Light looks like',
  'my_light_guest_preview.modules_intro': 'These are the areas you meet in My Light.',
  'my_light_guest_preview.card_about_title': 'About me',
  'my_light_guest_preview.card_about_body':
    'A short introduction, a few lines about who you are, and three questions that capture life as it feels now.',
  'my_light_guest_preview.card_relations_title': 'Those close to you',
  'my_light_guest_preview.card_relations_body':
    'Here you can see the people closest to you, and who has a special role when things matter most.',
  'my_light_guest_preview.card_compass_title': 'My compass',
  'my_light_guest_preview.card_compass_body':
    'Here you can put words to what keeps you on course, what matters most, and what others should understand about you.',
  'my_light_guest_preview.card_moons_title': 'Moons',
  'my_light_guest_preview.card_moons_body':
    'Moons are the close people around you who influence your life with closeness, direction, and trust.',
  'my_light_guest_preview.card_after_me_title': 'After me',
  'my_light_guest_preview.card_after_me_body':
    'After me is where you make what matters most clear for the people you love.',
  'my_light_guest_preview.footer_title': 'A personal place for relationship and responsibility',
  'my_light_guest_preview.sample_name': 'Member preview',
  'my_light_guest_preview.sample_role': 'Teacher and parent',
  'my_light_guest_preview.sample_bio':
    'I try to make room for honest conversations, calm mornings, and the people I need to stay close to.',
  'my_light_guest_preview.answer_1': 'To protect time with the people I love.',
  'my_light_guest_preview.answer_2': 'Walking, silence, and one truthful conversation.',
  'my_light_guest_preview.connection_name_1': 'Anna Berg',
  'my_light_guest_preview.connection_role_1': 'Sister',
  'my_light_guest_preview.connection_name_2': 'Isak Berg',
  'my_light_guest_preview.connection_role_2': 'Friend of the family',
  'my_light_guest_preview.compass_value_1': 'I do not want to disappear from what matters most.',
  'my_light_guest_preview.compass_value_2': 'Does this create more truth or only less discomfort?',
  'my_light_guest_preview.moon_name_1': 'Liv',
  'my_light_guest_preview.moon_role_1': 'Close friend',
  'my_light_guest_preview.moon_name_2': 'Maren',
  'my_light_guest_preview.moon_role_2': 'Daughter',
  'my_light_guest_preview.moon_status': 'Moon',
  'my_light_guest_preview.after_me_status': 'Clear',
  'my_light_guest_preview.after_me_updated': 'Updated recently',
  'my_light_guest_preview.after_me_message':
    'If something happens, let it be simple, warm, and without guessing.',
  end_of_time_center_title: 'The End of Time Center',
  end_of_time_center_intro: 'Work that begins where life ends.',
  end_of_time_center_body_1: 'A grave exists because a person has died.',
  end_of_time_center_body_2:
    'We seek understanding of why life ends, and how knowledge, insight, and research can help fewer lives do so in the future.\nNot through promises, but through long-term work.',
  end_of_time_center_section_1_title: 'From loss to action',
  end_of_time_center_section_1_body_1:
    'Most things stop at death.\nThe End of Time Center begins there.',
  end_of_time_center_section_1_body_2:
    'When a person dies, questions remain that memories alone cannot answer. Here, research, reflection, and development come together to understand life’s vulnerability and the role of time in illness, aging, and death.',
  end_of_time_center_section_1_body_3: 'This is not memorial work.\nIt is a responsibility.',
  end_of_time_center_section_2_title: 'The grave as a bridge',
  end_of_time_center_section_2_body_1:
    'Through Nettgrav, the grave becomes more than a place of stillness.\nIt becomes a bridge between what has been and what may come.',
  end_of_time_center_section_2_body_2:
    'Actions connected to the grave — candles, circles, and presence — are anchored in The End of Time Center. In this way, the grave is given a direction forward, toward understanding, coherence, and research at the boundaries of life.\nThis work is referred to as End of Time Care.',
  end_of_time_center_section_3_title: 'A long-term commitment',
  end_of_time_center_section_3_body_1:
    'The End of Time Center is a long-term initiative under The End Of Time Corporation. The work is rooted in Norway and developed with respect for life’s complexity and the human need for meaning.',
  end_of_time_center_section_3_body_2:
    'This is not a project meant to scale quickly.\nIt is work intended to endure.',
  end_of_time_center_section_4_title: 'Why The End of Time Center exists',
  end_of_time_center_section_4_body_1:
    'Because a life came to an end.\nIt became a grave.\nAnd because that carries responsibility.',
  end_of_time_chat_title: 'End Of Time Chat',
  end_of_time_chat_intro: 'Conversations that can hold silence',
  end_of_time_chat_beta_label: 'Beta version',
  end_of_time_chat_beta_short:
    'Core encryption protections are active. Because this is a beta, some features and interface details may change.',
  end_of_time_chat_open_beta: 'Open beta chat',
  end_of_time_chat_explore_security: 'How your conversations are protected',
  end_of_time_chat_security_eyebrow: 'Private by design',
  end_of_time_chat_security_summary_title: 'Protection status',
  end_of_time_chat_security_active: 'Active',
  end_of_time_chat_security_note:
    'Your conversations are protected with encryption and other security measures, but no digital service can guarantee complete security.',
  end_of_time_chat_beta_title: 'Ready to use, still being refined',
  end_of_time_chat_beta_body:
    'End of Time Chat is now available as a beta. You may find rough edges while we improve reliability, calls, synchronization, and the overall experience.',
  end_of_time_chat_beta_point_1: 'Features and interface details may change during the beta.',
  end_of_time_chat_beta_point_2: 'Temporary synchronization or call-connection issues may occur.',
  end_of_time_chat_beta_point_3:
    'Do not rely on a beta service for emergencies or time-critical communication.',
  end_of_time_chat_security_title: 'Built to protect the conversation',
  end_of_time_chat_security_intro:
    'Encryption is not an optional add-on. It is part of how messages, groups, and calls are designed from the beginning.',
  end_of_time_chat_e2ee_title: 'End-to-end encryption',
  end_of_time_chat_e2ee_body:
    'Conversation content is encrypted on participant devices. Nettgrav transports encrypted data rather than a readable copy of your conversation.',
  end_of_time_chat_pq_title: 'Hybrid post-quantum protection',
  end_of_time_chat_pq_body:
    'Hybrid X-Wing key establishment combines established cryptography with post-quantum protection. This helps reduce the risk of encrypted traffic being stored today and decrypted by future quantum computers.',
  end_of_time_chat_mls_title: 'Secure group key rotation',
  end_of_time_chat_mls_body:
    'Messaging Layer Security updates group secrets as membership and conversation state change, helping limit the impact of a compromised key over time.',
  end_of_time_chat_cta_title: 'A safer room for conversations that matter',
  end_of_time_chat_cta_body:
    'Use the beta, tell us what does not feel right, and help us make private communication more dependable.',
  end_of_time_chat_feedback: 'Report a beta issue',
  end_of_time_chat_body_1: 'Coming soon',
  end_of_time_chat_body_2:
    'Some conversations are too vulnerable for the open. Others are too true to disappear.',
  end_of_time_chat_body_3:
    'End of Time Chat is created for people who want a safe space for close conversations — where relationships can continue with honesty, tenderness, and time.',
  end_of_time_chat_section_1_title: 'A room, not a stream',
  end_of_time_chat_section_1_body_1:
    'This is not a social platform.\nIt is not a place for visibility, pace, or performance.',
  end_of_time_chat_section_1_body_2:
    'End of Time Chat is a closed space between people who have chosen each other.\nThe conversations are allowed to be what they are — without an audience.',
  end_of_time_chat_section_2_title: 'Built for trust',
  end_of_time_chat_section_2_body_1:
    'Conversations are end-to-end encrypted and built with security as a foundation. What is shared remains with those it belongs to.',
  end_of_time_chat_section_2_body_2:
    'The technology exists for one reason:\nTo protect what is human.',
  end_of_time_chat_section_3_title: 'Why End Of Time Chat exists',
  end_of_time_chat_section_3_body_1:
    'Because relationships do not end when life becomes difficult.\nBecause closeness needs spaces that do not exploit vulnerability.\nBecause some words can only be shared when it is safe to do so.',
  end_of_time_chat_section_3_body_2:
    'End of Time Chat is also created for the conversations we wish to have while we are living.\nTo say what we believe in.\nTo show what matters.\nTo be the one who says I love you first.',
  end_of_time_chat_section_3_body_3:
    'There is strength in being real.\nEven when it is not met.\nEven when it makes us vulnerable.',
  end_of_time_chat_section_4_title: 'Part of Nettgrav',
  end_of_time_chat_section_4_body_1:
    'End of Time Chat is developed as part of Nettgrav.\nA place for life, relationships, and presence — also after loss.',
  end_of_time_chat_section_5_title: 'A guiding principle',
  end_of_time_chat_section_5_body_1:
    'End of Time Chat is not a product.\nIt is a room that protects relationships.',
  about_nettgrav_title: 'About Nettgrav',
  about_nettgrav_intro:
    'Nettgrav is created for closeness both to those who are buried and to those who live on.',
  about_nettgrav_body_1:
    'When death occurs, needs often arise that a physical grave alone cannot hold. Nettgrav makes it possible to be present online as well — across time, distance, and life situations.',
  about_nettgrav_body_2:
    'A grave is more than a place. It holds a person, a life lived, and the relationships around it. Nettgrav is made to give this space dignity and permanence.',
  about_nettgrav_body_3:
    'Nettgrav exists independently of the physical grave. Even if a grave is changed, moved, or reused, the digital place remains as a lasting space for closeness and memories.',
  about_nettgrav_body_4:
    'The service is developed in Norway with a focus on durability, respect, and human closeness. Nettgrav is supported by public innovation funding through Innovation Norway, and is largely built with support from family and friends.',
  about_nettgrav_body_5:
    'Behind Nettgrav are the same people as The End Of Time Corporation — a Norwegian, long-term effort to build services that meet death, time, and the human need for meaning and connection.',
  create_spark_title: 'Create a Spark',
  create_spark_intro: 'A space for what is true for you',
  create_spark_body_1: 'Standing up for what you believe in can be an emotional journey.',
  create_spark_body_2:
    'Create a Spark gives room to put words to what is true for you — while you live.',
  create_spark_body_3: 'A spark can be a thought, a value, a wonder, or a reflection.',
  create_spark_body_4: 'Something you want to express, with no demand for answers or response.',
  create_spark_body_5:
    'Creating a spark is not about convincing others, but about being honest in meeting yourself and the world around you.',
  create_spark_body_6: 'In Nettgrav there is both life and memories.',
  create_spark_body_7: 'Graves hold the history. Sparks hold what is alive now.',
  partner_title: 'Partner',
  partner_intro:
    'Nettgrav works with partners who want to contribute to good lives for the people and families who use Nettgrav.',
  partner_body_1:
    'Partnership at Nettgrav is about supporting people in life’s important moments — with closeness, care, and long-term commitment. Together we aim to strengthen emotional and mental resilience, and choices that carry meaning over time.',
  partner_body_2:
    'For organizations and brands that want to build society through sharing and generosity, our partner program is available in collaboration with End of Time — a network that invests resources where they are needed.',
  partner_cta: 'Become a partner',
  how_it_works_title: 'How Nettgrav works',
  how_it_works_intro: 'Nettgrav is a place for closeness to your people and what matters.',
  how_it_works_lead_1: 'A place that exists alongside the physical grave — and endures over time.',
  how_it_works_lead_2: 'This page explains how Nettgrav works and what you can expect.',
  how_it_works_section_1_title: 'A place alongside the physical grave',
  how_it_works_section_1_body_1: 'The physical grave is a place you can visit.',
  how_it_works_section_1_body_2:
    'Nettgrav makes it possible to be present online as well, when distance, time, or life situation makes it hard to get there.',
  how_it_works_section_1_body_3: 'Nettgrav is independent of the physical grave’s duration.',
  how_it_works_section_1_body_4:
    'Even if a grave is changed, moved, or reused, the net grave remains a lasting place of belonging.',
  create_nettgrav_title: 'Create a Nettgrav',
  create_nettgrav_intro: 'A Nettgrav can be created whenever it is needed.',
  create_nettgrav_body_1:
    'To create a Nettgrav, enter the name of the person who is buried and choose municipality and cemetery if known.',
  create_nettgrav_body_2: 'Nettgrav is not dependent on the physical grave.',
  create_nettgrav_body_3: 'The person who is buried is our starting point — not the place.',
  create_nettgrav_section_create_title: 'Create a grave online',
  create_nettgrav_section_missing_title: 'When municipality or cemetery is missing',
  create_nettgrav_missing_body_1:
    'Over time, Nettgrav will not focus on registering all municipalities and cemeteries.',
  create_nettgrav_missing_body_2: 'If the municipality or cemetery is not in the list, choose:',
  create_nettgrav_missing_body_3: 'Nettgrav as municipality',
  create_nettgrav_missing_body_4: 'End Of Time Cemetery as cemetery',
  create_nettgrav_missing_body_5: 'Then the Nettgrav is created at no cost.',
  create_nettgrav_missing_body_6:
    'This Nettgrav works the same way as all others and provides a lasting digital place for closeness, memories, and relationships.',
  create_nettgrav_section_place_title: 'Digital grave creation — a place that lasts',
  create_nettgrav_place_body_1: 'Nettgrav is built on a simple idea:',
  create_nettgrav_place_body_2: 'The person who is buried is elsewhere than the physical grave.',
  create_nettgrav_place_body_3:
    'That is why Nettgrav is made for those who live on — family, friends, and loved ones — and for the connection that endures over time.',
  create_nettgrav_place_body_4:
    'End Of Time Cemetery is Nettgrav’s own cemetery, created to hold Nettgravs independent of physical place and meant to endure over time.',
  create_nettgrav_section_login_title: 'Log in and create a new Nettgrav',
  create_nettgrav_login_body_1: 'Log in and create a new Nettgrav',
  create_nettgrav_login_cta: 'Log in and create a new Nettgrav',
  how_it_works_section_2_title: 'Find or visit a grave',
  how_it_works_section_2_body_1: 'On Nettgrav you can:',
  how_it_works_section_2_body_2: 'find existing graves',
  how_it_works_section_2_body_3: 'create a new net grave',
  how_it_works_section_2_body_4: 'visit a grave online',
  how_it_works_section_2_body_5: 'connect your relationship to the person who is buried',
  how_it_works_section_2_body_6:
    'get to know the person the grave represents. You do not have to do anything specific. You can simply be there — quietly and without demands.',
  how_it_works_section_3_title: 'Small actions that matter',
  how_it_works_section_3_body_1: 'Nettgrav is built around simple actions:',
  how_it_works_section_3_body_2: 'send a gift',
  how_it_works_section_3_body_3: 'share a few words',
  how_it_works_section_3_body_4: 'add a photo or a memory',
  how_it_works_section_3_body_5: 'mark anniversaries',
  how_it_works_section_3_body_6: 'Everything is voluntary and can be done when it feels right.',
  how_it_works_section_3_body_7: 'No expectations. No deadlines.',
  how_it_works_section_4_title: 'Family and close ones',
  how_it_works_section_4_body_1: 'Nettgrav can be shared with family and those who belong.',
  how_it_works_section_4_body_2: 'You decide:',
  how_it_works_section_4_body_3: 'who has access',
  how_it_works_section_4_body_4: 'what is shared',
  how_it_works_section_4_body_5: 'how the grave is managed over time',
  how_it_works_section_4_body_6: 'This allows more people to be present — on their own terms.',
  how_it_works_section_5_title: 'Privacy and safety',
  how_it_works_section_5_body_1: 'Nettgrav is made for emotional and human safety.',
  how_it_works_section_5_body_2: 'Content can be:',
  how_it_works_section_5_body_3: 'private',
  how_it_works_section_5_body_4: 'visible to invited people',
  how_it_works_section_5_body_5: 'open to everyone who visits the grave',
  how_it_works_section_5_body_6: 'You are in control and can change this when it feels right.',
  how_it_works_section_6_title: 'Create a Spark — life that lives now',
  how_it_works_section_6_body_1: 'In addition to Nettgrav, there is Create a Spark.',
  how_it_works_section_6_body_2:
    'Create a Spark is a space for reflection, thoughts, and what is true for you — while you live.',
  how_it_works_section_6_body_3:
    'Here, words can be shared as expressions of life, meaning, and connection.',
  how_it_works_section_6_body_4: 'Graves hold the history.',
  how_it_works_section_6_body_5: 'Sparks hold what is alive now.',
  how_it_works_section_7_title: 'A place made to last',
  how_it_works_section_7_body_1: 'Nettgrav is built with time in mind.',
  how_it_works_section_7_body_2:
    'It is a place that does not disappear and does not require maintenance.',
  how_it_works_section_7_body_3: 'A lasting space for closeness to life.',
  how_it_works_section_7_body_4: 'You can return whenever you want.',
  how_it_works_section_7_body_5: 'It is enough to be there.',
  orbit_section_header: 'Earth position',
  orbit_intro_text:
    'All of us are traveling together on this great journey around the Sun. You are never alone here.',
  orbit_day_progress: 'Day {day} of 365',
  orbit_position_label: 'Earth position: {position}°',
  page_not_found: 'This page does not exist.',
  grave_load_server_error: 'Something went wrong on the server. Reload the page and try again.',
  grave_load_failed: 'We could not load the grave. Please try again.',
  grave_user_load_failed: 'We could not load the user information. Please try again.',
  grave_static_data_load_failed: 'We could not load the required information. Please try again.',
  search_event: 'Search event, Date',
  add_new: 'Add new',
  search_tab_all: 'All',
  search_tab_graves: 'Graves',
  search_tab_members: 'People',
  search_people_none_text: 'No members found for',
  search_grave_load_more: 'Load more graves',
  user_age: 'Age:',
  user_shared_grave: 'shared grave',
  user_shared_graves: 'shared graves',
  view_life_page: 'View Life page',
  see_my_light: 'See My Light',
  see_user_light: "See {name}'s Light",
  relation_to: 'to',

  user_values_heading:
    'Here, those connected with you can express how they experience you. You can also visit a person and do good for them.',
  add_user_values: 'Say what you see',
  user_values_modal_title: 'What do you see in {name}?',
  user_values_modal_subtitle:
    'To let someone know that you value and see their inner being is truly valuable. The value given and received is unending.',
  user_values_select_category: 'Select category',
  user_values_select_value: 'Choose a word you recognize.',
  user_values_save: 'Save',
  user_values_note_placeholder: 'Add a note',
  family_tree_page_title: 'Family Trees',
  family_tree_set_relationships: 'Set relationships',
  family_tree_set_relationship: 'Set relationship',
  family_tree_choose_my_relation: 'Choose my relation',
  family_tree_people_you_might_know: 'People you might know',
  family_tree_no_suggestions: 'No suggestions yet',
  family_tree_relations_in_tree: 'Relations in the tree',
  family_tree_relations_radius_hint:
    'Showing relations that are included in the tree within {count} generations.',
  family_tree_focus_in_tree: 'Focus in tree',
  family_tree_group_parents: 'Parents',
  family_tree_group_partners: 'Partners',
  family_tree_group_siblings: 'Siblings',
  family_tree_group_children: 'Children and descendants',
  family_tree_group_grandparents_list: 'Grandparents and earlier generations',
  family_tree_group_extended_family: 'Extended family',
  family_tree_open_relation: 'Open',
  family_tree_open_grave: 'Go to grave',
  family_tree_open_light: 'Go to light',
  family_tree_suggestion_likely_relation: 'Can be your {relation}',
  family_tree_suggestion_via: 'Via {name}',
  family_tree_your_relations: 'Your relations',
  family_tree_empty_title: 'Your family tree begins to grow here.',
  family_tree_empty_description:
    'You can already set relationships to the deceased and see the bonds take shape. This is an early version – more branches and features are coming soon.',
  family_tree_card_title: 'Your family tree',
  family_tree_card_members: '{count} members',
  family_tree_card_description: 'You and your two sons are here',
  family_tree_view_tree: 'View Family Tree',
  family_tree_empty_state:
    'Your relations appear here. Start by connecting a relation to a grave or a person.',
  family_tree_no_relations: 'No relations yet',
  family_tree_connect_relation: 'Connect relation',
  family_tree_load_more: 'Load more',
  family_tree_no_info: 'No info',
  family_tree_single_node_hint:
    'Your family tree grows when you connect relationships to graves and people, such as parents or children.',
  still_alive: 'still alive',
  family_tree_modal_title: 'Choose your relation to {name}',
  family_tree_modal_suggestion_title: 'Choose your relation to {name}',
  family_tree_modal_claim_title: 'Care responsibility for the grave',
  family_tree_modal_add_mother_title: 'Add your mother',
  family_tree_modal_add_father_title: 'Add your father',
  family_tree_role_mother: 'mother',
  family_tree_role_father: 'father',
  family_tree_role_person: 'person',
  family_tree_modal_tab_relation: 'Relationship',
  family_tree_modal_tab_care: 'Become guardian',
  family_tree_modal_select_grave_label: 'Type and Select grave/life page',
  family_tree_modal_select_grave_placeholder: 'Type and select a name',
  family_tree_modal_search_person_label: 'Search and select person',
  family_tree_modal_search_person_placeholder: 'Search for your {role}',
  family_tree_modal_search_person_hint: 'Type at least 2 letters to search by name.',
  family_tree_modal_locked_relation_label: 'Relationship',
  family_tree_modal_locked_relation_value: 'Saved as: {relation}',
  family_tree_modal_invite_person: 'No matches yet. Try full name or alternate spelling.',
  family_tree_modal_relation_to_person_label: 'Your relation to {name}',
  family_tree_modal_relation_to_you_label: 'What is this person’s relationship to you?',
  family_tree_modal_relation_to_you_with_name_label:
    'What is this person’s ({name}) relationship to you?',
  family_tree_connect_relations_modal_title: 'Connect Relations',
  family_tree_connect_relations_modal_subtitle:
    'Easy to connect different relatives to one another',
  family_tree_connect_relations_first_label: 'Select a relative',
  family_tree_connect_relations_second_label:
    'Select the relative you want to relate to the one above',
  family_tree_connect_relations_third_label: "Choose {from}'s relationship with {to}",
  family_tree_connect_relations_third_label_default:
    "Choose first person's relationship with second person",
  family_tree_connect_relations_fourth_label: "What is {to}'s relationship to {from}",
  family_tree_connect_relations_fourth_label_default:
    "What is second person's relationship to first person",
  family_tree_tab: 'Family Tree',
  waiting_for_approval: 'Waiting for approval',
  family_tree_tree_tab: 'Tree',
  family_tree_no_grave_selected: 'Select a person to start the family tree.',
  family_tree_me_label: 'Me',
  family_tree_you_label: 'You',
  family_tree_you_are_relation: 'You are {relation}',
  family_tree_additional_connections: '+{count} more',
  family_tree_connected_relatives: 'Connected relatives',
  family_tree_modal_reciprocal_label: "{name}'s relation to you",
  family_tree_modal_more_relations: 'More options',
  family_tree_modal_confirm_relation: 'Confirm relation',
  family_tree_modal_confirm_care: 'Confirm care responsibility',
  family_tree_modal_relation_search_placeholder: 'Search relations',
  family_tree_modal_relation_search_no_results: 'No matching relations',
  family_tree_depth: 'Depth',
  family_tree_radius_label: 'Generations',
  family_tree_radius_help: 'Show more generations in the family tree.',
  family_tree_radius_decrease: 'Show fewer generations',
  family_tree_radius_increase: 'Show more generations',
  family_tree_zoom_label: 'Zoom',
  family_tree_zoom_in: 'Zoom in',
  family_tree_zoom_out: 'Zoom out',
  family_tree_fit_view: 'Fit the complete tree',
  family_tree_center_viewer: 'Center on me',
  family_tree_relation_kind_blood: 'Blood',
  family_tree_relation_kind_spouse: 'Spouse',
  family_tree_relation_kind_in_law: 'In-law',
  family_tree_relation_kind_step: 'Step family',
  family_tree_relation_kind_other: 'Other',
  family_tree_relation_confidence_explicit: 'Explicit',
  family_tree_spouses_label: 'Spouses',
  family_tree_sources_label: 'Sources',
  family_tree_no_root: 'Select a person to view relations.',
  family_tree_error: 'We could not load this family tree. Please try again.',
  family_tree_self_label: 'Focus person',
  family_tree_no_self: 'No focus person',
  family_tree_group_descendants: 'Descendants',
  family_tree_group_in_laws: 'In-laws',
  family_tree_group_empty: 'Nothing to show yet.',
  family_tree_meta_summary: '{count} people • radius {radius}',
  family_tree_toggle_panel: 'Panel',
  family_tree_children: 'Children',
  family_tree_partners: 'Partners',
  family_tree_siblings: 'Siblings',
  family_tree_relation_of_user: '{relation} of {name}',
  family_tree_deceased_relation_to_user: '{deceased} is {relation} to {name}',
  family_tree_unknown_person: 'This person',
  family_tree_senses_title: 'Senses',
  family_tree_add_skill: 'Add talent',
  family_tree_talent_name_placeholder: 'Choose a suggestion or write a talent, gift, or ability',
  family_tree_talent_note_placeholder: 'Optional note (how this shows up in life)',
  family_tree_no_skills: 'No talents added yet',
  family_tree_cycles_broken_title: 'Patterns that were broken',
  family_tree_add_cycle_broken: 'Add change',
  family_tree_cycle_name_placeholder: 'Choose a suggestion or write a pattern or change yourself',
  family_tree_cycle_note_placeholder: 'What made this change possible?',
  family_tree_no_cycles_broken: 'No changes added yet',
  family_tree_shared_lineage_title: 'Patterns in the family',
  family_tree_shared_lineage_intro: 'Some patterns can appear across generations.',
  family_tree_no_shared_lineage: 'This is where such patterns can become visible over time.',
  family_tree_trait_signal_personal_memory: 'Personal memory',
  family_tree_trait_signal_possible_family_pattern: 'Possible family pattern',
  family_tree_trait_signal_family_confirmed: 'Family-confirmed',
  family_tree_trait_signal_personal_transformation: 'Personal change',
  family_tree_trait_signal_possible_family_transformation: 'Possible family change',
  family_tree_trait_signal_family_confirmed_transformation: 'Family-confirmed change',
  family_tree_group_cycles: 'Changes',
  family_tree_find_and_add: 'Find and add',
  family_tree_done: 'Done',
  family_tree_search_loading: 'Loading...',
  family_tree_search_no_matches: 'No matches. You can still add manually below.',
  family_tree_unified_search_placeholder: 'Search senses, talents, changes...',
  family_tree_suggested_senses: 'Suggested senses',
  family_tree_suggested_talents: 'Suggested talents',
  family_tree_suggested_cycles: 'Suggested changes',
  family_tree_origin_personal: 'Personal',
  family_tree_origin_possible_family_pattern: 'Possible family pattern',
  family_tree_origin_family_pattern: 'Family pattern',
  family_tree_origin_personal_change: 'Personal change',
  family_tree_origin_possible_family_change: 'Possible family change',
  family_tree_origin_family_change: 'Family change',
  family_tree_added_by_you: 'Added by you',
  family_tree_chip_added_in_family: 'Added in family',
  family_tree_agree: 'Recognize',
  family_tree_agreed: 'Recognize',
  family_tree_shared_in_lineage: 'Shared in lineage',
  family_tree_kind_sense: 'Sense',
  family_tree_kind_talent: 'Talent',
  family_tree_kind_cycle: 'Change',
  family_tree_lineage_type_cycle: 'Change',
  family_tree_lineage_type_talent: 'Talent',
  family_tree_parents_title: 'Parents',
  family_tree_no_parents: 'No parents listed',
  family_tree_add_mother: 'Add mother',
  family_tree_add_father: 'Add father',
  family_tree_detached_title: 'Known people without a connection yet',
  family_tree_detached_description:
    'These people are registered, but do not yet have a family connection in this tree.',
  family_tree_close_panel: 'Close details panel',
  family_tree_remove_talent: 'Remove talent',
  family_tree_remove_change: 'Remove change',
  family_tree_add_note: 'Add note',
  family_tree_edit_note: 'Edit note',
  user_has_already_been_taken: 'User has already been taken',
  relation_already_exists: 'Relation already exists',
  coin_store_categories: 'Categories',
  coin_store_price: 'Price',
  coin_store_category_all: 'All',
  coin_store_category_flowers: 'Flowers',
  coin_store_category_plants: 'Plants',
  coin_store_category_candles: 'Candles',
  coin_store_category_cure: 'Cure',
  coin_store_occasions: 'Occasions',
  coin_store_add_to_cart: 'Choose this',
  coin_store_preview: 'See preview',
  coin_store_preview_frame: 'See the circle',
  coin_store_preview_candle: 'See the candle',
  coin_store_already_subscribed: 'Already subscribed',
  coin_store_no_products: 'No products available',
  coin_store_no_frames: 'No frames available',
  coin_store_no_flowers: 'No flowers available',
  coin_store_no_candles: 'No candles available',
  coin_store_no_plants: 'No plants available',
  coin_store_no_cure_products: 'No Cure products available',
  coin_store_search_placeholder: 'Search',
  coin_store_sort_placeholder: 'Sort',
  coin_store_sort_name: 'Name',
  coin_store_sort_price_low: 'Price: Low to High',
  coin_store_sort_price_high: 'Price: High to Low',
  coin_store_tab_all: 'ALL',
  coin_store_tab_physical: 'PHYSICAL',
  coin_store_tab_digital: 'DIGITAL',
  coin_store_tab_gift: 'GIFT A FAVOR',
  coin_store_category_frames: 'Circles',
  coin_store_hero_heading: 'End Of Time Collection',
  coin_store_hero_subheading: 'Each light and circle bringing presence back.',
  coin_store_hero_image_alt: 'store illustration',
  coin_store_hero_pill_label: 'Everlight — follows the circadian rhythm at the grave',
  coin_store_hero_note1: 'calm animation, gentle on the eyes',
  coin_store_hero_note2: 'designed for presence — not noise',
  coin_store_filters: 'Filters',
  nav_section: 'Navigation',
  account_section: 'Account',
  aria_menu: 'menu',
  aria_profile_menu: 'profile menu',
  aria_notifications: 'notifications',
  aria_home: 'home',
  aria_my_light: 'my light',
  aria_open_search: 'open search',
  aria_close_search: 'close search',
  verified: 'Verified',
  claimed_by_you: 'Claimed by you',
  claimed_explainer: 'This grave is verified and linked to your account.',
  composer_visibility: 'Visibility',
  composer_public: 'Public',
  composer_relatives: 'Relatives',
  composer_private: 'Private',
  composer_public_desc: 'everyone',
  composer_relatives_desc: 'Visible to family/followers',
  composer_private_desc: 'Only for you',
  composer_more: 'More options …',
  composer_fewer: 'Fewer options',
  composer_caption_ph: 'Caption (optional)',
  composer_add_link_prompt: 'Paste a link (URL)',
  composer_add_link: 'Add link',
  composer_add_emoji: 'Add emoji',
  composer_search_emoji: 'Search emojis',
  reply: 'Reply',
  store_products: 'Circles and candles',
  store_products_subheading: 'Choose now. Use it from My choices after purchase.',
  store_intro_eyebrow: 'Presence on Nettgrav',
  store_intro_title: 'For someone on your mind',
  store_intro_body:
    'Here you can find candles and circles that give your thoughts a personal expression.',
  store_intro_candles: 'Light a candle',
  store_intro_frames: 'Choose a circle',
  store_intro_inventory: 'View My choices',
  store_frames_description:
    'A digital circle around the profile photo on a grave. After purchase, choose which grave to use it on from My choices.',
  store_candles_description:
    'A digital candle you can light on a grave now or on an anniversary. One purchase adds one candle to My choices.',
  store_view_all: 'View all {category}',
  store_choose_frame: 'Choose this circle',
  store_choose_candle: 'Choose this candle',
  store_preview_no_grave:
    'You can complete your choice now and choose a grave from My choices after purchase.',
  store_preview_example_grave: 'Example grave',
  store_cart_open: 'Open your choice',
  store_cart_close: 'Close your choice',
  store_cart_decrease: 'Decrease quantity',
  store_cart_increase: 'Increase quantity',
  store_cart_remove: 'Remove from your choice',
  store_cart_empty: 'You have not chosen anything yet.',
  store_continue_checkout: 'Continue',
  store_favorites_section: 'Saved for later',
  store_favorite_add: 'Save for later',
  store_favorite_remove: 'Remove saved item',
  coin_store_select_frame_title: 'Choose a circle',
  coin_store_select_frame_subtitle: 'Choose a circle you want to add to your collection.',
  coin_store_select_frame_confirm: 'Select this one?',
  frame_upload_title: 'Add New Frame',
  frame_upload_name_label: 'Name',
  frame_upload_name_placeholder: 'Frame name',
  frame_upload_name_required: 'Enter frame name',
  frame_upload_kind_label: 'Kind',
  frame_upload_kind_svg: 'SVG',
  frame_upload_kind_lottie: 'Lottie',
  frame_upload_kind_gif: 'GIF',
  frame_upload_kind_apng: 'APNG',
  frame_upload_kind_webp: 'WebP',
  frame_upload_kind_mp4: 'MP4',
  frame_upload_kind_webm: 'WebM',
  frame_upload_kind_mov: 'MOV',
  frame_upload_kind_tgs: 'TGS',
  frame_upload_viewbox_label: 'ViewBox',
  frame_upload_viewbox_placeholder: 'e.g., 0 0 100 100',
  frame_upload_viewbox_extra: "Format: 'minX minY width height'",
  frame_upload_inner_circle_label: 'Inner Circle',
  frame_upload_inner_circle_extra: 'Circle center (cx, cy) and radius (r) in viewBox units',
  frame_upload_inner_circle_cx_placeholder: 'cx',
  frame_upload_inner_circle_cy_placeholder: 'cy',
  frame_upload_inner_circle_r_placeholder: 'r',
  frame_upload_asset_file_label: 'Asset File',
  frame_upload_asset_file_button: 'Select file',
  frame_upload_asset_file_required: 'Please select at least one file.',
  frame_upload_price_label: 'Price',
  frame_upload_price_placeholder: 'Enter price',
  frame_upload_price_required: 'Enter price',
  frame_upload_description_label: 'Description',
  frame_upload_description_placeholder: 'Describe this frame',
  frame_upload_color_label: 'Color',
  frame_upload_color_red: 'Red',
  frame_upload_color_blue: 'Blue',
  frame_upload_color_green: 'Green',
  frame_upload_theme_label: 'Theme',
  frame_upload_theme_light: 'Light',
  frame_upload_theme_dark: 'Dark',
  frame_upload_submit: 'Upload',
  frame_upload_delete_title: 'Delete Frame',
  frame_upload_delete_content: 'This is permanent.',
  frame_upload_delete_ok: 'Delete',
  frame_apply: 'Apply',
  frame_buy_more: 'Choose circle',
  frame_available_quantity: 'Available: x{count}',
  frame_applied_at: 'Applied at:',
  frame_no_graves_yet: 'Your connected graves will appear here',
  frame_no_graves_active: 'No active graves yet.',
  no_frames_available: 'You don’t have any circles yet. See the circles you can choose from.',
  frame_modal_title: 'Choose a circle or add a photo',
  frames_store_title: 'Circles',
  send_gift: 'Light a candle',
  gift_message_label: 'Words for the grave',
  gift_event_context_time: 'on {event} · {time}',
  gift_message_placeholder: 'Write a few words, if you want',
  no_gifts_available: 'No gifts available.',
  no_gifts_yet: 'Light a candle for {graveName}',
  candles: 'Candles',
  choose_candle: 'Choose candle',
  add_candle: 'Add candle',
  buy_gifts: 'Buy gifts',
  gifts_title: 'Gifts',
  gifts_empty_state: 'No gifts have been added yet.',
  previous_gift: 'Previous gift',
  next_gift: 'Next gift',
  gift_update_success: 'Gift updated',
  gift_delete_success: 'Gift deleted',
  gifts_load_error: 'Unable to load gifts right now.',
  gift_update_error: 'Unable to update gift.',
  gift_delete_error: 'Unable to delete gift.',
  gift_edit_title: 'Edit Gift',
  gift_sent: 'Gift sent',
  gift_send_error: 'Failed to send gift',
  gift_event_by_user: '{event} by {user}',
  my_light_tooltip: 'Your Spark makes the world a better place.',
  edit_text_description: 'Add, edit, or remove text',
  products_title: 'Circles and candles',
  products_add_product: 'Add Product',
  products_edit_product: 'Edit Product',
  products_table_index: 'Index',
  products_table_name: 'Name',
  products_table_image_or_frame: 'Image or Frame',
  products_table_price: 'Price',
  products_table_description: 'Description',
  products_table_action: 'Action',
  products_action_edit: 'Edit',
  products_action_delete: 'Delete',
  products_form_type_label: 'Type',
  products_form_type_frame: 'Frame',
  products_form_type_cure: 'Cure',
  products_form_type_flower: 'Flower',
  products_form_type_plant: 'Plant',
  products_form_type_candle: 'Candle',
  products_form_cure_name_label: 'Name',
  products_form_cure_name_placeholder: 'Product name',
  products_form_cure_name_required: 'Enter product name',
  products_form_cure_lengths_label: 'Lengths',
  products_form_cure_lengths_placeholder: 'Enter subscription lengths',
  products_form_cure_lengths_required: 'Enter lengths',
  products_form_cure_price_label: 'Price',
  products_form_cure_price_placeholder: 'Enter price',
  products_form_cure_price_required: 'Enter price',
  products_form_cure_description_label: 'Description',
  products_form_cure_description_placeholder: 'Describe this product',
  products_form_cure_image_label: 'Image',
  products_form_cure_image_required: 'Please select an image.',
  products_form_upload_button: 'Upload',
  products_form_translations_label: 'Translations',
  products_form_add_translation: 'Add translation',
  products_form_translations_help:
    'Provide optional language-specific copy to override the English default.',
  products_form_translation_locale_label: 'Language',
  products_form_translation_locale_required: 'Select a language',
  products_form_translation_locale_placeholder: 'Choose language',
  products_form_translation_name_label: 'Name',
  products_form_translation_name_required: 'Enter a name',
  products_form_translation_name_placeholder: 'Translated product name',
  products_form_translation_description_label: 'Description',
  products_form_translation_description_placeholder: 'Translated description (optional)',
  products_form_translation_remove: 'Remove translation',
  products_delete_error_in_use: 'Unable to delete this product because it is still in use.',
  checkout_purchase_success: 'Purchase successful',
  checkout_payment_failed: 'Payment failed',
  checkout_missing_payment_method_id: 'Missing payment method ID',
  lighthouse_title: 'End Of Time Collection',
  lighthouse_subtitle: 'Each light and circle bringing presence back.',
  lighthouse_description:
    'A steadfast light on the horizon, guiding love through dark waters. Calm seas, quiet strength, and a beam that says: you are never alone. A gentle tribute for coastal hearts and for anyone who carried others safely home.',
  lighthouse_go_to_store: 'See the collection',
  frame_info_title: 'How to add a frame',
  frame_info_description:
    '1. Go to the grave you want to edit.\n2. Click the grave’s profile image.\n3. Choose a frame—it will appear on the grave immediately.',
  profile_and_settings: 'Profile & settings',
  help_and_support: 'Help & support',
  report_problem: 'Report a problem',
  light_theme: 'Light theme',
  dark_theme: 'Dark theme',
  toggle_theme: 'Toggle theme',
  toggle_theme_to_dark: 'Switch to dark mode',
  toggle_theme_to_light: 'Switch to light mode',
  partner_title: 'Partner',
  partner_become_seller: 'Become partner (seller account)',
  partner_status_pending: 'Partner status: awaiting approval',
  partner_apply: 'Apply to become a partner',
  partner_open_portal: 'Open partner portal',
  partner_dashboard: 'Partner dashboard',
  partner_create_ad: 'Create ad/product',
  partner_payouts: 'Payouts',
  'designSystem.showcase.title': 'Design System',
  'designSystem.colors.title': 'Portal color scheme',
  'designSystem.colors.silver': 'Silver',
  'designSystem.colors.gold': 'Gold',
  'designSystem.colors.roseGold': 'Rose Gold',
  'designSystem.colors.bronze': 'Bronze',
  'designSystem.colors.titanium': 'Titanium',
  'designSystem.colors.emerald': 'Emerald',
  'designSystem.colors.platinum': 'Platinum',
  'designSystem.colors.copper': 'Copper',
  'designSystem.colors.amethyst': 'Amethyst',
  'designSystem.colors.sapphire': 'Sapphire',
  'designSystem.colors.ruby': 'Ruby',
  'designSystem.colors.obsidian': 'Obsidian',
  'designSystem.colors.aqua': 'Aqua',
  'designSystem.colors.sunset': 'Sunset',
  'designSystem.colors.surfaces': 'Surface tokens',
  'designSystem.colors.text': 'Text tokens',
  'designSystem.colors.metallic': 'Metallic Palettes',
  'designSystem.colors.viewMetallicIcons': 'View metallic icon demo',
  'designSystem.anniversaries.upcoming': 'Upcoming anniversaries',
  'designSystem.anniversaries.breakdown.title': 'Next 7 days',
  'designSystem.anniversaries.grave': 'Grave',
  'designSystem.anniversaries.user': 'User',
  'designSystem.anniversaries.public': 'Public',
  'designSystem.anniversaries.total': 'Total',
  'designSystem.grid.sectionTitle': 'Grid layout',
  'designSystem.grid.controls.title': 'Interactive controls',
  'designSystem.grid.controls.align': 'Vertical align',
  'designSystem.grid.controls.justify': 'Horizontal justify',
  'designSystem.grid.controls.horizontalGutter': 'Horizontal gutter (px)',
  'designSystem.grid.controls.verticalGutter': 'Vertical gutter (px)',
  'designSystem.grid.controls.wrap': 'Wrap lines',
  'designSystem.grid.controls.currentProps': 'Active props',
  'designSystem.grid.preview.title': 'Preview',
  'designSystem.grid.align.top': 'Top',
  'designSystem.grid.align.middle': 'Middle',
  'designSystem.grid.align.bottom': 'Bottom',
  'designSystem.grid.align.stretch': 'Stretch',
  'designSystem.grid.justify.start': 'Start',
  'designSystem.grid.justify.center': 'Center',
  'designSystem.grid.justify.end': 'End',
  'designSystem.grid.justify.spaceBetween': 'Space between',
  'designSystem.grid.justify.spaceAround': 'Space around',
  'designSystem.grid.justify.spaceEvenly': 'Space evenly',
  'designSystem.grid.box.label': 'Column {index}',
  'designSystem.grid.box.span': 'span {value}',
  'designSystem.grid.box.offset': 'Offset {value}',
  'designSystem.grid.box.order': 'Order {value}',
  'designSystem.grid.box.flex': 'flex {value}',
  'designSystem.grid.box.grow': 'Fills remaining space',
  'designSystem.grid.responsive.title': 'Responsive example',
  'designSystem.grid.responsive.description':
    'Resize the viewport to watch gutters and alignment update across breakpoints.',
  'designSystem.grid.box.responsive': 'xs 24 → md 12',
  'designSystem.grid.box.responsiveDetail': 'Stacks on mobile, splits on desktop',
  'designSystem.grid.box.responsiveAlign': 'Shares gutter context automatically',
  'designSystem.grid.docs.title': 'Grid layout – Row & Col',
  'designSystem.grid.docs.notes':
    'Row computes responsive gutters and alignment, and Col mirrors them via context so layouts stay consistent.',
  'designSystem.mediaUpload.triggerLabel': 'Select files',
  'designSystem.mediaUpload.type.media': 'media',
  'designSystem.mediaUpload.type.image': 'images',
  'designSystem.mediaUpload.type.video': 'videos',
  'designSystem.mediaUpload.type.audio': 'audio',
  'designSystem.mediaUpload.type.file': 'files',
  'designSystem.mediaUpload.dropHint': 'Drag & drop to upload or browse files',
  'designSystem.mediaUpload.dropActive': 'Release to upload',
  'designSystem.mediaUpload.emptyState': 'No files selected yet',
  'designSystem.mediaUpload.previewVideoLabel': 'Preview of {name}',
  'designSystem.mediaUpload.previewImageAlt': 'Preview of {name}',
  'designSystem.mediaUpload.removeFile': 'Remove {name}',
  'designSystem.mediaUpload.editFile': 'Edit {name}',
  'designSystem.mediaUpload.zoom': 'Zoom',
  'designSystem.mediaUpload.unnamed': 'Untitled file',
  'designSystem.mediaUpload.showcase.defaultLabel': 'Media library',
  'designSystem.mediaUpload.showcase.defaultDescription':
    'Upload new photos, videos or audio to share with your team.',
  'designSystem.mediaUpload.showcase.controlTitle': 'Configuration',
  'designSystem.mediaUpload.showcase.mediaTypeLabel': 'Media type',
  'designSystem.mediaUpload.showcase.multipleLabel': 'Allow multiple files',
  'designSystem.mediaUpload.showcase.maxFilesLabel': 'Max files',
  'designSystem.mediaUpload.showcase.duplicatesLabel': 'Allow duplicate files',
  'designSystem.mediaUpload.showcase.dragLabel': 'Enable drag & drop',
  'designSystem.mediaUpload.showcase.selectedCount':
    '{count, plural, =0 {No files yet} one {# file selected} other {# files selected}}',
  'designSystem.mediaUpload.showcase.helper': 'Maximum {limit} MB per file',
  'designSystem.mediaUpload.showcase.tooLarge': '{name} exceeds the {limit} MB limit',
  'designSystem.mediaUpload.showcase.untitledFile': 'Selected file',
  'designSystem.mediaUpload.showcase.trigger': 'Upload {label}',
  'designSystem.mediaUpload.showcase.dropHint': 'Drag & drop {label} or browse files',
  'designSystem.mediaUpload.showcase.examplesTitle': 'Examples',
  'designSystem.mediaUpload.showcase.imageTitle': 'Gallery images',
  'designSystem.mediaUpload.showcase.imageDescription':
    'Upload retina-ready hero images for landing pages.',
  'designSystem.mediaUpload.showcase.imageHelper': 'PNG or JPG up to {limit} MB each.',
  'designSystem.mediaUpload.showcase.videoTitle': 'Promo video',
  'designSystem.mediaUpload.showcase.videoDescription':
    'Collect a single teaser video for campaigns.',
  'designSystem.mediaUpload.showcase.videoHelper':
    'MP4 up to {limit} MB. We’ll transcode automatically.',
  'designSystem.mediaUpload.showcase.audioTitle': 'Audio tribute',
  'designSystem.mediaUpload.showcase.audioDescription': 'Gather spoken memories or music clips.',
  'designSystem.mediaUpload.showcase.audioHelper': 'MP3 or WAV up to {limit} MB.',
  'designSystem.mediaUpload.showcase.fileTitle': 'Document upload',
  'designSystem.mediaUpload.showcase.fileDescription': 'Store memorial programs or consent forms.',
  'designSystem.mediaUpload.showcase.fileHelper': 'PDF or DOCX up to {limit} MB each.',
  'designSystem.mediaUpload.showcase.buttonTitle': 'Quick upload button',
  'designSystem.mediaUpload.showcase.buttonDescription':
    'Single tap button with icon for quick uploads.',
  'designSystem.mediaUpload.showcase.buttonHelper': 'Tap the button to pick one or more files.',
  'designSystem.mediaUpload.showcase.buttonTrigger': 'Choose files',
  'designSystem.mediaUpload.showcase.imageButtonCaption':
    'Tap the media button or drop hero images here.',
  'designSystem.mediaUpload.showcase.imageButtonAria': 'Add gallery image',
  'designSystem.mediaUpload.showcase.videoButtonCaption':
    'Drop or select a promo trailer to share.',
  'designSystem.mediaUpload.showcase.videoButtonAria': 'Add campaign video',
  'library.mediaUpload.trigger': '{count, plural, =0 {Upload media} other {Add more media}}',
  'library.mediaUpload.helper': 'Drag files here or browse from your device.',
  'settings.security.title': 'Security',
  'settings.security.sessions.title': "Where you're logged in",
  'settings.security.sessions.device': 'Device',
  'settings.security.sessions.this_device': 'This device',
  'settings.security.sessions.last_active': 'Last active',
  'settings.security.sessions.created': 'Created',
  'settings.security.sessions.expires': 'Expires',
  'settings.security.sessions.ip': 'IP',
  'settings.security.sessions.logout': 'Log out',
  'settings.security.sessions.logout_all': 'Log out of all devices',
  'settings.security.sessions.logout_others': 'Log out of other devices',
  'auth.remember_me': 'Remember me',
  'security.alerts.reuse_detected.title': 'We ended your session to keep you safe',
  'security.alerts.reuse_detected.body':
    'We noticed a sign-in that looked unusual. Please change your password if this wasn’t you.',
  'gettingStarted.title': 'Welcome',
  'gettingStarted.subtitle': 'Start by searching their name to find a grave.',
  'gettingStarted.search': 'Search',
  'gettingStarted.search.placeholder': 'Search by name',
  'gettingStarted.addRelation': 'Add someone',
  'gettingStarted.explainer':
    'Set your relation to keep the grave close with updates, anniversaries, and gentle reminders.',
  'search.publicNotice.title': 'Public records',
  'search.publicNotice.body': 'Sign in to view photos, memories, and more.',
  // Header/Notifications additions
  design_system: 'Design system',
  account_menu: 'Account menu',
  guest_menu: 'Menu',
  'guest_menu.subtitle': 'Explore more of Nettgrav or sign in to continue.',
  more_information: 'More information',
  settings: 'Settings',
  logout: 'Sign out',
  accepted: 'Accepted',
  rejected: 'Rejected',
  // Groups & Group Details
  'groups.title': 'Rooms',
  'groups.loading': 'Loading groups…',
  'groups.error': 'Error loading groups',
  'groups.empty': 'No groups yet.',
  'groups.createGroup': 'Create Group',
  'groups.form.name': 'Name',
  'groups.form.description': 'Description',
  'groups.form.category': 'Category',
  'groups.form.paid': 'Paid room',
  'groups.mode.explore': 'Explore rooms',
  'groups.mode.mine': 'My rooms',
  'groups.search': 'Search rooms',
  'groups.category': 'Category',
  'groups.category.all': 'All categories',
  'groups.create.title': 'Create a room',
  'groups.form.desc': 'Description (optional)',
  'groups.form.create': 'Create room',
  'groups.view': 'View',
  'groups.join': 'Join room',
  'groups.empty.hint': 'Try changing filters or create a new room.',
  loading: 'Loading…',
  'error.generic': 'Something went wrong.',
  'pagination.prev': 'Previous',
  'pagination.next': 'Next',
  notifications_load_more: 'Load more',
  'groups.subtitle': 'What would you like to talk about today?',
  'groups.categories.label': 'Categories',
  'groups.mine.filters.sub': 'Filter rooms by your role.',
  'groups.mine.filter.all': 'All',
  'groups.mine.filter.led': 'Led by you',
  'groups.mine.filter.member': 'Member',
  'groups.mine.filter.pending': 'Pending',
  'groups.mine.section.led': 'Rooms you lead',
  'groups.mine.section.led.sub': 'Rooms where you are owner or admin.',
  'groups.mine.section.member': 'Rooms you are in',
  'groups.mine.section.member.sub': 'Rooms where you are an active member.',
  'groups.mine.section.pending': 'Pending requests',
  'groups.mine.section.pending.sub': 'Rooms where your request or invite is still pending.',
  'groups.mine.empty.title': 'No rooms in this section yet',
  'groups.mine.empty.hint': 'Switch filter or explore rooms to join.',
  'groups.mine.empty.cta': 'Explore rooms',
  'groups.mine.empty.all.title': 'You are not part of any rooms yet',
  'groups.mine.empty.all.hint': 'Explore rooms or create one to get started.',
  'groups.mine.overview.title': 'Your rooms',
  'groups.mine.overview.sub': 'Rooms you lead, participate in, or are waiting to join.',
  'groups.mine.load_error.title': 'Could not load your rooms',
  'groups.mine.load_error.text': 'Try again in a moment.',
  'groups.mine.retry': 'Try again',
  'groups.mine.search_empty.title': 'No rooms match your search',
  'groups.mine.search_empty.text': 'Try another room name or clear the search.',
  'groups.mine.search_empty.clear': 'Clear search',
  'groups.mine.feed.error.title': 'Could not load recent activity',
  'groups.mine.feed.error.text': 'Your rooms are still available above.',
  'groups.sidebar.mine.title': 'Your recent rooms',
  'groups.sidebar.mine.sub': 'Quick access to rooms you already follow.',
  'groups.category_name.local': 'Local',
  'groups.category_name.science_and_tech': 'Science and tech',
  'groups.category_name.education': 'Education',
  'groups.category_name.health': 'Health',
  'groups.category_name.lifestyle': 'Lifestyle',
  'groups.category_name.travel': 'Travel',
  'groups.category_name.sports': 'Sports',
  'groups.category_name.technology': 'Technology',
  'groups.category_name.family': 'Family',
  'groups.category_name.grief_and_loss': 'Grief and loss',
  'groups.category_name.spirituality': 'Religion and faith',
  'groups.category_name.relationships': 'Relationships',
  'groups.category_name.life_choices': 'Life choices',
  'groups.category_name.existence': 'Existence',
  'groups.category_name.guidance': 'Guidance',
  'groups.create.cta': 'Create room',
  'groups.empty.title': 'No rooms found',
  'groups.empty.hint': 'There are no rooms matching your search right now.',
  'groups.empty.initial.title': 'No open rooms yet',
  'groups.empty.initial.hint':
    'Create the first room and invite people into a meaningful conversation.',
  'groups.empty.clear': 'Clear search and filters',
  'groups.card.view': 'Open',
  'groups.card.enter': 'Enter',
  'groups.card.owner': 'Room holder',
  'groups.card.owner.you': 'You',
  'create_group.title': 'Create room',
  'create_group.open_title': 'Open a room',
  'create_group.open_subtitle': 'A room gathers people around what matters.',
  'create_group.name_prompt': 'What should the room be called?',
  'create_group.name': 'What should the room be called?',
  'create_group.name.placeholder': 'Name of room',
  'create_group.desc_prompt': 'What does this room hold?',
  'create_group.desc': 'What should this room hold?',
  'create_group.desc.placeholder': 'What can be shared here?',
  'create_group.category': 'Direction',
  'create_group.category.optional_label': 'Direction (optional)',
  'create_group.category.placeholder': 'Choose direction',
  'create_group.category.required': 'Choose a direction.',
  'create_group.paid': 'Paid room (optional)',
  'create_group.free': 'Free',
  'create_group.submit': 'Create room',
  'create_group.open_submit': 'Open room',
  'create_group.cancel': 'Cancel',
  'create_group.cover.label': 'Room image (optional)',
  'create_group.cover.preview_alt': 'Preview of room image',
  'create_group.cover.empty': 'No room image selected yet.',
  'create_group.cover.choose': 'Choose room image',
  'create_group.cover.adjust_crop': 'Adjust crop',
  'create_group.cover.remove': 'Remove',
  'create_group.cover.hint':
    'The image is added when the room is created and can be changed later in Settings.',
  'create_group.cover.upload_error': 'Could not upload room image. You can add it in Settings.',
  'create_group.cover.image_only': 'Please choose an image file.',
  'groups.settings.cover.crop': 'Adjust room image',
  'groups.settings.cover.safe_area': 'Keep important details inside the dashed frame.',
  crop_zoom: 'Zoom',
  'gravesHub.title': 'Your people',
  'gravesHub.hero.eyebrow': 'Keeping close',
  'gravesHub.hero.title': 'The people I look after',
  'gravesHub.hero.subtitle':
    'Everything about the people you check in on sits here—updates, dates, and who else is involved.',
  'gravesHub.hero.graveCount':
    'You currently follow {count, plural, one {# person} other {# people}} in Nettgrav.',
  'gravesHub.hero.cta': 'Add someone new',
  'gravesHub.hero.secondary': 'See invitations',
  'gravesHub.myGraves': 'My graves',
  'gravesHub.myGraves.count': '{count}',
  'gravesHub.create': 'Add a person',
  'gravesHub.myGraves.empty':
    'No one here yet. Add someone or accept an invitation to get started.',
  'gravesHub.myGraves.emptyAction': 'Add someone new',
  'gravesHub.myGraves.viewInvites': 'Accept invitation',
  'gravesHub.guest':
    'Here you will find the graves you belong to. A place for closeness, presence, and care over time. Sign in to get started.',
  'gravesHub.guest_preview.name_1': 'Lorense Hansen',
  'gravesHub.guest_preview.role_1': 'Grandmother',
  'gravesHub.guest_preview.name_2': 'Oskar Johansen',
  'gravesHub.guest_preview.role_2': 'Father',
  'gravesHub.guest_preview.name_3': 'Anna Solberg',
  'gravesHub.guest_preview.role_3': 'Family friend',
  'gravesHub.guest_preview.place': 'Vestre gravlund, Oslo',
  'gravesHub.guest_preview.selected_copy':
    'A place to see the graves you are connected to, open the grave, and invite others who also care for it.',
  'gravesHub.guest_preview.visit': 'Open grave',
  'gravesHub.guest_preview.invite': 'Invite family',
  'gravesHub.guest_preview.update_author_1': 'Maren added a memory',
  'gravesHub.guest_preview.update_time_1': '2 hours ago',
  'gravesHub.guest_preview.update_body_1':
    'Maren is thankful for Lorense Hansen. A sign of presence, without needing many words.',
  'gravesHub.guest_preview.update_author_2': 'Isak added a photo',
  'gravesHub.guest_preview.update_time_2': 'Yesterday',
  'gravesHub.guest_preview.update_body_2':
    'Isak added a photo so the family can keep more of Lorense Hansen together here.',
  'gravesHub.loading.graves': 'Gathering the graves you care for...',
  'gravesHub.loading.error': "We couldn't fetch your people right now. Refresh to try again.",
  'gravesHub.loading.completed': 'Synced in {seconds}s',
  'gravesHub.feed.title': 'Grave wall',
  'gravesHub.feed.noSelection': 'Choose a grave to be present here.',
  'gravesHub.feed.empty': 'It is quiet here for now.',
  'gravesHub.invite': 'Invite family to help care for the grave',
  'gravesHub.selected.copy': 'Keep up with what’s happening, and bring in others you trust.',
  'gravesHub.memory.photoOnly': 'Added a photo for the grave',
  'gravesHub.memory.view': 'Read memory',
  'gravesHub.memory.empty': 'No memories yet. Share a story that helps family remember.',
  'gravesHub.memory.loadMore': 'Show more updates',
  'gravesHub.visitNamed': 'Visit {name}’s grave',
  'gravesHub.visitFallback': 'Visit grave',
  'gravesHub.invitations.shortcut':
    '{count, plural, one {# invitation waiting} other {# invitations waiting}}',
  'gravesHub.invitations.title': 'Shared care invitations',
  'gravesHub.invitations.manage': 'Manage',
  'gravesHub.invitations.invitedBy': 'Wants to help care for this grave with you',
  'gravesHub.invitations.accept': 'Accept',
  'gravesHub.invitations.decline': 'Decline',
  'gravesHub.invitations.acceptSuccess': 'Invitation accepted',
  'gravesHub.invitations.declineSuccess': 'Invitation declined',
  'gravesHub.invitations.actionError': 'Something went wrong. Try again.',
  'gravesHub.gettingStarted.title': 'Today',
  'gravesHub.gettingStarted.reminders': 'Email nudges',
  'gravesHub.gettingStarted.remindersHint':
    'Get a gentle heads-up before important days or new updates.',
  'gravesHub.starter.anniversaries.title': 'Memorial days',
  'gravesHub.starter.anniversaries.body': 'Add dates that help family remember together.',
  'gravesHub.starter.anniversaries.action': 'Add a date to remember',
  'gravesHub.starter.memory.title': 'Photos',
  'gravesHub.starter.memory.body': 'Add photos the family may want to keep together.',
  'gravesHub.starter.memory.action': 'Add photos',
  'gravesHub.shortcuts.title': 'Shortcuts',
  'gravesHub.shortcuts.invite': 'Invite family to help care',
  'gravesHub.shortcuts.invite.copy':
    'Share access so family can add memories, photos, and context.',
  'gravesHub.shortcuts.email': 'Email settings',
  'gravesHub.shortcuts.email.copy': 'Fine-tune reminders and notifications.',
  'gravesHub.shortcuts.open': 'Open grave',
  'gravesHub.shortcuts.open.copy':
    'Visit the full grave page for stories, photos, and shared care.',
  'gravesHub.tips.title': 'Keep in touch',
  'gravesHub.tips.applyFrame.title': 'Make it personal',
  'gravesHub.tips.applyFrame.body':
    'You have frames ready. Want to add one that fits {hasName, select, yes {{firstName}} other {them}}?',
  'gravesHub.tips.applyFrame.cta': 'Apply a frame',
  'gravesHub.tips.invite.title': 'Bring trusted relatives in',
  'gravesHub.tips.invite.body':
    'Share responsibility and access, so stories and care are carried together.',
  'gravesHub.tips.invite.cta': 'Send invite',
  'gravesHub.tips.reminders.title': 'Email reminder',
  'gravesHub.tips.reminders.body': 'Get an email reminder before important events.',
  'gravesHub.tips.info.title': 'Build a steady care rhythm',
  'gravesHub.tips.info.body':
    'Use reminders, updates, and shared access to keep care steady over time.',
  'gravesHub.store.title': 'Small actions with deep meaning',
  'gravesHub.store.description':
    'Discover End Of Time Collection – lights and circles that bring presence back.',
  'gravesHub.store.candle.title': 'Light a candle',
  'gravesHub.store.candle.body': 'A quiet act of love that lasts.',
  'gravesHub.store.candle.cta': 'Keep the light burning',
  'gravesHub.store.frame.title': 'Choose a circle',
  'gravesHub.store.frame.body': 'Find the one that reflects your bond.',
  'gravesHub.store.frame.cta': 'Choose circle',
  'gravesHub.store.tree.title': 'Plant a tree',
  'gravesHub.store.tree.body': 'Plant a living tribute in their honour through our partners.',
  'gravesHub.store.tree.cta': 'Plant a tree',
  'gravesHub.notifications.updated': 'Reminder preferences updated',
  'gravesHub.notifications.error':
    'We could not update your reminder preferences. Please try again.',
  'gravesHub.notifications.noSelection': 'Choose a person to continue.',
  'gravesHub.sidePanel.title': 'Support & guidance',
  'gravesHub.sidePanel.empty':
    'Select a grave to see tips and tools for keeping the memorial up to date.',
  'create_group.invite.title': 'Invite friends (optional)',
  'create_group.invite.placeholder_name': 'Enter name or email',
  'create_group.invite.placeholder_msg': 'Write message',
  // Post-purchase apply flow
  'postPurchase.applyFrame.title': 'Use your new purchase now?',
  'postPurchase.applyFrame.body': 'You can add what you just bought to a grave right away.',
  'postPurchase.applyFrame.select': 'Choose a grave',
  'postPurchase.applyFrame.apply': 'Apply to this grave',
  'postPurchase.applyFrame.inventory': 'Go to My collection',
  'postPurchase.applyFrame.skip': 'Skip for now',
  // Inventory quick apply
  'inventory.applyFrame': 'Use this now',
  'inventory.applyFrame.select': 'Choose someone',
  'inventory.applyFrame.open': 'Open page',
  'inventory.apply.select': 'Choose someone',
  'inventory.apply.button.frame': 'Use this circle now',
  'inventory.apply.button.candle': 'Light this candle now',
  'inventory.apply.button.default': 'Use this now',
  'inventory.apply.title.frame': 'Who should wear this circle?',
  'inventory.apply.title.candle': 'Who are you lighting the candle for?',
  'inventory.apply.title.default': 'Use your new item',
  'inventory.apply.link.store': 'Find another candle in the store',
  'inventory.buyMore.frame': 'Find another circle',
  'inventory.buyMore.candle': 'Pick another candle',
  'inventory.buyMore.default': 'Find something new',
  grave_candles_light_now: 'Light a candle for {name}',
  grave_candles_browse_store: 'Find another candle',
  cover_photo_adjust_hint: 'Adjust the image until it feels right',
  cover_photo_drag_hint: 'Drag to adjust',
  cover_photo_reset: 'Reset position',
  frame_apply_success: 'Frame applied',
  frame_apply_failed: 'Could not apply the frame',
  remove_grave_frame: 'Remove profile circle',
  frame_remove_success: 'Frame removed',
  frame_remove_failed: 'Could not remove the frame',
  loading: 'Loading…',
  'per_page.label': 'Per page',
  'notifications.group_invite.eyebrow': 'Group invitation',
  'notifications.group_invite.title': '{inviterName} invited you to {groupName}',
  'notifications.group_invite.body': 'Accept the invitation to join this group conversation.',
  'notifications.group_invite.accepted': 'Group invitation accepted.',
  'notifications.group_invite.declined': 'Group invitation declined.',
  'notifications.group_invite.action_error': 'Could not update the group invitation.',
  'notifications.group_join_request.eyebrow': 'Group join request',
  'notifications.group_join_request.title': '{requesterName} requested to join {groupName}',
  'notifications.group_join_request.accepted': 'Group join request approved.',
  'notifications.group_join_request.declined': 'Group join request declined.',
  'notifications.group_join_request.action_error': 'Could not update the group join request.',
  'groups.accept.working': 'Accepting your invitation…',
  'groups.accept.ok': 'You’ve joined the group.',
  'groups.accept.view': 'Go to group',
  'groups.accept.fail': 'Invite is invalid or expired.',
  'groups.accept.back': 'Back to groups',
  'groups.accept.title': 'Group invite',
  'groups.accept.loading': 'Loading invitation...',
  'groups.accept.auth_required': 'Login or create an account to view this group invitation.',
  'groups.accept.member_count': '{count, plural, one {# member} other {# members}}',
  'groups.accept.invite_label': 'Group invitation',
  'groups.members.label': 'People in room: {count}',
  'groups.confirm.delete': 'Delete this group?',
  'groupDetails.loading': 'Loading group…',
  'groupDetails.error': 'Error loading group',
  'groupDetails.edit': 'Edit room',
  'groupDetails.form.name': 'Name',
  'groupDetails.form.description': 'Description',
  'groupDetails.form.category': 'Category',
  'groupDetails.addMember.title': 'Invite to room',
  'groupDetails.addMember.searchLabel': 'Invite person (search by name)',
  'groupDetails.addMember.placeholder': 'Search users…',
  'groupDetails.addMember.selected': 'Selected',
  'groupDetails.addMember.selectedId': 'Selected user ID:',
  'groupDetails.addMember.role': 'Role',
  'groupDetails.addMember.status': 'Status',
  'groupDetails.addMember.submit': 'Invite',
  // Groups UI (new components)
  'groups.banner.members': '{count, number} members · {posts, number} posts/day',
  'groups.banner.members_only': '{count, number} members',
  'groups.banner.default_subtitle': 'A room for calm conversations.',
  'groups.banner.held_by': 'Held by {name}',
  'groups.composer.label': 'New post',
  'groups.composer.helper': 'Share a few words, a photo, or a video in the room.',
  'groups.section.about.title': 'About this room',
  'groups.section.about.text': 'See the description, guidelines, and who holds the room.',
  'groups.section.members.title': 'People in the room',
  'groups.section.members.text': 'See who is here and invite more people when appropriate.',
  'groups.section.files.title': 'Photos, videos, and documents',
  'groups.section.files.text': 'Everything shared in the room, collected in one place.',
  'groups.section.requests.title': 'Pending requests',
  'groups.section.requests.text': 'Review membership and post requests here.',
  'groups.section.settings.title': 'Room settings',
  'groups.section.settings.text': 'Adjust visibility, guidelines, and how the room works.',
  'groups.tabs.about': 'About',
  'groups.tabs.members': 'People in room',
  'groups.tabs.files': 'Files',
  'groups.tabs.requests': 'Requests',
  'groups.tabs.settings': 'Settings',
  'groups.tabs.mobile_nav': 'Room section',
  phone_number: 'Phone number',
  'groups.composer.placeholder': 'Share something in the room…',
  'groups.preview.author': 'Room holder',
  'groups.preview.just_now': 'says',
  'groups.invite.title': 'Invite members',
  'groups.invite.subtitle': 'Bring friends to this community',
  'groups.invite.sent': 'Invitation sent.',
  'groups.cta.invite': 'Invite',
  'groups.cta.post': 'Share',
  'groups.see_comments': 'See conversation',
  'groups.banner.join': 'Join',
  'groups.banner.request_join': 'Request to join',
  'groups.banner.joined': 'Joined',
  'groups.files.empty': 'No files yet.',
  'groups.join.unavailable': 'Joining requires an invite or owner approval.',
  'groups.join.success': 'You joined the room.',
  'groups.join.toPost': 'Join this room to share.',
  'groups.leave': 'Leave room',
  'groups.leave.confirm': 'Leave this group?',
  'groups.leave.success': 'You left the room.',
  'groups.leave.unavailable': 'Could not leave this group.',
  'groups.comments.create_error': 'Could not share the reply.',
  'groups.comments.update_error': 'Could not update reply.',
  'groups.comments.delete_error': 'Could not delete reply.',
  'groups.comments.delete.confirm': 'Delete this reply?',
  'groups.comments.delete.title': 'Delete reply',
  'groups.comments.delete.body':
    'This reply will be removed from the conversation. This cannot be undone.',
  'groups.comments.placeholder': 'Write a reply...',
  'groups.comments.empty': 'No replies yet.',
  'groups.comments.post': 'Share',
  'groups.hide_comments': 'Hide conversation',
  'groups.post.pending': 'Sharing...',
  'groups.post.awaiting_approval': 'Awaiting approval',
  'groups.post.create_error': 'Could not publish post. Please try again.',
  'groups.post.update_error': 'Could not update post.',
  'groups.post.delete.confirm': 'Delete post?',
  'groups.post.delete_error': 'Could not delete post.',
  'groups.post.delete.title': 'Delete post',
  'groups.post.delete.body':
    'The post and its replies will be removed from the room. This cannot be undone.',
  'groups.post.share': 'Share',
  'groups.post.share_success': 'The post link was copied.',
  'groups.post.share_error': 'Could not share the post.',
  'groups.day.today': 'Today',
  'groups.day.yesterday': 'Yesterday',
  'groups.day.unknown': 'Earlier',
  invite_coming_soon: 'Invites coming soon',
  'groupDetails.addMember.loadMore': 'Load more',
  'groupDetails.members.title': 'Members',
  'groupDetails.members.empty': 'No members yet.',
  'groupDetails.members.table.id': 'ID',
  'groupDetails.members.table.user': 'User',
  'groupDetails.members.table.role': 'Role',
  'groupDetails.members.table.status': 'Status',
  'groupDetails.members.table.actions': 'Actions',
  'groupDetails.members.remove': 'Remove',
  'groupDetails.confirm.remove': 'Remove member?',
  'groupDetails.categoryPrefix': 'Category: {name}',
  'groupDetails.fallbackTitle': 'Group #{id}',
  create_grave_validation_full_date_required: 'Please select year, month, and day',
  create_grave_date_help: 'Select year, then month, then day',
  'checkout.gift.buyAsGift': 'Buy as gift',
  'checkout.gift.recipient': 'Recipient',
  'checkout.gift.recipient.placeholder': 'Recipient username or slug',
  'nav.sparks': 'Create Spark',
  'nav.my_family': 'Family tree',
  'nav.home': 'Home',
  'nav.groups': 'Rooms',
  'rooms.navigation.unread_label':
    'Rooms, {count, plural, one {# unread message} other {# unread messages}}',
  'rooms.mine.navigation.unread_label':
    'My rooms, {count, plural, one {# unread message} other {# unread messages}}',
  'rooms.inbox.muted': 'Notifications muted',
  'rooms.inbox.room_unread_label':
    '{count, plural, one {# unread message} other {# unread messages}}',
  'nav.familyTree': 'Family tree',
  'nav.graves': 'My graves',
  'nav.store': 'Presence',
  'nav.primary': 'Primary navigation',
  'nav.mobile_graves': 'Graves',
  'header.openMessages': 'Open messages',
  'messenger.searchPlaceholder': 'Search conversations',
  'messenger.newConversation': 'New conversation',
  'messenger.loading': 'Loading conversations…',
  'messenger.error': 'We could not load your messages.',
  'messenger.emptyState': 'No conversations yet. Start a conversation to stay in touch.',
  'messenger.selectThread': 'Select a conversation to view messages.',
  'messenger.emptyMessages': 'No messages yet. Say hello to get the conversation started.',
  'messenger.attach': 'Attach file',
  'messenger.emoji': 'Insert emoji',
  'messenger.send': 'Send',
  'messenger.call': 'Start call',
  'messenger.typing': 'Typing…',
  'messenger.online': 'Online',
  'messenger.status.online': 'Online',
  'messenger.status.offline': 'Offline',
  'messenger.status.lastSeen': 'Last seen {time}',
  'messenger.status.group': 'Group conversation',
  'messenger.status.groupCount': '{online} of {total} online',
  'messenger.loadingContacts': 'Loading contacts…',
  'messenger.errorContacts': 'We could not load your contacts.',
  'messenger.noContacts': 'No connections found yet. Add relations to start a conversation.',
  'messenger.conversations': 'Conversations',
  'messenger.status.live': 'Live',
  'messenger.status.reconnecting': 'Reconnecting…',
  'messenger.status.connecting': 'Connecting…',
  'messenger.loadOlder': 'Load older messages',
  'messenger.encryption_initializing':
    'Encryption is still setting up. Message will be queued and retried.',
  'messenger.decryptionFailed': 'Message could not be decrypted.',
  'messenger.encryptedPlaceholder': '🔒 Encrypted message pending sync…',
  'messenger.mls.syncingEncryption': 'Syncing encryption… (retrying)',
  'messenger.mls.pendingSync': 'Syncing encrypted messages…',
  'messenger.mls.notEnabled': 'This chat is not MLS-enabled. Start a new encrypted conversation.',
  'messages.title': 'Messages',
  'messages.search': 'Search conversations',
  'messages.new.title': 'Start a conversation',
  'messages.new.recipient': 'Recipient ID',
  'messages.new.subject': 'Subject (optional)',
  'messages.new.start': 'Start',
  'messages.empty': 'No conversations yet',
  'messages.empty.hint': 'Start one from the form on the left.',
  'messages.list.unread': 'Unread',
  'messages.list.open': 'Open',
  'messages.thread.title': 'Conversation',
  'messages.thread.loading': 'Loading messages…',
  'messages.thread.error': 'Could not load messages.',
  'messages.thread.placeholder': 'Write a message…',
  'messages.thread.send': 'Send',
  'pagination.prev': 'Previous',
  'pagination.next': 'Next',
  'error.generic': 'Something went wrong.',
  'sparks.weeklyQuestion.title': "This week's question",
  'sparks.weeklyQuestion.body': "What helps you feel most connected to the people you've lost?",
  'sparks.weeklyQuestion.answerCta': 'Create a Spark',
  'sparks.create.title': 'Create a Spark',
  'sparks.create.hint': 'Be kind. Be true. Keep it warm.',
  'sparks.create.linkGrave': 'Link to a grave',
  'sparks.create.submit': 'Ignite',
  'sparks.composer.open': 'Create a Spark',
  'sparks.topics.title': 'Topics',
  'sparks.topics.empty': 'No topics yet.',
  'sparks.highlights.title': 'Highlights',
  'sparks.highlights.empty': 'No highlights yet.',
  'sparks.feed.empty': 'No sparks yet.',
  'sparks.filters.title': 'Filters',
  'sparks.filters.newest': 'Newest',
  'sparks.filters.mostActive': 'Most active',
  'sparks.filters.stars': 'Stars',
  'sparks.filters.open': 'Filters and topics',
  'sparks.quote.title': 'A thought for today',
  'sparks.quote.loading': "Finding today's thought…",
  'sparks.quote.empty': 'What if life is about making the world a little better for someone?',
  'sparks.suggestions.title': 'Suggestions',
  'sparks.suggestions.empty': 'No suggestions yet.',
  'sparks.rooms.title': 'Rooms for what we share',
  'sparks.rooms.body':
    'Meet people who relate to what matters to you. Share experiences, find support, and explore what you care about together.',
  'sparks.rooms.cta': 'Explore Rooms',
  spark_submit_error: 'Something went wrong while posting. Please try again.',
  media_uploaded: 'Upload complete',
  search_set_relation_title: 'Find the grave to set your relation',
  filter_graves: 'Filter graves',
  country: 'Country',
  municipality: 'Municipality',
  cemetery: 'Cemetery',
  search_placeholder: 'Search by name',
  set_relation: 'Choose your relation',
  go_to_grave: 'Go to grave',
  relation_confirmed: 'Relation confirmed',
  relation_waiting_for_approval: 'Relation waiting for approval',
  relation_modal_title: 'Set relation',
  relation_modal_desc: "Choose both sides of the relation. We'll save when both are selected.",
  their_relation_to_you: 'Their relation to you',
  your_relation_to_them: 'Your relation to them',
  optional_note: 'Optional note',
  relation_note_placeholder: 'Add a short note or memory (optional)',
  bond_saved_confirmation: 'The bond will be saved: {a} and {b}.',
  select_both_relations_hint: 'Select both relations to continue.',
  save_relation: 'Save relation',
  cancel: 'Cancel',
  results_count_one: 'Showing {count} result',
  results_count_other: 'Showing {count} results',
  search_grave_results_one: '{count} grave found',
  search_grave_results_other: '{count} results',
  spark_category_question_description: 'Invite others to wonder with you.',
  spark_category_story_description: 'Tell a moment as it happened.',
  spark_category_insight_description: 'Share a truth you’ve noticed.',
  spark_category_feeling_description: 'Name what’s alive in you right now.',
  spark_category_intention_description: 'Say what you wish to bring.',
  'designSystem.timePicker.label.hour': 'Hour',
  'designSystem.timePicker.label.minute': 'Minute',
  'designSystem.timePicker.label.period': 'Period',
  'designSystem.timePicker.placeholder.hour': 'Select hour',
  'designSystem.timePicker.placeholder.minute': 'Select minute',
  'designSystem.timePicker.placeholder.period': 'Select period',
  'designSystem.timePicker.clear': 'Clear time',
  'designSystem.timePicker.period.am': 'AM',
  'designSystem.timePicker.period.pm': 'PM',
  'designSystem.select.noResults': 'Not found',
  'designSystem.select.clear': 'Clear selection',
  'designSystem.select.searchPlaceholder': 'Type to search',
  aunt_in_law_parent: "Aunt In Law's Parent",
  aunt_in_law_sibling: "Aunt In Law's Sibling",
  aunt_in_law_sibling_daughter: "Aunt In Law's Sibling's Daughter",
  aunt_in_law_sibling_daughter_daughter: "Aunt In Law's Sibling's Daughter's Daughter",
  brother_in_law_parent: "Brother In Law's Parent",
  brother_in_law_sibling: "Brother In Law's Sibling",
  brother_in_law_sibling_son: "Brother In Law's Sibling's Son",
  brother_in_law_sibling_son_son: "Brother In Law's Sibling's Son's Son",
  brother_in_law_son: "Brother In Law's Son",
  father_in_law_parent: "Father In Law's Parent",
  father_in_law_sibling: "Father In Law's Sibling",
  father_in_law_sibling_parent: "Father In Law's Sibling's Parent",
  father_in_law_sibling_sibling: "Father In Law's Sibling's Sibling",
  father_in_law_sibling_sibling_son: "Father In Law's Sibling's Sibling's Son",
  father_in_law_sibling_son: "Father In Law's Sibling's Son",
  father_in_law_sibling_son_son: "Father In Law's Sibling's Son's Son",
  father_in_law_son: "Father In Law's Son",
  father_parent_sibling_sibling: "Father's Parent's Sibling's Sibling",
  father_sibling_sibling: "Father's Sibling's Sibling",
  father_sibling_sibling_son: "Father's Sibling's Sibling's Son",
  first_cousin_once_removed_in_law: 'First Cousin Once Removed In Law',
  grandfather_in_law: 'Grandfather In Law',
  grandmother_in_law: 'Grandmother In Law',
  mother_in_law_daughter: "Mother In Law's Daughter",
  mother_in_law_parent: "Mother In Law's Parent",
  mother_in_law_sibling: "Mother In Law's Sibling",
  mother_in_law_sibling_daughter: "Mother In Law's Sibling's Daughter",
  mother_in_law_sibling_daughter_daughter: "Mother In Law's Sibling's Daughter's Daughter",
  mother_in_law_sibling_parent: "Mother In Law's Sibling's Parent",
  mother_in_law_sibling_sibling: "Mother In Law's Sibling's Sibling",
  mother_in_law_sibling_sibling_daughter: "Mother In Law's Sibling's Sibling's Daughter",
  mother_parent_sibling_sibling: "Mother's Parent's Sibling's Sibling",
  mother_sibling_sibling: "Mother's Sibling's Sibling",
  parent_spouse: "Parent's Spouse",
  sister_in_law_daughter: "Sister In Law's Daughter",
  sister_in_law_parent: "Sister In Law's Parent",
  sister_in_law_sibling: "Sister In Law's Sibling",
  sister_in_law_sibling_daughter: "Sister In Law's Sibling's Daughter",
  sister_in_law_sibling_daughter_daughter: "Sister In Law's Sibling's Daughter's Daughter",
  spouse_daughter: "Spouse's Daughter",
  spouse_son: "Spouse's Son",
  uncle_in_law_parent: "Uncle In Law's Parent",
  uncle_in_law_sibling: "Uncle In Law's Sibling",
  uncle_in_law_sibling_son: "Uncle In Law's Sibling's Son",
  uncle_in_law_sibling_son_son: "Uncle In Law's Sibling's Son's Son",
  circle_description1:
    "The circles frame the image and give a quiet expression of a person's values, personality, and presence.",
  presence_description1: 'You choose the grave, and the candle is lit there.',
  presence_description2:
    'For many, candles are a simple way to show hope and sit with their thoughts.',
  new_home_page_store_description:
    'Nettgrav is <link>End of Time Care</link> in practice: care that does not end, but continues in the actions we take for one another.',
  'groups.sidebar.quick': 'Rooms you might like',
  'groups.sidebar.quick.sub': 'Rooms that are open and in use.',
  'groups.categories.sub': 'Browse by category to discover relevant rooms faster.',
  'groups.section.top': 'Explore rooms',
  'groups.section.top.sub': 'Open rooms you can enter now.',
  'groups.section.mine.sub': 'Groups you own or participate in.',
  'groups.section.suggested': 'Suggested for you',
  'groups.section.suggested.sub': 'Groups matching your current search and filters.',
  'groups.section.new': 'New groups',
  'groups.section.new.sub': 'Recently created communities you can join.',
  'groups.rules.placeholder': 'One rule per line',
  'groups.rules.empty': 'No custom guidelines added.',
  'groups.members.creator': 'Room holder',
  'groups.role.owner': 'Room holder',
  'groups.role.admin': 'Co-holder',
  'groups.role.member': 'Member',
  'groups.members.co_creators': 'Co-holders',
  'groups.members.send_message': 'Send message',
  'groups.members.message_soon': 'Direct messages from rooms are coming soon in End of Time chat.',
  'groups.members.make_creator': 'Make room holder',
  'groups.members.remove_from_group': 'Remove from room',
  'groups.members.turn_on_post_approval': 'Turn on post approval',
  'groups.members.turn_off_post_approval': 'Turn off post approval',
  'groups.members.change_to_member_only': 'Change to member only',
  'groups.members.leave_group': 'Leave room',
  'groups.members.cancel_at_period_end': 'Ends at the end of the period',
  'groups.members.period_end_info':
    'When renewal is stopped, the person keeps access until the end of the current period.',
  'groups.members.make_creator.success': 'Room holder updated.',
  'groups.members.action_error': 'Could not update member.',
  'groups.files.photos': 'Photos',
  'groups.files.videos': 'Videos',
  'groups.files.documents': 'Documents',
  'groups.files.upload_photo': 'Upload photo',
  'groups.files.upload_video': 'Upload video',
  'groups.files.upload_document': 'Upload document',
  'groups.files.upload_success': 'File uploaded.',
  'groups.files.upload_error': 'Could not upload file.',
  'groups.files.upload_too_large': 'The file is too large. Maximum size is {size}.',
  'groups.files.delete_error': 'Could not delete file.',
  'groups.files.delete_success': 'File deleted.',
  'groups.files.type_tabs': 'File types',
  'groups.files.open_photo': 'Open {name}',
  'groups.files.play_video': 'Play {name}',
  'groups.files.load_error.title': 'Could not load files',
  'groups.files.load_error.text': 'Try again in a moment.',
  'groups.files.retry': 'Try again',
  'groups.files.delete_confirm.title': 'Delete file?',
  'groups.files.delete_confirm.text': '{name} will be permanently removed from the room.',
  'groups.files.loading': 'Loading files...',
  'groups.files.photos.empty': 'No photos yet.',
  'groups.files.videos.empty': 'No videos yet.',
  'groups.files.documents.empty': 'No documents yet.',
  'groups.files.sort': 'Sort documents',
  'groups.files.sort.newest': 'Newest',
  'groups.files.sort.name': 'Name',
  'groups.files.view': 'View',
  'groups.files.download': 'Download',
  'groups.files.details': 'Details',
  'groups.files.delete': 'Delete',
  'groups.files.action.view': 'View coming soon.',
  'groups.files.action.download': 'Download will be available soon.',
  'groups.files.action.details': '{name} · {size} KB',
  'groups.subscribe.saved_methods': 'Saved payment methods',
  'groups.subscribe.saved_methods.loading': 'Loading saved methods...',
  'groups.subscribe.saved_methods.none': 'No saved payment methods found.',
  'groups.subscribe.saved_methods.use_other': 'Use another method',
  'groups.subscribe.saved_methods.default': 'Default',
  'groups.subscribe.next_step.saved':
    'Next: we will use your saved method and continue to secure confirmation.',
  'groups.subscribe.next_step.vipps':
    'Next: you will continue in Vipps to confirm your membership.',
  'groups.subscribe.next_step.card':
    'Next: you will continue in Stripe to confirm your membership.',
  'groups.banner.subscribe': 'Support room',
  'groups.banner.support_with_price': 'Support room - {price} NOK / month',
  'groups.banner.supported_badge': 'Supported room',
  'groups.banner.supported_subtitle': 'This room stays open because people choose to support it.',
  'groups.banner.support_access_note':
    'Support gives access to the full room. Can be ended at any time.',
  'groups.subscribe.title': 'You are stepping in as a supporter',
  'groups.subscribe.header': 'You are stepping in as a supporter',
  'groups.subscribe.cta': 'Join and support',
  'groups.subscribe.cta_supporter': 'Become a supporter',
  'groups.subscribe.support_intro': 'By supporting this room:',
  'groups.subscribe.support_point_1': 'you sit at the table',
  'groups.subscribe.support_point_2': 'you help carry the community',
  'groups.subscribe.support_point_3': 'you make it possible for the room to keep living',
  'groups.subscribe.amount_line': 'Amount: {price} per month',
  'groups.subscribe.cancel_anytime': 'Can be ended at any time.',
  'groups.subscribe.success': 'Support is active. You are now in the room.',
  'groups.framework.title': 'How rooms work',
  'groups.framework.subtitle': 'The Nettgrav frame applies to every room.',
  'groups.framework.principle_1.title': 'Dignity',
  'groups.framework.principle_1.body': 'We meet each other with respect. No ranking. No attacks.',
  'groups.framework.principle_2.title': 'Humanity',
  'groups.framework.principle_2.body': 'We write as people. Not as roles. Not as brands.',
  'groups.framework.principle_3.title': 'Silence',
  'groups.framework.principle_3.body': 'Silence is allowed. No expectation of response.',
  'groups.framework.principle_4.title': 'Responsibility',
  'groups.framework.principle_4.body':
    'The room holder keeps the room safe, but does not own it as power.',
  'groups.suggested_members': 'Suggestions for who you can invite',
  'groups.paid.why.body':
    'Rooms make it possible for people to use their experience and knowledge to support others and build sustainability in that work.',
  'groups.subscribe.saved_method.invalid':
    'Saved payment method is no longer valid. Choose another method and try again.',
  'admin.group_moderation.approve': 'Approve',
  'admin.group_moderation.category.paid': 'Approval of paid room',
  'admin.group_moderation.category.report': 'Reported room',
  'admin.group_moderation.empty': 'No moderation items.',
  'admin.group_moderation.filter.all': 'All',
  'admin.group_moderation.filter.paid': 'Paid approvals',
  'admin.group_moderation.filter.reports': 'Reports',
  'admin.group_moderation.filter.unread': 'Unread',
  'admin.group_moderation.mark_read': 'Mark as read',
  'admin.group_moderation.mark_unread': 'Mark unread',
  'admin.group_moderation.mark_resolved': 'Set as resolved',
  'admin.group_moderation.mark_pending': 'Set as pending',
  'admin.group_moderation.meta.group': 'Room: {name}',
  'admin.group_moderation.meta.reason': 'Reason: {reason}',
  'admin.group_moderation.meta.reporter': 'Reporter: {name}',
  'admin.group_moderation.note_placeholder': 'Optional note (required in case of rejection).',
  'admin.group_moderation.open_group': 'Open Room',
  'admin.group_moderation.refresh': 'Refresh',
  'admin.group_moderation.reject': 'Decline',
  'admin.group_moderation.reject_note_required': 'Add a rejection note before you reject.',
  'admin.group_moderation.resolution.at': 'Resolved: {time}',
  'admin.group_moderation.resolution.by': 'Resolved by: {name}',
  'admin.group_moderation.resolution.note': 'Note: {note}',
  'admin.group_moderation.resolution.placeholder': 'Resolution note (optional).',
  'admin.group_moderation.search': 'Search by Room, reason, or reporter',
  'admin.group_moderation.state.pending': 'Pending',
  'admin.group_moderation.state.resolved': 'Resolved',
  'admin.group_moderation.subtitle': 'Review Room reports and paid-Room approval requests.',
  'admin.group_moderation.summary.total': 'Total',
  'admin.group_moderation.summary.unread': 'unread',
  'admin.group_moderation.summary.visible': 'Visible',
  'admin.group_moderation.nav': 'Room moderation',
  'admin.group_moderation.title': 'Room moderation',
  'create_group.intro': 'Open a room with a clear direction.',
  'create_group.audience.label': 'Who is this room for?',
  'create_group.audience.placeholder': 'Who should feel at home here?',
  'create_group.audience.required': 'Please add who this room is for.',
  'create_group.safety_intent.label': 'How will you keep this room safe?',
  'create_group.safety_intent.placeholder': 'A few words about tone and care.',
  'create_group.safety_intent.hint':
    'For your own awareness when opening the room. Not shown publicly.',
  'create_group.life_category.grief': 'Grief',
  'create_group.life_category.life_choices': 'Life choices',
  'create_group.life_category.relationships': 'Relationships',
  'create_group.life_category.health': 'Health',
  'create_group.life_category.existence': 'Existence',
  'create_group.life_category.guidance': 'Guidance',
  'create_group.life_category.other': 'Other',
  'create_group.invite.info': 'Invite someone into the room',
  'create_group.invite.sent_count': '{count} invitations sent',
  'create_group.tip.name': 'Give the room a clear name',
  'create_group.tip.visibility': 'Who can see the room?',
  'create_group.visibility': 'Visibility',
  'create_group.visibility.public_desc': 'Everyone can read. Join to participate.',
  'create_group.visibility.closed_desc':
    'The room is visible, but you must be invited or approved to join.',
  'create_group.visibility.private_desc':
    'The room is hidden from others. Only invited members can see and participate.',
  'create_group.visibility.closed': 'Closed room',
  'create_group.visibility.private': 'Private room',
  'create_group.visibility.public': 'Open room',
  'groupDetails.confirm.remove.ok': 'Remove',
  'groupDetails.confirm.remove.title': 'Remove from room',
  'groupDetails.unavailable': 'Unavailable',
  'groups.about.empty': 'No description.',
  'groups.aria.invite_name': 'Invite {name}',
  'groups.comments.load_more': 'Show more',
  'groups.edit.name_required': 'Room name is required.',
  'groups.edit.no_changes': 'No changes',
  'groups.edit.save_error': 'Could not save room details.',
  'groups.edit.saved': 'Room details saved.',
  'groups.invite': 'Invite',
  'groups.join.request_sent': 'Request sent. Awaiting approval.',
  'groups.joined': 'You joined the room.',
  'groups.quiet.cta': 'Set room quiet',
  'groups.quiet.active': 'Room is quiet',
  'groups.quiet.confirm': 'Set this room to quiet for now?',
  'groups.quiet.enabled': 'The room is now quiet for now.',
  'groups.quiet.notice': 'This room is quiet for now.',
  'groups.members': 'Those who are with',
  'groups.members.empty': 'No members yet.',
  'groups.members.no_results': 'No members match your search.',
  'groups.members.actions': 'Member actions',
  'groups.members.owner_admin': 'Owner/admin',
  'groups.members.see_all': 'View all',
  'groups.mine.feed.empty': 'No conversations yet.',
  'groups.mine.feed.sub': 'Recent posts from rooms you are part of.',
  'groups.mine.feed.title': 'Recent activity',
  'groups.paid.approval.approve': 'Approve',
  'groups.paid.approval.approved': 'Paid room approved.',
  'groups.paid.approval.note_placeholder': 'Note (shown to room holder/admin).',
  'groups.paid.approval.reject': 'Decline',
  'groups.paid.approval.reject_note': 'First, add a rejection note.',
  'groups.paid.approval.rejected': 'Paid room declined.',
  'groups.paid.approval.request': 'Request a review',
  'groups.paid.approval.requested': 'Paid room rating has been sent.',
  'groups.paid.awaiting_approval': 'Awaiting Approval',
  'groups.paid.connect_cta': 'Connect to payments',
  'groups.paid.connect_hint': 'This room requires payment to join.',
  'groups.paid.connect_required': 'Connect to payments before activating paid Room.',
  'groups.paid.details.audience': 'Target audience',
  'groups.paid.details.audience.hint': 'Who is this room for?',
  'groups.paid.details.audience.placeholder':
    'For people who want structured support and weekly follow-up.',
  'groups.paid.details.benefits': 'Benefits',
  'groups.paid.details.benefits.hint': 'What do members get?',
  'groups.paid.details.benefits.placeholder':
    'Monthly live broadcasts, practical exercises, direct feedback...',
  'groups.paid.details.refund': 'Refund Policy',
  'groups.paid.details.refund.hint': 'Describe refund policies',
  'groups.paid.details.refund.placeholder':
    'End anytime. Access lasts for the duration of the paid period.',
  'groups.paid.details.title': 'Paid room details',
  'groups.paid.details_required':
    'Add membership benefits and who the room is for before creating a paid room.',
  'groups.paid.enabled_hint': 'Set a monthly price from {min} to {max} NOK.',
  'groups.paid.enabled_hint_currency': 'Set a monthly price from {min} to {max} {currency}.',
  'groups.paid.onboarding_note': 'Paid rooms become visible after approval.',
  'groups.paid.preview.net': 'Net to room holder',
  'groups.paid.preview.platform': 'Net grave share',
  'groups.paid.preview.price': 'Amount',
  'groups.paid.preview.stripe': 'Stripe fee',
  'groups.paid.preview.title': 'Rates Overview',
  'groups.paid.price_range': 'The price must be between {min} and {max} NOK.',
  'groups.paid.price_range_currency': 'The price must be between {min} and {max} {currency}.',
  'groups.paid.why.cta': 'Read more about paid rooms',
  'groups.paid.why.point_1': 'Set a monthly price that suits your target audience.',
  'groups.paid.why.point_2': 'Provide members with clear benefits and follow-up.',
  'groups.paid.why.point_3': 'Make secure payments with Vipps or card.',
  'groups.paid.why.title': 'Why paid rooms?',
  'groups.payout_mode': 'Payout mode',
  'groups.payout_mode.automatic': 'Automatic via Stripe',
  'groups.payout_mode.automatic.hint':
    'Requires Stripe Connect. Payouts go automatically to your account.',
  'groups.payout_mode.manual': 'Manual via Nettgrav',
  'groups.payout_mode.manual.hint':
    'No Stripe needed. Nettgrav collects payment and pays out monthly.',
  'groups.photos.recent': 'Recent photos',
  'groups.photos.see_all': 'View all',
  'groups.photos.add': 'Add photo',
  'groups.photos.loading': 'Loading photos...',
  'groups.photos.load_error': 'Could not load the photos.',
  'groups.photos.empty': 'No photos have been shared yet.',
  'groups.invite.search_label': 'Search for people',
  'groups.invite.search_hint': 'Enter at least two characters to search.',
  'groups.invite.searching': 'Searching...',
  'groups.invite.no_results': 'No people found.',
  'groups.post.upload_error': 'Could not upload media. Please try again.',
  'groups.posting': 'Posts',
  'groups.report.cta': 'Reporting',
  'groups.report.details': 'Details (optional)',
  'groups.report.details.placeholder': 'Add context that helps admin assess quickly.',
  'groups.report.reason': 'Causes',
  'groups.report.reason.abuse': 'Harassment or abuse',
  'groups.report.reason.illegal': 'Illegal content',
  'groups.report.reason.other': 'Other',
  'groups.report.reason.spam': 'Spam or scam',
  'groups.report.submit': 'Send Report',
  'groups.report.success': 'Thank you. Your report has been received.',
  'groups.report.title': 'Report room',
  'groups.post.report': 'Report post',
  'groups.post.report.title': 'Report post',
  'groups.requests.action_error': 'Could not update request.',
  'groups.requests.confirm': 'Approve',
  'groups.requests.decline': 'Decline',
  'groups.requests.member_empty': 'No membership requests.',
  'groups.requests.member_title': 'Member Requests ',
  'groups.requests.post_empty': 'No posts are waiting for approval.',
  'groups.requests.post_title': 'Post requests',
  'groups.requests.load_error.title': 'Could not load requests',
  'groups.requests.load_error.text': 'Try again in a moment.',
  'groups.requests.retry': 'Try again',
  'groups.requests.member.requested': 'Requested access {time}',
  'groups.requests.attachment': 'Open attachment',
  'groups.requests.member.approve_success': 'Membership request approved.',
  'groups.requests.member.decline_success': 'Membership request declined.',
  'groups.requests.post.approve_success': 'Post approved.',
  'groups.requests.post.decline_success': 'Post declined.',
  'groups.requests.member.decline_title': 'Decline membership request?',
  'groups.requests.post.decline_title': 'Decline post?',
  'groups.requests.member.decline_text': 'The request from {name} will be declined.',
  'groups.requests.post.decline_text': 'The post from {name} will not be published.',
  'groups.read_more': 'Read more',
  'groups.show_less': 'Show less',
  'groups.rules': 'Rules',
  'groups.settings.chat.admins': 'Admin only',
  'groups.settings.chat.members': 'Members and admin',
  'groups.settings.chat_permissions': 'Room chat privileges',
  'groups.settings.chat.readonly_note': 'Direct room chat permissions are fixed in this version.',
  'groups.settings.membership.admins': 'Only room holder and co-holders',
  'groups.settings.membership.anyone': 'Everyone in the room',
  'groups.settings.membership_approval': 'Membership approval',
  'groups.settings.membership.readonly_note':
    'Membership approval follows room visibility and invitation flow.',
  'groups.settings.post_approval': 'Post approval',
  'groups.settings.post_approval.none': 'No approval',
  'groups.settings.post_approval.require': 'All posts must be approved.',
  'groups.settings.posting.admins': 'Admin only',
  'groups.settings.posting.anyone': 'Everyone in the room',
  'groups.settings.posting_permissions': 'Rights for publication',
  'groups.settings.privacy': 'Personal Data Protection',
  'groups.settings.cover': 'Room image',
  'groups.settings.cover.empty': 'No room image yet.',
  'groups.settings.cover.upload': 'Upload room image',
  'groups.settings.cover.remove': 'Remove room image',
  'groups.settings.cover.instant_save': 'Room image changes are saved immediately.',
  'groups.settings.cover.upload_success': 'Room image updated.',
  'groups.settings.cover.upload_error': 'Could not upload room image.',
  'groups.settings.cover.remove_success': 'Room image removed.',
  'groups.settings.cover.remove_error': 'Could not remove room image.',
  'groups.settings.save_error': 'Could not save settings.',
  'groups.settings.saved': 'Settings Saved.',
  'groups.settings.room_status': 'Room status',
  'groups.settings.room_status.active': 'The room is active.',
  'groups.settings.unsaved.confirm': 'You have unsaved changes. Leave without saving?',
  'groups.settings.categories.loading': 'Loading categories...',
  'groups.settings.categories.empty': 'No categories are available.',
  'groups.settings.categories.error': 'Could not load the categories.',
  'groups.settings.categories.retry': 'Try again',
  'groups.settings.current_rules': 'How this room works',
  'groups.settings.current_rules.hint':
    'An overview of the rules that currently apply to the room.',
  'groups.settings.membership.public': 'Anyone can join',
  'groups.settings.membership.closed': 'Room managers approve requests',
  'groups.settings.membership.private': 'By invitation only',
  'groups.quiet.reactivate': 'Make room active',
  'groups.quiet.reactivate_confirm': 'Make this room active again?',
  'groups.quiet.disabled': 'The room is active again.',
  'groups.quiet.update_error': 'Could not update the room status.',
  'groups.subscribe.benefit_1': 'Exclusive content and follow-up',
  'groups.subscribe.benefit_2': 'Safe community with clear boundaries',
  'groups.subscribe.benefit_3': 'Direct support from managers and supervisors',
  'groups.subscribe.breakdown': 'Overview',
  'groups.subscribe.card': 'Card',
  'groups.subscribe.monthly': 'Monthly support',
  'create_group.paid_price_currency': 'Monthly price ({currency})',
  'create_group.support.toggle': 'Enable support for this room',
  'create_group.support.amount': 'Monthly support',
  'create_group.support.renewal_note': 'Support renews automatically and can be ended at any time.',
  'create_group.support.possible.label': 'What does support make possible in this room?',
  'create_group.support.possible.placeholder':
    'What opens up when someone chooses to support this room?',
  'create_group.support.possible.required': 'Briefly describe what support makes possible.',
  'create_group.support.for_whom.label': 'Who can this room be especially important for?',
  'create_group.support.for_whom.placeholder': 'Who can this room be especially important for?',
  'create_group.support.for_whom.required': 'Describe who this room may be important for.',
  'create_group.support.cancel.label': 'How does ending support work?',
  'create_group.support.cancel.placeholder':
    'Support can be ended at any time. Access lasts until the end of paid period.',
  'create_group.support.cancel.default':
    'Support can be ended at any time. Access lasts until the end of paid period.',
  'create_group.support.connect.info': 'To receive support, connect payouts.',
  'create_group.support.summary': 'Overview',
  'create_group.support.summary.amount': 'Support',
  'create_group.support.summary.platform': 'Nettgrav share',
  'create_group.support.summary.fee': 'Payment fee',
  'create_group.support.summary.you_get': 'You receive before payment fees',
  'create_group.rate_limit': 'You have created several rooms recently. Please try again later.',
  'create_group.category.load_error': 'Could not load directions. Please reload the page.',
  'groups.subscribe.pending': 'Payment is completing. Update in a moment.',
  'groups.subscribe.total': 'Total',
  'groups.subscribe.local_estimate': 'Approx. {amount} in your local currency.',
  'groups.subscribe.cancel.cta': 'End participation',
  'groups.subscribe.cancel.success': 'You are no longer in the room.',
  'groups.subscribe.vipps_info': 'You confirm the payment securely in Vipps.',
  'groups.subscribe.vipps_currency_note': 'Payment via Vipps is charged in NOK.',
  'groups.subscribe.vipps_unavailable_currency':
    'Vipps is not available for this room currency. Please use card.',
  'groups.time.2h': 'a moment ago',
  'messenger_v2.brand.title': 'End of Time',
  'messenger_v2.brand.beta': 'Beta',
  'messenger_v2.brand.tagline': 'A place for truth. Always.',
  'messenger_v2.conversation.title': 'Conversations',
  'messenger_v2.encryption.title': 'End-to-end encrypted',
  'messenger_v2.encryption.copy': 'Your words stay between you.',
  'messenger_v2.encryption.learn_more': 'Learn more',
  'messenger_v2.presence.active_now': 'Active now',
  'messenger_v2.composer.truth_placeholder': "What's true right now?",
  'messenger_v2.message.reaction_failed': 'Unable to update the reaction.',
  'messenger_v2.message.react_with': 'React with {emoji}',
  'messenger_v2.message.reaction_count': '{emoji}, {count} reactions',
  'messenger_v2.message.actions': 'Message actions',
  'messenger_v2.message.commands': 'Message commands',
  'messenger_v2.message.reactions': 'Reactions',
  'messenger_v2.message.reaction_all': 'All',
  'messenger_v2.message.reaction_details': 'Reaction details',
  'messenger_v2.message.reaction_filters': 'Reaction filters',
  'messenger_v2.message.reaction_people_unavailable':
    'Reaction details are unavailable for this message.',
  'messenger_v2.message.click_to_remove': 'Click to remove',
  'messenger_v2.message.history_loading': 'Loading earlier messages.',
  'messenger_v2.attachment.select': 'Select {name}',
  'messenger_v2.search.placeholder': 'Search or start a conversation',
  'messenger_v2.search.groups_placeholder': 'Search groups',
  'messenger_v2.tabs.aria': 'Messages sections',
  'messenger_v2.tabs.direct': 'Messages',
  'messenger_v2.tabs.groups': 'Groups',
  'messenger_v2.groups.add_action': 'Add',
  'messenger_v2.groups.add_members': 'Add members',
  'messenger_v2.groups.add_members_short': 'Add',
  'messenger_v2.groups.add_members_title': 'Add members',
  'messenger_v2.groups.add_description': 'Add group description',
  'messenger_v2.groups.contacts_loading': 'Contacts are loading.',
  'messenger_v2.groups.create': 'Create group',
  'messenger_v2.groups.create_action': 'Create',
  'messenger_v2.groups.create_category_required': 'Group category is not available yet.',
  'messenger_v2.groups.create_name_required': 'Group name is required.',
  'messenger_v2.groups.create_new_group': 'Create new group',
  'messenger_v2.groups.create_success': 'Group created.',
  'messenger_v2.groups.create_title': 'Create group',
  'messenger_v2.groups.description_label': 'Description',
  'messenger_v2.groups.description_placeholder': 'Optional',
  'messenger_v2.groups.details_updated': 'Group details updated.',
  'messenger_v2.groups.edit_description': 'Edit group description',
  'messenger_v2.groups.edit_group_picture': 'Edit group picture',
  'messenger_v2.groups.edit_name': 'Edit group name',
  'messenger_v2.groups.empty': 'No groups matched your search.',
  'messenger_v2.groups.error': 'Groups could not be loaded.',
  'messenger_v2.groups.fallback': 'Group',
  'messenger_v2.groups.choose_photo': 'Choose photo',
  'messenger_v2.groups.delete_photo': 'Delete photo',
  'messenger_v2.groups.deleting_photo': 'Deleting photo...',
  'messenger_v2.groups.uploading_photo': 'Uploading...',
  'messenger_v2.groups.avatar_crop_failed': 'Image could not be cropped.',
  'messenger_v2.groups.avatar_read_failed': 'Image could not be opened.',
  'messenger_v2.groups.avatar_owner_only': 'Only the group creator can update the group picture.',
  'messenger_v2.groups.avatar_updated': 'Group picture updated.',
  'messenger_v2.groups.avatar_update_failed': 'Group picture could not be updated.',
  'messenger_v2.groups.avatar_deleted': 'Group picture deleted.',
  'messenger_v2.groups.avatar_delete_failed': 'Group picture could not be deleted.',
  'messenger_v2.groups.loading': 'Groups are loading.',
  'messenger_v2.groups.members_added': 'Members added.',
  'messenger_v2.groups.members_count': '{count} members',
  'messenger_v2.groups.members_label': 'Members',
  'messenger_v2.groups.leave_group': 'Leave',
  'messenger_v2.groups.exit_group': 'Exit group',
  'messenger_v2.groups.exit_group_title': 'Exit group: "{name}"?',
  'messenger_v2.groups.exit_group_notice': 'Only admins are notified when you leave a group.',
  'messenger_v2.groups.exit_and_delete_for_me': 'Exit and delete for me',
  'messenger_v2.groups.delete_group': 'Delete group',
  'messenger_v2.groups.deleting_group': 'Deleting group...',
  'messenger_v2.groups.delete_group_title': 'Delete group "{name}"?',
  'messenger_v2.groups.delete_group_warning_body':
    'This group will be removed from your chat list and your local history will be cleared.',
  'messenger_v2.groups.group_deleted': 'Group deleted from your chat list.',
  'messenger_v2.groups.delete_group_failed': 'Group could not be deleted.',
  'messenger_v2.groups.exiting_group': 'Exiting group...',
  'messenger_v2.groups.left_group': 'You left the group.',
  'messenger_v2.groups.left_group_notice':
    'You left this group. You can view previous messages, but you cannot send new messages.',
  'messenger_v2.groups.member_removed': '{name} was removed from the group.',
  'messenger_v2.groups.member_remove_failed': 'Member could not be removed.',
  'messenger_v2.groups.remove_member': 'Remove',
  'messenger_v2.groups.removed_notice':
    '{actor} removed you from this group. You can view previous messages, but you cannot send new messages.',
  'messenger_v2.groups.access_removed_notice':
    'You are no longer a member of this group. You can view previous messages, but you cannot send new messages.',
  'messenger_v2.groups.removing_member': 'Removing...',
  'messenger_v2.groups.name_label': 'Name',
  'messenger_v2.groups.name_placeholder': 'Family updates',
  'messenger_v2.groups.update_failed': 'Group details could not be updated.',
  'messenger_v2.groups.no_contacts': 'No contacts available.',
  'messenger_v2.groups.no_contacts_to_add': 'No contacts available to add.',
  'messenger_v2.groups.no_messages': 'No messages yet',
  'messenger_v2.groups.save_failed': 'Group could not be saved.',
  'messenger_v2.groups.saving': 'Saving...',
  'messenger_v2.groups.select_member_required': 'Select at least one member.',
  'messenger_v2.groups.selected_count': '{count} selected',
  'messenger_v2.groups.selected_fraction': '{selected}/{total}',
  'messenger_v2.groups.search_name_or_number': 'Search name or number',
  'messenger_v2.groups.members_can_add': 'All members can add others to this group.',
  'messenger_v2.groups.edit_group_permissions': 'Edit group permissions.',
  'messenger_v2.groups.group_permissions': 'Group permissions',
  'messenger_v2.groups.invite_via_link': 'Invite via link',
  'messenger_v2.groups.invite_via_link_qr': 'Invite via link or QR code',
  'messenger_v2.groups.frequently_contacted': 'Frequently contacted',
  'messenger_v2.groups.scroll_more_contacts': 'Scroll to load more',
  'messenger_v2.groups.remove_selected_member': 'Remove {name}',
  'messenger_v2.groups.group_link': 'Group link',
  'messenger_v2.groups.group_chat_invite': 'Group chat invite',
  'messenger_v2.groups.open_invite_link': 'Open this link to join {name}.',
  'messenger_v2.groups.join_group': 'Join group',
  'messenger_v2.groups.view_group': 'View group',
  'messenger_v2.groups.invite_link_loading': 'Loading link...',
  'messenger_v2.groups.invite_link_checking': 'Checking link...',
  'messenger_v2.groups.invite_link_expired': 'Link expired',
  'messenger_v2.groups.invite_link_unavailable': 'Group unavailable',
  'messenger_v2.groups.invite_link_full': 'Group full',
  'messenger_v2.groups.invite_link_status_expired': 'This invite link has expired.',
  'messenger_v2.groups.invite_link_status_unavailable': 'This group invite is no longer available.',
  'messenger_v2.groups.invite_link_status_full': 'This group is full.',
  'messenger_v2.groups.invite_link_copied': 'Invite link copied.',
  'messenger_v2.groups.invite_link_copy_failed': 'Invite link could not be copied.',
  'messenger_v2.groups.invite_link_failed': 'Invite link could not be loaded.',
  'messenger_v2.groups.invite_share_text': 'Join {name}',
  'messenger_v2.groups.invite_share_text_with_link': 'Join {name}: {url}',
  'messenger_v2.groups.share_via_chat': 'Share via chat',
  'messenger_v2.groups.send_to': 'Send to',
  'messenger_v2.groups.send_action': 'Send',
  'messenger_v2.groups.select_chat_recipients': 'Select chats',
  'messenger_v2.groups.invite_link_sent': 'Invite link sent.',
  'messenger_v2.groups.invite_link_send_failed': 'Invite link could not be sent.',
  'messenger_v2.groups.share_link': 'Share link',
  'messenger_v2.groups.share_link_short': 'Share',
  'messenger_v2.groups.copy_link': 'Copy link',
  'messenger_v2.groups.qr_code': 'QR Code',
  'messenger_v2.groups.manage_permissions': 'Manage permissions',
  'messenger_v2.groups.invite_approval_not_required':
    'Admin approval is not needed to join. Members have access to this link here.',
  'messenger_v2.groups.permissions_members_can': 'Members can',
  'messenger_v2.groups.permission_edit_settings': 'Edit group settings',
  'messenger_v2.groups.permission_edit_settings_desc':
    'This includes the group name, icon, description and advanced chat privacy.',
  'messenger_v2.groups.permission_send_messages': 'Send new messages',
  'messenger_v2.groups.permission_add_members': 'Add other members',
  'messenger_v2.groups.permission_send_history': 'Send message history',
  'messenger_v2.groups.permission_send_history_desc':
    'Allow members to send past messages to new members.',
  'messenger_v2.groups.permission_invite_link': 'Invite via link',
  'messenger_v2.groups.permissions_turning_off_hint':
    'Turning off these settings means that only group admins can perform this action.',
  'messenger_v2.groups.permissions_admins_can': 'Admins can',
  'messenger_v2.groups.permission_approve_new_members': 'Approve new members',
  'messenger_v2.groups.permission_approve_new_members_desc':
    'When turned on, admins must approve anyone who wants to join this group.',
  'messenger_v2.groups.group_admins': 'Group admins',
  'messenger_v2.groups.edit_admins': 'Edit admins',
  'messenger_v2.groups.admin': 'Admin',
  'messenger_v2.groups.available_member': 'Available member',
  'messenger_v2.groups.make_group_admin': 'Make group admin',
  'messenger_v2.groups.dismiss_as_admin': 'Dismiss as admin',
  'messenger_v2.groups.remove_from_group': 'Remove from group',
  'messenger_v2.groups.no_members_to_manage': 'No members to manage.',
  'messenger_v2.groups.admins_updated': 'Group admins updated.',
  'messenger_v2.groups.admin_update_failed': 'Group admin role could not be updated.',
  'messenger_v2.groups.member_made_admin': '{name} is now a group admin.',
  'messenger_v2.groups.member_dismissed_admin': '{name} is no longer a group admin.',
  'messenger_v2.groups.permissions_updated': 'Group permissions updated.',
  'messenger_v2.groups.permissions_update_failed': 'Group permissions could not be updated.',
  'messenger_v2.groups.no_longer_member_status': 'No longer a member',
  'messenger_v2.info.member_options': 'Member options',
  'messenger_v2.common.search': 'Search',
  'messenger_v2.conversation.group_fallback': 'Group conversation',
  'messenger_v2.conversation.direct_fallback': 'Direct conversation',
  'messenger_v2.conversation.new_message': 'New message',
  'messenger_v2.conversation.no_content': 'No content',
  'messenger_v2.conversation.connection': 'Connection',
  'messenger_v2.conversation.connections': 'Connections',
  'messenger_v2.conversation.open': 'Open',
  'messenger_v2.conversation.open_failed': 'Conversation could not be opened.',
  'messenger_v2.conversation.opening': 'Opening...',
  'messenger_v2.conversation.contacts_loading': 'Contacts are loading.',
  'messenger_v2.conversation.no_contacts_matched': 'No contacts matched your search.',
  'messenger_v2.conversation.bootstrap_loading': 'Messenger is starting.',
  'messenger_v2.conversation.none_yet': 'No conversations yet. Start one from the contacts list.',
  'messenger_v2.conversation.select_title': 'Select a conversation',
  'messenger_v2.conversation.select_copy':
    'Open a thread from the left rail or start a new conversation with the plus button.',
  'messenger_v2.conversation.show_contacts': 'Show contacts',
  'messenger_v2.conversation.show_conversations': 'Show conversations',
  'messenger_v2.presence.offline': 'Offline',
  'messenger_v2.presence.online': 'Online',
  'messenger_v2.presence.ready': 'Ready',
  'messenger_v2.presence.not_ready_yet': 'Not ready yet',
  'messenger_v2.presence.group_online': '{onlineCount} of {totalCount} online',
  'messenger_v2.presence.last_seen_today_at': 'Last seen today at {time}',
  'messenger_v2.presence.last_seen_yesterday_at': 'Last seen yesterday at {time}',
  'messenger_v2.presence.last_seen_date_at': 'Last seen {date} at {time}',
  'messenger_v2.timeline.today': 'Today',
  'messenger_v2.timeline.yesterday': 'Yesterday',
  'messenger_v2.message.edited': 'Edited',
  'messenger_v2.message.edited_time': 'Edited {time}',
  'messenger_v2.message.read_more': 'Read more',
  'messenger_v2.message.show_less': 'Show less',
  'messenger_v2.message.upload_failed': 'Upload failed',
  'messenger_v2.message.preparing_upload': 'Preparing…',
  'messenger_v2.message.upload_progress': 'Uploading {progress}%',
  'messenger_v2.message.upload_paused_progress': 'Upload paused at {progress}%',
  'messenger_v2.message.retry_upload': 'Retry upload',
  'messenger_v2.message.retry_send': 'Retry message',
  'messenger_v2.message.retry_reaction': 'Retry reaction',
  'messenger_v2.message.retry_failed': 'The message could not be sent. Try again.',
  'messenger_v2.message.reaction_retry_failed': 'The reaction could not be sent. Try again.',
  'messenger_v2.message.pause_upload': 'Pause upload',
  'messenger_v2.message.pause': 'Pause',
  'messenger_v2.message.resume_upload': 'Resume upload',
  'messenger_v2.message.resume': 'Resume',
  'messenger_v2.attachment.upload_paused': 'Upload paused: {name}',
  'messenger_v2.message.failed': 'Failed',
  'messenger_v2.message.read': 'Read',
  'messenger_v2.message.delivered': 'Delivered',
  'messenger_v2.message.sent': 'Sent',
  'messenger_v2.message.delete': 'Delete message',
  'messenger_v2.message.delete_title': 'Delete message?',
  'messenger_v2.message.delete_from': 'Delete message from {name}?',
  'messenger_v2.message.delete_everyone': 'Delete for everyone',
  'messenger_v2.message.delete_me': 'Delete for me',
  'messenger_v2.message.copy': 'Copy message',
  'messenger_v2.attachment.copy': 'Copy attachment',
  'messenger_v2.clipboard.copied': 'Copied',
  'messenger_v2.clipboard.retry': 'Retry',
  'messenger_v2.message.edit': 'Edit message',
  'messenger_v2.message.clear_selection': 'Clear selection',
  'messenger_v2.message.open_menu': 'Open message menu',
  'messenger_v2.message.scroll_latest': 'Scroll to latest message',
  'messenger_v2.message.thread_loading': 'Thread history is loading.',
  'messenger_v2.conversation.unavailable_title': 'Conversation unavailable',
  'messenger_v2.conversation.unavailable_copy': 'You no longer have access to this conversation.',
  'messenger_v2.message.thread_empty': 'No messages have loaded in this thread yet.',
  'messenger_v2.message.thread': 'Conversation thread',
  'messenger_v2.message.timeline': 'Conversation messages',
  'messenger_v2.message.encrypted_pending': 'Encrypted MLS message pending runtime ready.',
  'messenger_v2.message.edit_resolve_error':
    'Unable to resolve the message being edited. Please reopen edit mode and try again.',
  'messenger_v2.message.reply': 'Reply',
  'messenger_v2.message.forward': 'Forward',
  'messenger_v2.message.forwarded': 'Forwarded',
  'messenger_v2.forward.title': 'Forward to',
  'messenger_v2.forward.preview_label': 'Forwarding',
  'messenger_v2.forward.message_preview': 'Message',
  'messenger_v2.forward.search': 'Search chats and connections',
  'messenger_v2.forward.add_message': 'Add a message',
  'messenger_v2.forward.add_message_placeholder': 'Add a message...',
  'messenger_v2.forward.selected': 'Selected',
  'messenger_v2.forward.not_selected': 'Not selected',
  'messenger_v2.forward.loading': 'Loading chats and connections...',
  'messenger_v2.forward.chats': 'Chats',
  'messenger_v2.forward.connections': 'Connections',
  'messenger_v2.forward.no_targets': 'No chats or connections found.',
  'messenger_v2.forward.loading_message': 'Loading message...',
  'messenger_v2.forward.message_unavailable': 'This message is unavailable.',
  'messenger_v2.forward.send_failed': 'The message could not be forwarded.',
  'messenger_v2.forward.unavailable': 'This message cannot be forwarded yet.',
  'messenger_v2.forward.sending_progress': 'Sending {completed} of {total}',
  'messenger_v2.forward.failed_count': '{count} failed',
  'messenger_v2.forward.selected_count': '{count} selected',
  'messenger_v2.forward.retry_failed': 'Retry failed',
  'messenger_v2.forward.sent_count': 'Forwarded to {count} chats.',
  'messenger_v2.message.react': 'React',
  'messenger_v2.message.cancel_reply': 'Cancel reply',
  'messenger_v2.message.open_replied_message': 'Open replied message',
  'messenger_v2.reply.photo': 'Photo',
  'messenger_v2.reply.photos_count': '{count} photos',
  'messenger_v2.reply.video': 'Video',
  'messenger_v2.reply.videos_count': '{count} videos',
  'messenger_v2.reply.audio': 'Audio',
  'messenger_v2.reply.media_count': '{count} media',
  'messenger_v2.reply.pages_count': '{count} pages',
  'messenger_v2.common.cancel': 'Cancel',
  'messenger_v2.common.back': 'Back',
  'messenger_v2.common.close': 'Close',
  'messenger_v2.common.done': 'Done',
  'messenger_v2.common.save': 'Save',
  'messenger_v2.common.someone': 'Someone',
  'messenger_v2.common.you': 'You',
  'messenger_v2.common.messenger': 'Messenger',
  'messenger_v2.chat.back': 'Back to conversations',
  'messenger_v2.chat.more': 'More',
  'messenger_v2.chat.more_actions': 'More actions',
  'messenger_v2.notifications.enabled': 'Desktop notifications enabled',
  'messenger_v2.notifications.enabled_message': 'Desktop notifications enabled.',
  'messenger_v2.notifications.reaction_body': 'Reacted {emoji} to your message.',
  'messenger_v2.conversation.reaction_preview': 'Reacted {emoji} to “{message}”',
  'messenger_v2.conversation.reaction_preview_unknown': 'Reacted {emoji} to a message',
  'messenger_v2.notifications.reaction_body_with_preview':
    'Reacted {emoji} to your message: “{message}”',
  'messenger_v2.notifications.blocked': 'Desktop notifications blocked',
  'messenger_v2.notifications.blocked_message':
    'Desktop notifications are blocked in browser settings.',
  'messenger_v2.notifications.unsupported':
    'Desktop notifications are not supported in this browser.',
  'messenger_v2.notifications.enable': 'Enable desktop notifications',
  'messenger_v2.typing.preview': 'Typing...',
  'messenger_v2.typing.preview_named': '{name} is typing...',
  'messenger_v2.typing.aria': '{name} is typing',
  'messenger_v2.info.open': 'Open conversation info',
  'messenger_v2.info.title': 'Conversation info',
  'messenger_v2.info.close': 'Close conversation info',
  'messenger_v2.info.contact': 'Contact',
  'messenger_v2.info.creator': 'Creator',
  'messenger_v2.info.direct_chat': 'Direct chat',
  'messenger_v2.info.message_action': 'Message',
  'messenger_v2.info.block': 'Block',
  'messenger_v2.info.block_failed': 'User could not be blocked.',
  'messenger_v2.info.block_user': 'Block {name}',
  'messenger_v2.info.block_user_confirm':
    'This user will not see your avatar or status, and new messages or calls from them will not reach you.',
  'messenger_v2.info.block_user_title': 'Block "{name}"?',
  'messenger_v2.info.blocking_user': 'Blocking...',
  'messenger_v2.info.chat_cleared': 'Chat cleared.',
  'messenger_v2.info.clear_all_messages': 'Clear all messages',
  'messenger_v2.info.clear_chat': 'Clear chat',
  'messenger_v2.info.clear_chat_confirm': 'Old messages will be removed only for you.',
  'messenger_v2.info.clear_chat_failed': 'Chat could not be cleared.',
  'messenger_v2.info.clear_chat_title': 'Clear chat?',
  'messenger_v2.info.clear_chat_warning_body':
    'This chat will be empty but will remain in your chat list.',
  'messenger_v2.info.clear_chat_warning_title': 'Clear all messages from "{name}"?',
  'messenger_v2.info.chat_deleted': 'Chat deleted.',
  'messenger_v2.info.delete_chat': 'Delete chat',
  'messenger_v2.info.delete_chat_failed': 'Chat could not be deleted.',
  'messenger_v2.info.delete_chat_warning_body':
    'This chat will be removed from your chat list. If you start this chat again, old messages will not be shown.',
  'messenger_v2.info.delete_chat_warning_title': 'Delete chat with "{name}"?',
  'messenger_v2.info.clearing_chat': 'Clearing chat...',
  'messenger_v2.info.info': 'Info',
  'messenger_v2.info.media': 'Media',
  'messenger_v2.info.links': 'Links',
  'messenger_v2.info.docs': 'Docs',
  'messenger_v2.info.media_links_docs': 'Media, links and docs',
  'messenger_v2.info.starred': 'Starred',
  'messenger_v2.info.encryption': 'Encryption',
  'messenger_v2.info.members': 'Members',
  'messenger_v2.info.groups_in_common': 'Groups in common',
  'messenger_v2.info.no_media': 'No media has been shared in this conversation yet.',
  'messenger_v2.info.no_links': 'No links have been shared in this conversation yet.',
  'messenger_v2.info.no_docs': 'No documents have been shared in this conversation yet.',
  'messenger_v2.info.no_common_groups': 'No groups in common yet.',
  'messenger_v2.info.unblock': 'Unblock',
  'messenger_v2.info.unblock_failed': 'User could not be unblocked.',
  'messenger_v2.info.unblock_user': 'Unblock {name}',
  'messenger_v2.info.unblock_user_confirm': 'This user will be able to reach you again.',
  'messenger_v2.info.unblock_user_title': 'Unblock "{name}"?',
  'messenger_v2.info.unblocking_user': 'Unblocking...',
  'messenger_v2.info.user_blocked': '{name} blocked.',
  'messenger_v2.info.user_unblocked': '{name} unblocked.',
  'messenger_v2.info.no_members': 'No members to show yet.',
  'messenger_v2.info.pending_invitations': 'Invited - waiting for response',
  'messenger_v2.info.invitation_pending': 'Invitation pending',
  'messenger_v2.info.document_fallback': 'Document',
  'messenger_v2.info.encryption_detail': 'Messages are protected in this conversation.',
  'messenger_v2.info.starred_empty': 'No starred messages yet.',
  'messenger_v2.info.member': 'Member',
  'messenger_v2.info.you_label': '{name} (You)',
  'messenger_v2.info.last_week': 'Last week',
  'messenger_v2.info.this_month': 'This month',
  'messenger_v2.info.date_unknown': 'Earlier',
  'messenger_v2.composer.add_note': 'Add a note',
  'messenger_v2.composer.add_more_attachments': 'Add more attachments',
  'messenger_v2.composer.open_attachments': 'Open attachments',
  'messenger_v2.composer.send': 'Send',
  'messenger_v2.composer.sending': 'Sending',
  'messenger_v2.composer.draft': 'Draft',
  'messenger_v2.voice.record': 'Record voice message',
  'messenger_v2.voice.recording': 'Recording voice message',
  'messenger_v2.voice.recording_preview': 'Recording voice...',
  'messenger_v2.voice.paused': 'Voice recording paused',
  'messenger_v2.voice.ready': 'Voice message ready',
  'messenger_v2.voice.sending': 'Sending voice message',
  'messenger_v2.voice.pause': 'Pause recording',
  'messenger_v2.voice.pause_short': 'Pause',
  'messenger_v2.voice.resume': 'Resume recording',
  'messenger_v2.voice.resume_short': 'Resume',
  'messenger_v2.voice.cancel': 'Delete voice recording',
  'messenger_v2.voice.send': 'Send voice message',
  'messenger_v2.voice.unsupported': 'Voice recording is not supported by this browser.',
  'messenger_v2.voice.permission_denied':
    'Microphone permission was denied. Allow microphone access and try again.',
  'messenger_v2.voice.microphone_unavailable': 'No available microphone was found.',
  'messenger_v2.voice.too_short': 'The voice message is too short. Please record again.',
  'messenger_v2.voice.send_failed': 'The voice message could not be queued. Tap send to try again.',
  'messenger_v2.voice.recording_failed': 'The voice message could not be recorded.',
  'messenger_v2.voice.retry_playback': 'Retry voice message',
  'messenger_v2.voice.pause_playback': 'Pause voice message',
  'messenger_v2.voice.play': 'Play voice message',
  'messenger_v2.voice.seek': 'Seek voice message',
  'messenger_v2.voice.uploading': 'Uploading {progress}%',
  'messenger_v2.voice.speed': 'Playback speed {rate}x',
  'messenger_v2.composer.send_attachments': 'Send attachments',
  'messenger_v2.composer.sending_attachments': 'Sending attachments',
  'messenger_v2.composer.file': 'File',
  'messenger_v2.composer.image_or_video': 'Image or video',
  'messenger_v2.composer.document': 'Document',
  'messenger_v2.composer.preview_unavailable':
    'Preview unavailable. You can still send the plain link.',
  'messenger_v2.link_preview.error': 'Link preview unavailable.',
  'messenger_v2.link_preview.remove': 'Remove link preview',
  'messenger_v2.attachment.image': 'Image',
  'messenger_v2.attachment.video': 'Video',
  'messenger_v2.attachment.audio': 'Audio',
  'messenger_v2.attachment.document': 'Document',
  'messenger_v2.attachment.file': 'File',
  'messenger_v2.attachment.file_upper': 'FILE',
  'messenger_v2.attachment.attachment': 'Attachment',
  'messenger_v2.attachment.fallback_name': 'Attachment {index}',
  'messenger_v2.attachment.attachments_selected': '{count} attachments selected',
  'messenger_v2.attachment.add_attachments': 'Add attachments',
  'messenger_v2.attachment.edit_image': 'Edit image',
  'messenger_v2.attachment.prepare_failed':
    'The edited attachment could not be prepared. Your changes are still here—please try again.',
  'messenger_v2.attachment.edit_render_failed':
    'The edited image could not be rendered. Your changes are still here—please try again.',
  'messenger_v2.attachment.encryption_failed':
    'The attachment could not be encrypted on this device. Please try again.',
  'messenger_v2.attachment.storage_warning':
    'Device storage is full. Keep the app open while the attachments upload.',
  'messenger_v2.attachment.upload_failed':
    'The secure attachment upload was interrupted. Check your connection and try again.',
  'messenger_v2.attachment.send_failed':
    'The attachments could not be queued. Your changes are still here—please try again.',
  'messenger_v2.attachment.preparing_progress': 'Preparing attachments ({completed}/{total})',
  'messenger_v2.image_editor.close': 'Back',
  'messenger_v2.image_editor.crop': 'Crop',
  'messenger_v2.image_editor.done': 'Done',
  'messenger_v2.image_editor.draw': 'Draw',
  'messenger_v2.image_editor.emoji': 'Emoji',
  'messenger_v2.image_editor.redo': 'Redo',
  'messenger_v2.image_editor.text': 'Text',
  'messenger_v2.image_editor.title': 'Edit image',
  'messenger_v2.image_editor.undo': 'Undo',
  'messenger_v2.attachment.drop_files_here': 'Drop files here',
  'messenger_v2.attachment.drop_files_hint': 'They will be added to your attachment draft.',
  'messenger_v2.attachment.no_attachments_selected_title': 'No attachments selected yet',
  'messenger_v2.attachment.no_attachments_selected_text':
    'Choose files from the attachment menu to start building the draft.',
  'messenger_v2.attachment.no_files_selected_title': 'No files selected yet',
  'messenger_v2.attachment.no_files_selected_text':
    'Choose images, videos, documents, or any file to build the message draft.',
  'messenger_v2.attachment.preview_unavailable': 'Preview unavailable',
  'messenger_v2.attachment.unable_open': 'Unable to open this attachment. Please try again.',
  'messenger_v2.attachment.unable_download':
    'Unable to download this attachment. Please try again.',
  'messenger_v2.attachment.no_selected': 'No attachment selected',
  'messenger_v2.attachment.play_video_preview': 'Play video preview',
  'messenger_v2.attachment.close_composer': 'Close attachment composer',
  'messenger_v2.attachment.close_preview': 'Close attachment preview',
  'messenger_v2.attachment.previous': 'Previous attachment',
  'messenger_v2.attachment.next': 'Next attachment',
  'messenger_v2.attachment.previous_selected': 'Show previous selected attachment',
  'messenger_v2.attachment.next_selected': 'Show next selected attachment',
  'messenger_v2.attachment.scroll_left': 'Scroll attachments left',
  'messenger_v2.attachment.scroll_right': 'Scroll attachments right',
  'messenger_v2.attachment.scroll_selected_left': 'Scroll selected attachments left',
  'messenger_v2.attachment.scroll_selected_right': 'Scroll selected attachments right',
  'messenger_v2.attachment.remove': 'Remove {name}',
  'messenger_v2.attachment.open': 'Open {name}',
  'messenger_v2.attachment.view': 'View {name}',
  'messenger_v2.attachment.download': 'Download {name}',
  'messenger_v2.attachment.download_action': 'Download',
  'messenger_v2.attachment.zoom_in': 'Zoom in image',
  'messenger_v2.attachment.reset_zoom': 'Reset image zoom',
  'messenger_v2.attachment.uploading': 'Uploading {name}',
  'messenger_v2.call.audio': 'Audio',
  'messenger_v2.call.remote_audio': 'Remote call audio',
  'messenger_v2.call.video': 'Video',
  'messenger_v2.call.start_voice': 'Start voice call',
  'messenger_v2.call.start_video': 'Start video call',
  'messenger_v2.call.direct_only': 'Calls are available in direct encrypted chats.',
  'messenger_v2.call.group_needs_members': 'Add another member to start a group call.',
  'messenger_v2.call.unavailable': 'Calls are unavailable for this chat.',
  'messenger_v2.call.blocked_unavailable': 'Calls are unavailable for this chat.',
  'messenger_v2.call.start_failed': 'Unable to start voice call.',
  'messenger_v2.call.start_video_failed': 'Unable to start video call.',
  'messenger_v2.call.recipient_device_unavailable':
    'The recipient must open Nettgrav Chat on their device before you can call securely.',
  'messenger_v2.call.accept_failed': 'Unable to accept voice call.',
  'messenger_v2.call.incoming': 'Incoming voice call',
  'messenger_v2.call.incoming_video': 'Incoming video call',
  'messenger_v2.call.calling': 'Calling...',
  'messenger_v2.call.ringing': 'Ringing...',
  'messenger_v2.call.connecting': 'Connecting...',
  'messenger_v2.call.reconnecting': 'Reconnecting...',
  'messenger_v2.call.active': 'Voice call',
  'messenger_v2.call.active_video': 'Video call',
  'messenger_v2.call.accept': 'Accept call',
  'messenger_v2.call.decline': 'Decline call',
  'messenger_v2.call.open': 'Open',
  'messenger_v2.call.join': 'Join',
  'messenger_v2.call.ignore': 'Ignore',
  'messenger_v2.call.minimize': 'Minimize call',
  'messenger_v2.call.encrypted': 'End-to-end encrypted',
  'messenger_v2.call.open_chat': 'Open chat',
  'messenger_v2.call.change_audio_output': 'Change audio output',
  'messenger_v2.call.mute': 'Mute',
  'messenger_v2.call.unmute': 'Unmute',
  'messenger_v2.call.camera_on': 'Turn camera on',
  'messenger_v2.call.camera_off': 'Turn camera off',
  'messenger_v2.call.background_blur_on': 'Blur background',
  'messenger_v2.call.background_blur_off': 'Turn background blur off',
  'messenger_v2.call.background_blur_failed': 'Unable to change background blur.',
  'messenger_v2.call.enter_fullscreen': 'Enter fullscreen',
  'messenger_v2.call.exit_fullscreen': 'Exit fullscreen',
  'messenger_v2.call.end': 'End call',
  'messenger_v2.call.participant': 'Participant',
  'messenger_v2.call.you_label': '{name} (You)',
  'messenger_v2.call.pin_participant': 'Pin {name}',
  'messenger_v2.call.unpin_participant': 'Unpin {name}',
  'messenger_v2.call.screen_sharing': 'Screen sharing',
  'messenger_v2.call.peer_muted': '{name} muted this call',
  'messenger_v2.call.you_muted': 'You muted this call',
  'messenger_v2.call.history_call': 'Voice call',
  'messenger_v2.call.history_video_call': 'Video call',
  'messenger_v2.call.history_group_call': 'Group call',
  'messenger_v2.call.history_group_video_call': 'Group video call',
  'messenger_v2.call.history_participants': '{count} members',
  'messenger_v2.call.members_title': 'Call members',
  'messenger_v2.call.history_missed': 'Missed voice call',
  'messenger_v2.call.history_video_missed': 'Missed video call',
  'messenger_v2.call.history_declined': 'Voice call declined',
  'messenger_v2.call.history_video_declined': 'Video call declined',
  'messenger_v2.call.history_cancelled': 'Voice call cancelled',
  'messenger_v2.call.history_video_cancelled': 'Video call cancelled',
  'messenger_v2.call.history_failed': 'Voice call failed',
  'messenger_v2.call.history_video_failed': 'Video call failed',
  'messenger_v2.call.duration_seconds': '{seconds} sec',
  'messenger_v2.call.duration_minutes': '{minutes} min',
  'messenger_v2.call.duration_minutes_seconds': '{minutes} min {seconds} sec',
  'messenger_v2.call.duration_hours': '{hours} hr',
  'messenger_v2.call.duration_hours_minutes': '{hours} hr {minutes} min',
  'messenger_v2.discard.title': 'Discard Changes?',
  'messenger_v2.discard.content': 'Are you sure you want to discard your changes?',
  'messenger_v2.discard.confirm': 'Discard',
  'messenger_v2.discard.cancel': 'Continue editing',
  'emojiPicker.emojiPicker': 'Emoji picker',
  'emojiPicker.reactionPicker': 'Reaction picker',
  'emojiPicker.searchEmoji': 'Search emoji',
  'emojiPicker.searchReactions': 'Search reactions',
  'emojiPicker.findEmoji': 'Find the perfect emoji',
  'emojiPicker.findReaction': 'Find the perfect reaction',
  'emojiPicker.categories': 'Emoji categories',
  'emojiPicker.category.frequent': 'Frequently used',
  'emojiPicker.category.smileys': 'Smileys & emotion',
  'emojiPicker.category.people': 'People & body',
  'emojiPicker.category.animals': 'Animals & nature',
  'emojiPicker.category.food': 'Food & drink',
  'emojiPicker.category.travel': 'Travel & places',
  'emojiPicker.category.activities': 'Activities',
  'emojiPicker.category.objects': 'Objects',
  'emojiPicker.category.symbols': 'Symbols',
  'emojiPicker.category.flags': 'Flags',
  'emojiPicker.searchResults': 'Search results',
  'emojiPicker.noResults': 'No emoji match your search.',
  'emojiPicker.noFrequentlyUsed': 'Your frequently used emoji will appear here.',
  'emojiPicker.skinTone': 'Skin tone',
  'emojiPicker.skinTone.default': 'Default skin tone',
  'emojiPicker.skinTone.light': 'Light skin tone',
  'emojiPicker.skinTone.mediumLight': 'Medium-light skin tone',
  'emojiPicker.skinTone.medium': 'Medium skin tone',
  'emojiPicker.skinTone.mediumDark': 'Medium-dark skin tone',
  'emojiPicker.skinTone.dark': 'Dark skin tone',
  'messenger_v2.composer.choose_emoji': 'Choose emoji',
  'messenger_v2.message.add_reaction': 'Add reaction',
  'pwa.onboarding.install_title': 'Install Nettgrav',
  'pwa.onboarding.install_body':
    'Keep Nettgrav one tap away and receive a more reliable app experience on this device.',
  'pwa.onboarding.install_action': 'Install Nettgrav',
  'pwa.onboarding.install_manual_action': 'I understand',
  'pwa.onboarding.not_now': 'Not now',
  'pwa.onboarding.benefit_messages': 'Background message notifications',
  'pwa.onboarding.benefit_calls': 'Incoming call alerts',
  'pwa.onboarding.benefit_badge': 'Unread count on the app icon',
  'pwa.onboarding.ios_steps':
    'Tap Share in your browser, choose Add to Home Screen, then open Nettgrav from its new icon.',
  'pwa.onboarding.mac_steps':
    'In Safari, choose File → Add to Dock, then open Nettgrav from the Dock or Applications.',
  'pwa.onboarding.notifications_title': 'Never miss a message or call',
  'pwa.onboarding.notifications_body':
    'Allow Nettgrav to notify you about new encrypted messages and incoming calls, even when the app is closed.',
  'pwa.onboarding.notifications_action': 'Allow notifications',
  'pwa.onboarding.notifications_denied':
    'Notifications are currently blocked. Enable them for Nettgrav in your browser or device notification settings, then try again.',
  'rooms.invite.auth_required': 'Login or create an account to view this room invitation.',
  'rooms.invite.back': 'Back to rooms',
  'rooms.invite.fail': 'Invite is invalid or expired.',
  'rooms.invite.join': 'Join room',
  'rooms.invite.label': 'Room invitation',
  'rooms.invite.loading': 'Loading invitation...',
  'rooms.invite.member_count': '{count, plural, one {# member} other {# members}}',
  'rooms.invite.title': 'Room invite',
  'rooms.invite.view': 'View room',
  'rooms.navigation.label': 'Room sections',
  'rooms.state.archived': 'This room has been archived.',
  'rooms.state.error': 'The room could not be loaded.',
  'rooms.state.loading': 'Loading room…',
  'rooms.state.removed': 'This room has been removed.',
  'rooms.state.retry': 'Try again',
  'rooms.tabs.members_chat': 'Members Chat',
  'rooms.members_chat.title': 'Encrypted Members Chat',
  'rooms.members_chat.description':
    'A private, end-to-end encrypted conversation for active Room members.',
  'rooms.members_chat.loading': 'Preparing Room chat…',
  'rooms.members_chat.locked_title': 'Members-only conversation',
  'rooms.members_chat.locked':
    'Join this Room to open its encrypted Members Chat. Messages and previews stay hidden until your membership is active.',
  'rooms.members_chat.error': 'Members Chat could not be loaded.',
  'rooms.state.unavailable': "Room not found or you don't have access.",
  'rooms.provisioning.action_required': 'Room chat needs attention before it can be used.',
  'rooms.provisioning.pending': 'Room chat is being prepared.',
  'groups.reactions.error': 'Could not update your reaction.',
  'groups.media.uploading': 'Uploading media…',
  'groups.post.published': 'Posted.',
  retry: 'Try again',
};

export default ENG;
